// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (modules, entry, mainEntry, parcelRequireName, globalName) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        this
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      return res === false ? {} : newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });

      // <script>
    } else if (globalName) {
      this[globalName] = mainExports;
    }
  }
})({"jJFYt":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
"use strict";
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.BlurredModal = BlurredModal;
exports.ErrorBoundary = void 0;
exports.HorusLink = HorusLink;
exports.HorusPopover = void 0;
exports.MovingChevron = MovingChevron;
exports.debounce = debounce;
exports.getFile = getFile;
exports.saveFile = saveFile;
exports.updateFile = updateFile;
var _react = require("4562a3cb6760606a");
var _react2 = require("b19e24b8394d791c");
var _Chevron = _interopRequireDefault(require("93fbb7d9e5e5c03d"));
var _utils = require("182011f52367751f");
var _reactDom = require("430ce9410a891535");
var _reactRouterDom = require("105a5373b6b19e34");
function _interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
function _regeneratorRuntime() {
    "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ 
    _regeneratorRuntime = function _regeneratorRuntime() {
        return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t, e, r) {
        t[e] = r.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define(t, e, r) {
        return Object.defineProperty(t, e, {
            value: r,
            enumerable: !0,
            configurable: !0,
            writable: !0
        }), t[e];
    }
    try {
        define({}, "");
    } catch (t) {
        define = function define(t, e, r) {
            return t[e] = r;
        };
    }
    function wrap(t, e, r, n) {
        var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []);
        return o(a, "_invoke", {
            value: makeInvokeMethod(t, r, c)
        }), a;
    }
    function tryCatch(t, e, r) {
        try {
            return {
                type: "normal",
                arg: t.call(e, r)
            };
        } catch (t) {
            return {
                type: "throw",
                arg: t
            };
        }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    var p = {};
    define(p, a, function() {
        return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(e) {
            define(t, e, function(t) {
                return this._invoke(e, t);
            });
        });
    }
    function AsyncIterator(t, e) {
        function invoke(r, o, i, a) {
            var c = tryCatch(t[r], t, o);
            if ("throw" !== c.type) {
                var u = c.arg, h = u.value;
                return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function(t) {
                    invoke("next", t, i, a);
                }, function(t) {
                    invoke("throw", t, i, a);
                }) : e.resolve(h).then(function(t) {
                    u.value = t, i(u);
                }, function(t) {
                    return invoke("throw", t, i, a);
                });
            }
            a(c.arg);
        }
        var r;
        o(this, "_invoke", {
            value: function value(t, n) {
                function callInvokeWithMethodAndArg() {
                    return new e(function(e, r) {
                        invoke(t, n, e, r);
                    });
                }
                return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
            }
        });
    }
    function makeInvokeMethod(e, r, n) {
        var o = h;
        return function(i, a) {
            if (o === f) throw Error("Generator is already running");
            if (o === s) {
                if ("throw" === i) throw a;
                return {
                    value: t,
                    done: !0
                };
            }
            for(n.method = i, n.arg = a;;){
                var c = n.delegate;
                if (c) {
                    var u = maybeInvokeDelegate(c, n);
                    if (u) {
                        if (u === y) continue;
                        return u;
                    }
                }
                if ("next" === n.method) n.sent = n._sent = n.arg;
                else if ("throw" === n.method) {
                    if (o === h) throw o = s, n.arg;
                    n.dispatchException(n.arg);
                } else "return" === n.method && n.abrupt("return", n.arg);
                o = f;
                var p = tryCatch(e, r, n);
                if ("normal" === p.type) {
                    if (o = n.done ? s : l, p.arg === y) continue;
                    return {
                        value: p.arg,
                        done: n.done
                    };
                }
                "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
            }
        };
    }
    function maybeInvokeDelegate(e, r) {
        var n = r.method, o = e.iterator[n];
        if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
        var i = tryCatch(o, e.iterator, r.arg);
        if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
        var a = i.arg;
        return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
    }
    function pushTryEntry(t) {
        var e = {
            tryLoc: t[0]
        };
        1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
    }
    function resetTryEntry(t) {
        var e = t.completion || {};
        e.type = "normal", delete e.arg, t.completion = e;
    }
    function Context(t) {
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ], t.forEach(pushTryEntry, this), this.reset(!0);
    }
    function values(e) {
        if (e || "" === e) {
            var r = e[a];
            if (r) return r.call(e);
            if ("function" == typeof e.next) return e;
            if (!isNaN(e.length)) {
                var o = -1, i = function next() {
                    for(; ++o < e.length;)if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
                    return next.value = t, next.done = !0, next;
                };
                return i.next = i;
            }
        }
        throw new TypeError(_typeof(e) + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: !0
    }), o(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: !0
    }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t) {
        var e = "function" == typeof t && t.constructor;
        return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
    }, e.mark = function(t) {
        return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
    }, e.awrap = function(t) {
        return {
            __await: t
        };
    }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function() {
        return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t, r, n, o, i) {
        void 0 === i && (i = Promise);
        var a = new AsyncIterator(wrap(t, r, n, o), i);
        return e.isGeneratorFunction(r) ? a : a.next().then(function(t) {
            return t.done ? t.value : a.next();
        });
    }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function() {
        return this;
    }), define(g, "toString", function() {
        return "[object Generator]";
    }), e.keys = function(t) {
        var e = Object(t), r = [];
        for(var n in e)r.push(n);
        return r.reverse(), function next() {
            for(; r.length;){
                var _$t = r.pop();
                if (_$t in e) return next.value = _$t, next.done = !1, next;
            }
            return next.done = !0, next;
        };
    }, e.values = values, Context.prototype = {
        constructor: Context,
        reset: function reset(e) {
            if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for(var r in this)"t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
        },
        stop: function stop() {
            this.done = !0;
            var t = this.tryEntries[0].completion;
            if ("throw" === t.type) throw t.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(e) {
            if (this.done) throw e;
            var r = this;
            function handle(n, o) {
                return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
            }
            for(var o = this.tryEntries.length - 1; o >= 0; --o){
                var i = this.tryEntries[o], a = i.completion;
                if ("root" === i.tryLoc) return handle("end");
                if (i.tryLoc <= this.prev) {
                    var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc");
                    if (c && u) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    } else if (c) {
                        if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
                    } else {
                        if (!u) throw Error("try statement without catch or finally");
                        if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
                    }
                }
            }
        },
        abrupt: function abrupt(t, e) {
            for(var r = this.tryEntries.length - 1; r >= 0; --r){
                var o = this.tryEntries[r];
                if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
                    var i = o;
                    break;
                }
            }
            i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
            var a = i ? i.completion : {};
            return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
        },
        complete: function complete(t, e) {
            if ("throw" === t.type) throw t.arg;
            return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
        },
        finish: function finish(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
            }
        },
        catch: function _catch(t) {
            for(var e = this.tryEntries.length - 1; e >= 0; --e){
                var r = this.tryEntries[e];
                if (r.tryLoc === t) {
                    var n = r.completion;
                    if ("throw" === n.type) {
                        var o = n.arg;
                        resetTryEntry(r);
                    }
                    return o;
                }
            }
            throw Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(e, r, n) {
            return this.delegate = {
                iterator: values(e),
                resultName: r,
                nextLoc: n
            }, "next" === this.method && (this.arg = t), y;
        }
    }, e;
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
    try {
        var i = n[a](c), u = i.value;
    } catch (n) {
        return void e(n);
    }
    i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
    return function() {
        var t = this, e = arguments;
        return new Promise(function(r, o) {
            var a = n.apply(t, e);
            function _next(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
            }
            function _throw(n) {
                asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
            }
            _next(void 0);
        });
    };
}
function _classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
    }
}
function _createClass(e, r, t) {
    return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
    return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
    if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
    if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
    return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
    if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return e;
}
function _isNativeReflectConstruct() {
    try {
        var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (t) {}
    return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
        return !!t;
    })();
}
function _getPrototypeOf(t) {
    return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(t) {
        return t.__proto__ || Object.getPrototypeOf(t);
    }, _getPrototypeOf(t);
}
function _inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
    return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, _setPrototypeOf(t, e);
}
function _slicedToArray(r, e) {
    return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return _arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
    }
}
function _arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function _iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function _arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
var HorusPopover = exports.HorusPopover = function HorusPopover(props) {
    var trigger = props.trigger, children = props.children, disableHover = props.disableHover;
    var _useState = (0, _react.useState)(false), _useState2 = _slicedToArray(_useState, 2), isOpen = _useState2[0], setIsOpen = _useState2[1];
    var handleOpen = function handleOpen() {
        setIsOpen(true);
        if (props !== null && props !== void 0 && props.onOpen) props === null || props === void 0 || props.onOpen();
    };
    var handleClose = function handleClose() {
        setIsOpen(false);
        if (props !== null && props !== void 0 && props.onClose) props === null || props === void 0 || props.onClose();
    };
    var handleClickTrigger = function handleClickTrigger() {
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)(_react2.Popover, {
        className: props.overrideClassName ? props.overrideClassName : "relative",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react2.Popover.Group, {
                onMouseOver: disableHover ? function() {} : handleOpen,
                onMouseLeave: disableHover ? function() {} : handleClose,
                style: props.cancelStyle ? undefined : {
                    margin: "0",
                    padding: "0",
                    height: "1.25rem"
                },
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: props.triggerClassName,
                    onClick: handleClickTrigger,
                    children: trigger
                })
            }),
            isOpen && /*#__PURE__*/ (0, _jsxRuntime.jsx)(_react2.Popover.Panel, {
                className: "absolute zoom-out-animation",
                style: {
                    zIndex: Number.MAX_SAFE_INTEGER
                },
                static: true,
                children: children
            })
        ]
    });
};
function debounce(func) {
    var _this = this;
    var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 300;
    var timer;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        clearTimeout(timer);
        timer = setTimeout(function() {
            // @ts-ignore
            func.apply(_this, args);
        }, timeout);
    };
}
function BlurredModal(props) {
    var _props$zIndex, _props$maxContentSize, _props$maxContentSize2, _props$maxContentSize3, _props$maxContentSize4;
    if (!props.show) return null;
    var modalView = /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        style: {
            zIndex: (_props$zIndex = props.zIndex) !== null && _props$zIndex !== void 0 ? _props$zIndex : 1000
        },
        className: "blurred-modal-container flex justify-center ".concat(!props.noCentered && "items-center"),
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                style: {
                    margin: props.noCentered ? "2rem" : props.noMargin ? 0 : undefined,
                    padding: props.noMargin ? 0 : undefined,
                    borderRadius: props.noMargin ? "15px" : undefined,
                    overflow: "auto",
                    // overflow: props.noMargin ? "hidden" : undefined,
                    height: (_props$maxContentSize = props.maxContentSize) === null || _props$maxContentSize === void 0 ? void 0 : _props$maxContentSize.height,
                    width: (_props$maxContentSize2 = props.maxContentSize) === null || _props$maxContentSize2 === void 0 ? void 0 : _props$maxContentSize2.width
                },
                className: "z-30 absolute blurred-modal-content zoom-in-animation ".concat(!((_props$maxContentSize3 = props.maxContentSize) !== null && _props$maxContentSize3 !== void 0 && _props$maxContentSize3.width) && "max-w-[60%]", "  ").concat(!((_props$maxContentSize4 = props.maxContentSize) !== null && _props$maxContentSize4 !== void 0 && _props$maxContentSize4.height) && "max-h-[85%]"),
                children: props.children
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                id: "horus-modal-backdrop",
                className: "backdrop-blur h-full w-full absolute z-20 blur-in-animation",
                onClick: props.onHide
            })
        ]
    });
    if (props.overRoot) return (0, _reactDom.createPortal)(modalView, document.body.firstElementChild);
    return modalView;
}
var ErrorBoundary = exports.ErrorBoundary = /*#__PURE__*/ function(_Component) {
    function ErrorBoundary(props) {
        var _this2;
        _classCallCheck(this, ErrorBoundary);
        _this2 = _callSuper(this, ErrorBoundary, [
            props
        ]);
        _this2.state = {
            hasError: false
        };
        _this2.props = props;
        return _this2;
    }
    _inherits(ErrorBoundary, _Component);
    return _createClass(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, info) {
                console.error("Error: ", error);
                console.info("Info: ", info);
            }
        },
        {
            key: "render",
            value: function render() {
                if (this.state.hasError) // You can render any custom fallback UI
                return this.props.fallback;
                return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(_) {
                // Update state so the next render will show the fallback UI.
                return {
                    hasError: true
                };
            }
        }
    ]);
}(_react.Component);
function MovingChevron(_ref) {
    var down = _ref.down, className = _ref.className;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "".concat(className, " cursor-pointer transition-all transform ").concat(down ? null : "rotate-180"),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Chevron.default, {
            direction: "up"
        })
    });
}
function updateFile(file, path) {
    // Updates the file on the selected path
    var formData = new FormData();
    formData.append("file", file, file.name);
    formData.append("path", path);
    var headers = {
        Accept: "application/json"
    };
    (0, _utils.horusPost)("/api/updatefile", headers, formData).then(function(res) {
        return res.json();
    }).then(function(data) {
        if (!data.ok) alert(data.msg);
    }).catch(function(error) {
        alert("There was an error saving the file: " + error);
    });
}
function saveFile(file) {
    // If we ar eon desktop mode, use the /savecontents endpoint,
    // otherwise, create a download link
    if (window.horusInternal.isDesktop) {
        // Post the file to the /savecontents endpoint
        var form = new FormData();
        form.append("file", file, file.name);
        var headers = {
            Accept: "application/json"
        };
        (0, _utils.horusPost)("/api/savecontents", headers, form).then(function(res) {
            return res.json();
        }).then(function(data) {
            if (!data.ok) alert(data.msg);
        }).catch(function(error) {
            alert("There was an error saving the file: " + error);
        });
    } else {
        // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
        var blobUrl = URL.createObjectURL(file);
        // Create a link element
        var link = document.createElement("a");
        // Set link's href to point to the Blob URL
        link.href = blobUrl;
        link.download = file.name;
        // Append link to the body
        document.body.appendChild(link);
        // Dispatch click event on the link
        // This is necessary as link.click() does not work on the latest firefox
        link.dispatchEvent(new MouseEvent("click", {
            bubbles: true,
            cancelable: true,
            view: window
        }));
        // Remove link from body
        document.body.removeChild(link);
    }
}
// Will download the file (if its available for the user)
// and return the Blob
function getFile(path) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, onlyFiles = _ref2.onlyFiles, onlyText = _ref2.onlyText;
    var url = new URL(window.location.origin + window.__HORUS_ROOT__ + "/api/filepicker/download");
    // Setup URL params
    url.searchParams.append("path", path);
    if (onlyFiles) url.searchParams.append("onlyFiles", "true");
    if (onlyText) url.searchParams.append("onlyText", "true");
    return new Promise(function(resolve, reject) {
        fetch(url.toString()).then(/*#__PURE__*/ function() {
            var _ref3 = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime().mark(function _callee(res) {
                var _res$headers$get;
                var _yield$res$json$then$, msg;
                return _regeneratorRuntime().wrap(function _callee$(_context) {
                    while(true)switch(_context.prev = _context.next){
                        case 0:
                            if (!((_res$headers$get = res.headers.get("content-type")) !== null && _res$headers$get !== void 0 && _res$headers$get.includes("application/json"))) {
                                _context.next = 14;
                                break;
                            }
                            _context.next = 3;
                            return res.json().then(function(res) {
                                return res["msg"];
                            }).catch(function(e) {
                                return undefined;
                            });
                        case 3:
                            _context.t1 = _yield$res$json$then$ = _context.sent;
                            _context.t0 = _context.t1 !== null;
                            if (!_context.t0) {
                                _context.next = 7;
                                break;
                            }
                            _context.t0 = _yield$res$json$then$ !== void 0;
                        case 7:
                            if (!_context.t0) {
                                _context.next = 11;
                                break;
                            }
                            _context.t2 = _yield$res$json$then$;
                            _context.next = 12;
                            break;
                        case 11:
                            _context.t2 = "Unknown error";
                        case 12:
                            msg = _context.t2;
                            reject("".concat(msg !== null && msg !== void 0 ? msg : "Unknown error"));
                        case 14:
                            return _context.abrupt("return", res.blob());
                        case 15:
                        case "end":
                            return _context.stop();
                    }
                }, _callee);
            }));
            return function(_x) {
                return _ref3.apply(this, arguments);
            };
        }()).then(function(blob) {
            resolve(blob);
        }).catch(function(err) {
            reject(err);
        });
    });
}
function HorusLink(props) {
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_reactRouterDom.Link, (0, _objectSpreadProps._)((0, _objectSpread._)({}, props), {
        to: window.__HORUS_ROOT__ + props.to
    }));
}

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","react/jsx-runtime":"iKGFf","4562a3cb6760606a":"9MtAM","b19e24b8394d791c":"8x0oo","93fbb7d9e5e5c03d":"kPxkp","182011f52367751f":"fkrhY","430ce9410a891535":"5Yfvl","105a5373b6b19e34":"2Hr5H"}],"8x0oo":[function(require,module,exports) {
"use strict";
module.exports = require("5664dbce7ba90239");

},{"5664dbce7ba90239":"1Jc2l"}],"1Jc2l":[function(require,module,exports) {
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _objectWithoutProperties = require("@swc/helpers/_/_object_without_properties");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
"use strict";
var ko = Object.create;
var st = Object.defineProperty;
var No = Object.getOwnPropertyDescriptor;
var Go = Object.getOwnPropertyNames;
var Uo = Object.getPrototypeOf, Bo = Object.prototype.hasOwnProperty;
var Vo = function(e, t, n) {
    return t in e ? st(e, t, {
        enumerable: !0,
        configurable: !0,
        writable: !0,
        value: n
    }) : e[t] = n;
};
var jo = function(e, t) {
    for(var n in t)st(e, n, {
        get: t[n],
        enumerable: !0
    });
}, Cn = function(e, t, n, o) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (t && typeof t == "object" || typeof t == "function") try {
        var _loop = function() {
            var l = _step.value;
            !Bo.call(e, l) && l !== n && st(e, l, {
                get: function() {
                    return t[l];
                },
                enumerable: !(o = No(t, l)) || o.enumerable
            });
        };
        for(var _iterator = Go(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return e;
};
var ne = function(e, t, n) {
    return n = e != null ? ko(Uo(e)) : {}, Cn(t || !e || !e.__esModule ? st(n, "default", {
        value: e,
        enumerable: !0
    }) : n, e);
}, Wo = function(e) {
    return Cn(st({}, "__esModule", {
        value: !0
    }), e);
};
var xt = function(e, t, n) {
    return Vo(e, typeof t != "symbol" ? t + "" : t, n), n;
};
var Ii = {};
jo(Ii, {
    Combobox: function() {
        return Er;
    },
    Dialog: function() {
        return ba;
    },
    Disclosure: function() {
        return Da;
    },
    FocusTrap: function() {
        return We;
    },
    Listbox: function() {
        return qa;
    },
    Menu: function() {
        return dl;
    },
    Popover: function() {
        return Fl;
    },
    Portal: function() {
        return mt;
    },
    RadioGroup: function() {
        return Wl;
    },
    Switch: function() {
        return Ql;
    },
    Tab: function() {
        return gi;
    },
    Transition: function() {
        return Di;
    }
});
module.exports = Wo(Ii);
var B = ne(require("79aad0578ed312fe"), 1);
var hn = require("79aad0578ed312fe");
var vt = require("79aad0578ed312fe");
var Bt = /*#__PURE__*/ function() {
    function Bt() {
        (0, _classCallCheck._)(this, Bt);
        xt(this, "current", this.detect());
        xt(this, "handoffState", "pending");
        xt(this, "currentId", 0);
    }
    (0, _createClass._)(Bt, [
        {
            key: "set",
            value: function set(t) {
                this.current !== t && (this.handoffState = "pending", this.currentId = 0, this.current = t);
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.set(this.detect());
            }
        },
        {
            key: "nextId",
            value: function nextId() {
                return ++this.currentId;
            }
        },
        {
            key: "isServer",
            get: function get() {
                return this.current === "server";
            }
        },
        {
            key: "isClient",
            get: function get() {
                return this.current === "client";
            }
        },
        {
            key: "detect",
            value: function detect() {
                return typeof window == "undefined" || typeof document == "undefined" ? "server" : "client";
            }
        },
        {
            key: "handoff",
            value: function handoff() {
                this.handoffState === "pending" && (this.handoffState = "complete");
            }
        },
        {
            key: "isHandoffComplete",
            get: function get() {
                return this.handoffState === "complete";
            }
        }
    ]);
    return Bt;
}(), Pe = new Bt;
var H = function(e, t) {
    Pe.isServer ? (0, vt.useEffect)(e, t) : (0, vt.useLayoutEffect)(e, t);
};
var Ln = require("79aad0578ed312fe");
function Y(e) {
    var t = (0, Ln.useRef)(e);
    return H(function() {
        t.current = e;
    }, [
        e
    ]), t;
}
function Ge(e, t) {
    var _ref = (0, _slicedToArray._)((0, hn.useState)(e), 2), n = _ref[0], o = _ref[1], l = Y(e);
    return H(function() {
        return o(l.current);
    }, [
        l,
        o
    ].concat((0, _toConsumableArray._)(t))), n;
}
var Rt = require("79aad0578ed312fe");
function De(e) {
    typeof queueMicrotask == "function" ? queueMicrotask(e) : Promise.resolve().then(e).catch(function(t) {
        return setTimeout(function() {
            throw t;
        });
    });
}
function ae() {
    var e = [], t = {
        addEventListener (n, o, l, r) {
            return n.addEventListener(o, l, r), t.add(function() {
                return n.removeEventListener(o, l, r);
            });
        },
        requestAnimationFrame () {
            for(var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++){
                n[_key] = arguments[_key];
            }
            var o = requestAnimationFrame.apply(void 0, (0, _toConsumableArray._)(n));
            return t.add(function() {
                return cancelAnimationFrame(o);
            });
        },
        nextFrame () {
            for(var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++){
                n[_key] = arguments[_key];
            }
            var _t;
            return t.requestAnimationFrame(function() {
                return (_t = t).requestAnimationFrame.apply(_t, (0, _toConsumableArray._)(n));
            });
        },
        setTimeout () {
            for(var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++){
                n[_key] = arguments[_key];
            }
            var o = setTimeout.apply(void 0, (0, _toConsumableArray._)(n));
            return t.add(function() {
                return clearTimeout(o);
            });
        },
        microTask () {
            for(var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++){
                n[_key] = arguments[_key];
            }
            var o = {
                current: !0
            };
            return De(function() {
                o.current && n[0]();
            }), t.add(function() {
                o.current = !1;
            });
        },
        style (n, o, l) {
            var r = n.style.getPropertyValue(o);
            return Object.assign(n.style, {
                [o]: l
            }), this.add(function() {
                Object.assign(n.style, {
                    [o]: r
                });
            });
        },
        group (n) {
            var o = ae();
            return n(o), this.add(function() {
                return o.dispose();
            });
        },
        add (n) {
            return e.push(n), function() {
                var o = e.indexOf(n);
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                if (o >= 0) try {
                    for(var _iterator = e.splice(o, 1)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var l = _step.value;
                        l();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
        },
        dispose () {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e.splice(0)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    n();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
    return t;
}
function le() {
    var _ref = (0, _slicedToArray._)((0, Rt.useState)(ae), 1), e = _ref[0];
    return (0, Rt.useEffect)(function() {
        return function() {
            return e.dispose();
        };
    }, [
        e
    ]), e;
}
var Dn = ne(require("79aad0578ed312fe"), 1);
var m = function m(t) {
    var _n;
    var n = Y(t);
    return Dn.default.useCallback(function() {
        for(var _len = arguments.length, o = new Array(_len), _key = 0; _key < _len; _key++){
            o[_key] = arguments[_key];
        }
        return (_n = n).current.apply(_n, (0, _toConsumableArray._)(o));
    }, [
        n
    ]);
};
var Vt = ne(require("79aad0578ed312fe"), 1);
var ut = require("79aad0578ed312fe");
function Ae() {
    var _ref = (0, _slicedToArray._)((0, ut.useState)(Pe.isHandoffComplete), 2), e = _ref[0], t = _ref[1];
    return e && Pe.isHandoffComplete === !1 && t(!1), (0, ut.useEffect)(function() {
        e !== !0 && t(!0);
    }, [
        e
    ]), (0, ut.useEffect)(function() {
        return Pe.handoff();
    }, []), e;
}
var In, j = (In = Vt.default.useId) != null ? In : function j() {
    var t = Ae(), _Vt_default_useState = (0, _slicedToArray._)(Vt.default.useState(t ? function() {
        return Pe.nextId();
    } : null), 2), n = _Vt_default_useState[0], o = _Vt_default_useState[1];
    return H(function() {
        n === null && o(Pe.nextId());
    }, [
        n
    ]), n != null ? "" + n : void 0;
};
var pt = require("79aad0578ed312fe");
function I(e, t) {
    for(var _len = arguments.length, n = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++){
        n[_key - 2] = arguments[_key];
    }
    if (e in t) {
        var l = t[e];
        return typeof l == "function" ? l.apply(void 0, (0, _toConsumableArray._)(n)) : l;
    }
    var o = new Error(`Tried to handle "${e}" but there is no handler defined. Only defined handlers are: ${Object.keys(t).map(function(l) {
        return `"${l}"`;
    }).join(", ")}.`);
    throw Error.captureStackTrace && Error.captureStackTrace(o, I), o;
}
function be(e) {
    return Pe.isServer ? null : e instanceof Node ? e.ownerDocument : e != null && e.hasOwnProperty("current") && e.current instanceof Node ? e.current.ownerDocument : document;
}
var jt = [
    "[contentEditable=true]",
    "[tabindex]",
    "a[href]",
    "area[href]",
    "button:not([disabled])",
    "iframe",
    "input:not([disabled])",
    "select:not([disabled])",
    "textarea:not([disabled])"
].map(function(e) {
    return `${e}:not([tabindex='-1'])`;
}).join(",");
function Je() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : document.body;
    return e == null ? [] : Array.from(e.querySelectorAll(jt)).sort(function(t, n) {
        return Math.sign((t.tabIndex || Number.MAX_SAFE_INTEGER) - (n.tabIndex || Number.MAX_SAFE_INTEGER));
    });
}
function Me(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var n;
    return e === ((n = be(e)) == null ? void 0 : n.body) ? !1 : I(t, {
        [0] () {
            return e.matches(jt);
        },
        [1] () {
            var o = e;
            for(; o !== null;){
                if (o.matches(jt)) return !0;
                o = o.parentElement;
            }
            return !1;
        }
    });
}
function Wt(e) {
    var t = be(e);
    ae().nextFrame(function() {
        t && !Me(t.activeElement, 0) && we(e);
    });
}
typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("keydown", function(e) {
    e.metaKey || e.altKey || e.ctrlKey || (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0), document.addEventListener("click", function(e) {
    e.detail === 1 ? delete document.documentElement.dataset.headlessuiFocusVisible : e.detail === 0 && (document.documentElement.dataset.headlessuiFocusVisible = "");
}, !0));
function we(e) {
    e == null || e.focus({
        preventScroll: !0
    });
}
var Ko = [
    "textarea",
    "input"
].join(",");
function Xo(e) {
    var t, n;
    return (n = (t = e == null ? void 0 : e.matches) == null ? void 0 : t.call(e, Ko)) != null ? n : !1;
}
function ge(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(n) {
        return n;
    };
    return e.slice().sort(function(n, o) {
        var l = t(n), r = t(o);
        if (l === null || r === null) return 0;
        var a = l.compareDocumentPosition(r);
        return a & Node.DOCUMENT_POSITION_FOLLOWING ? -1 : a & Node.DOCUMENT_POSITION_PRECEDING ? 1 : 0;
    });
}
function Fn(e, t) {
    return oe(Je(), t, {
        relativeTo: e
    });
}
function oe(e, t) {
    var _ref = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, tmp = _ref.sorted, n = tmp === void 0 ? !0 : tmp, tmp1 = _ref.relativeTo, o = tmp1 === void 0 ? null : tmp1, tmp2 = _ref.skipElements, l = tmp2 === void 0 ? [] : tmp2;
    var r = Array.isArray(e) ? e.length > 0 ? e[0].ownerDocument : document : e.ownerDocument, a = Array.isArray(e) ? n ? ge(e) : e : Je(e);
    l.length > 0 && a.length > 1 && (a = a.filter(function(b) {
        return !l.includes(b);
    })), o = o != null ? o : r.activeElement;
    var i = function() {
        if (t & 5) return 1;
        if (t & 10) return -1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    }(), s = function() {
        if (t & 1) return 0;
        if (t & 2) return Math.max(0, a.indexOf(o)) - 1;
        if (t & 4) return Math.max(0, a.indexOf(o)) + 1;
        if (t & 8) return a.length - 1;
        throw new Error("Missing Focus.First, Focus.Previous, Focus.Next or Focus.Last");
    }(), u = t & 32 ? {
        preventScroll: !0
    } : {}, f = 0, p = a.length, g;
    do {
        if (f >= p || f + p <= 0) return 0;
        var b = s + f;
        if (t & 16) b = (b + p) % p;
        else {
            if (b < 0) return 3;
            if (b >= p) return 1;
        }
        g = a[b], g == null || g.focus(u), f += i;
    }while (g !== r.activeElement);
    return t & 6 && Xo(g) && g.select(), 2;
}
var Mn = require("79aad0578ed312fe");
function St(e, t, n) {
    var o = Y(t);
    (0, Mn.useEffect)(function() {
        var l = function l(r) {
            o.current(r);
        };
        return document.addEventListener(e, l, n), function() {
            return document.removeEventListener(e, l, n);
        };
    }, [
        e,
        n
    ]);
}
function Ie(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : !0;
    var o = (0, pt.useRef)(!1);
    (0, pt.useEffect)(function() {
        requestAnimationFrame(function() {
            o.current = n;
        });
    }, [
        n
    ]);
    function l(a, i) {
        if (!o.current || a.defaultPrevented) return;
        var s = function f(p) {
            return typeof p == "function" ? f(p()) : Array.isArray(p) || p instanceof Set ? p : [
                p
            ];
        }(e), u = i(a);
        if (u !== null && u.getRootNode().contains(u)) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = s[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var f = _step.value;
                    if (f === null) continue;
                    var p = f instanceof HTMLElement ? f : f.current;
                    if (p != null && p.contains(u) || a.composed && a.composedPath().includes(p)) return;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !Me(u, 1) && u.tabIndex !== -1 && a.preventDefault(), t(a, u);
        }
    }
    var r = (0, pt.useRef)(null);
    St("mousedown", function(a) {
        var i, s;
        o.current && (r.current = ((s = (i = a.composedPath) == null ? void 0 : i.call(a)) == null ? void 0 : s[0]) || a.target);
    }, !0), St("click", function(a) {
        r.current && (l(a, function() {
            return r.current;
        }), r.current = null);
    }, !0), St("blur", function(a) {
        return l(a, function() {
            return window.document.activeElement instanceof HTMLIFrameElement ? window.document.activeElement : null;
        });
    }, !0);
}
var _n = require("79aad0578ed312fe");
function wn(e) {
    var n;
    if (e.type) return e.type;
    var t = (n = e.as) != null ? n : "button";
    if (typeof t == "string" && t.toLowerCase() === "button") return "button";
}
function Ee(e, t) {
    var _ref = (0, _slicedToArray._)((0, _n.useState)(function() {
        return wn(e);
    }), 2), n = _ref[0], o = _ref[1];
    return H(function() {
        o(wn(e));
    }, [
        e.type,
        e.as
    ]), H(function() {
        n || t.current && t.current instanceof HTMLButtonElement && !t.current.hasAttribute("type") && o("button");
    }, [
        n,
        t
    ]), n;
}
var Ot = require("79aad0578ed312fe");
var Hn = Symbol();
function qe(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    return Object.assign(e, {
        [Hn]: t
    });
}
function _() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var t = (0, Ot.useRef)(e);
    (0, Ot.useEffect)(function() {
        t.current = e;
    }, [
        e
    ]);
    var n = m(function(o) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var l = _step.value;
                l != null && (typeof l == "function" ? l(o) : l.current = o);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return e.every(function(o) {
        return o == null || (o == null ? void 0 : o[Hn]);
    }) ? void 0 : n;
}
var dt = require("79aad0578ed312fe");
function Ye(param) {
    var e = param.container, t = param.accept, n = param.walk, tmp = param.enabled, o = tmp === void 0 ? !0 : tmp;
    var l = (0, dt.useRef)(t), r = (0, dt.useRef)(n);
    (0, dt.useEffect)(function() {
        l.current = t, r.current = n;
    }, [
        t,
        n
    ]), H(function() {
        if (!e || !o) return;
        var a = be(e);
        if (!a) return;
        var i = l.current, s = r.current, u = Object.assign(function(p) {
            return i(p);
        }, {
            acceptNode: i
        }), f = a.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, u, !1);
        for(; f.nextNode();)s(f.currentNode);
    }, [
        e,
        o,
        l,
        r
    ]);
}
function $o(e) {
    throw new Error("Unexpected object: " + e);
}
function Qe(e, t) {
    var n = t.resolveItems();
    if (n.length <= 0) return null;
    var o = t.resolveActiveIndex(), l = o != null ? o : -1, r = function() {
        switch(e.focus){
            case 0:
                return n.findIndex(function(a) {
                    return !t.resolveDisabled(a);
                });
            case 1:
                {
                    var a = n.slice().reverse().findIndex(function(i, s, u) {
                        return l !== -1 && u.length - s - 1 >= l ? !1 : !t.resolveDisabled(i);
                    });
                    return a === -1 ? a : n.length - 1 - a;
                }
            case 2:
                return n.findIndex(function(a, i) {
                    return i <= l ? !1 : !t.resolveDisabled(a);
                });
            case 3:
                {
                    var a1 = n.slice().reverse().findIndex(function(i) {
                        return !t.resolveDisabled(i);
                    });
                    return a1 === -1 ? a1 : n.length - 1 - a1;
                }
            case 4:
                return n.findIndex(function(a) {
                    return t.resolveId(a) === e.id;
                });
            case 5:
                return null;
            default:
                $o(e);
        }
    }();
    return r === -1 ? o : r;
}
var Re = require("79aad0578ed312fe");
function ct() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return e.filter(Boolean).join(" ");
}
function h(param) {
    var e = param.ourProps, t = param.theirProps, n = param.slot, o = param.defaultTag, l = param.features, tmp = param.visible, r = tmp === void 0 ? !0 : tmp, a = param.name;
    var i = kn(t, e);
    if (r) return At(i, n, o, a);
    var s = l != null ? l : 0;
    if (s & 2) {
        var tmp1 = i.static, u = tmp1 === void 0 ? !1 : tmp1, f = (0, _objectWithoutProperties._)(i, [
            "static"
        ]);
        if (u) return At(f, n, o, a);
    }
    if (s & 1) {
        var tmp2 = i.unmount, u1 = tmp2 === void 0 ? !0 : tmp2, f1 = (0, _objectWithoutProperties._)(i, [
            "unmount"
        ]);
        return I(u1 ? 0 : 1, {
            [0] () {
                return null;
            },
            [1] () {
                return At((0, _objectSpreadProps._)((0, _objectSpread._)({}, f1), {
                    hidden: !0,
                    style: {
                        display: "none"
                    }
                }), n, o, a);
            }
        });
    }
    return At(i, n, o, a);
}
function At(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, n = arguments.length > 2 ? arguments[2] : void 0, o = arguments.length > 3 ? arguments[3] : void 0;
    var _Xt = Xt(e, [
        "unmount",
        "static"
    ]), tmp = _Xt.as, l = tmp === void 0 ? n : tmp, r = _Xt.children, tmp1 = _Xt.refName, a = tmp1 === void 0 ? "ref" : tmp1, i = (0, _objectWithoutProperties._)(_Xt, [
        "as",
        "children",
        "refName"
    ]), s = e.ref !== void 0 ? {
        [a]: e.ref
    } : {}, u = typeof r == "function" ? r(t) : r;
    "className" in i && i.className && typeof i.className == "function" && (i.className = i.className(t));
    var f = {};
    if (t) {
        var p = !1, g = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(t)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), b = _step_value[0], d = _step_value[1];
                typeof d == "boolean" && (p = !0), d === !0 && g.push(b);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        p && (f["data-headlessui-state"] = g.join(" "));
    }
    if (l === Re.Fragment && Object.keys(Fe(i)).length > 0) {
        var _p;
        if (!(0, Re.isValidElement)(u) || Array.isArray(u) && u.length > 1) throw new Error([
            'Passing props on "Fragment"!',
            "",
            `The current component <${o} /> is rendering a "Fragment".`,
            "However we need to passthrough the following props:",
            Object.keys(i).map(function(d) {
                return `  - ${d}`;
            }).join(`
`),
            "",
            "You can apply a few solutions:",
            [
                'Add an `as="..."` prop, to ensure that we render an actual element instead of a "Fragment".',
                "Render a single element as the child so that we can forward the props onto that element."
            ].map(function(d) {
                return `  - ${d}`;
            }).join(`
`)
        ].join(`
`));
        var p1 = u.props, g1 = typeof (p1 == null ? void 0 : p1.className) == "function" ? function() {
            for(var _len = arguments.length, d = new Array(_len), _key = 0; _key < _len; _key++){
                d[_key] = arguments[_key];
            }
            return ct(p1 == null ? void 0 : (_p = p1).className.apply(_p, (0, _toConsumableArray._)(d)), i.className);
        } : ct(p1 == null ? void 0 : p1.className, i.className), b1 = g1 ? {
            className: g1
        } : {};
        return (0, Re.cloneElement)(u, Object.assign({}, kn(u.props, Fe(Xt(i, [
            "ref"
        ]))), f, s, Jo(u.ref, s.ref), b1));
    }
    return (0, Re.createElement)(l, Object.assign({}, Xt(i, [
        "ref"
    ]), l !== Re.Fragment && s, l !== Re.Fragment && f), u);
}
function Jo() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return {
        ref: e.every(function(t) {
            return t == null;
        }) ? void 0 : function(t) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var n = _step.value;
                    n != null && (typeof n == "function" ? n(t) : n.current = t);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    };
}
function kn() {
    var _loop = function(l1) {
        Object.assign(t, {
            [l1] (r) {
                for(var _len = arguments.length, a = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    a[_key - 1] = arguments[_key];
                }
                var i = n[l1];
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = i[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var s = _step.value;
                        if ((r instanceof Event || (r == null ? void 0 : r.nativeEvent) instanceof Event) && r.defaultPrevented) return;
                        s.apply(void 0, [
                            r
                        ].concat((0, _toConsumableArray._)(a)));
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        });
    };
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    var o;
    if (e.length === 0) return {};
    if (e.length === 1) return e[0];
    var t = {}, n = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var l = _step.value;
            for(var r in l)r.startsWith("on") && typeof l[r] == "function" ? ((o = n[r]) != null || (n[r] = []), n[r].push(l[r])) : t[r] = l[r];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    if (t.disabled || t["aria-disabled"]) return Object.assign(t, Object.fromEntries(Object.keys(n).map(function(l) {
        return [
            l,
            void 0
        ];
    })));
    for(var l1 in n)_loop(l1);
    return t;
}
function D(e) {
    var t;
    return Object.assign((0, Re.forwardRef)(e), {
        displayName: (t = e.displayName) != null ? t : e.name
    });
}
function Fe(e) {
    var t = Object.assign({}, e);
    for(var n in t)t[n] === void 0 && delete t[n];
    return t;
}
function Xt(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var n = Object.assign({}, e);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = t[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var o = _step.value;
            o in n && delete n[o];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
}
function fe(e) {
    var t = e.parentElement, n = null;
    for(; t && !(t instanceof HTMLFieldSetElement);)t instanceof HTMLLegendElement && (n = t), t = t.parentElement;
    var o = (t == null ? void 0 : t.getAttribute("disabled")) === "";
    return o && qo(n) ? !1 : o;
}
function qo(e) {
    if (!e) return !1;
    var t = e.previousElementSibling;
    for(; t !== null;){
        if (t instanceof HTMLLegendElement) return !1;
        t = t.previousElementSibling;
    }
    return !0;
}
function Ue() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(e)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), o = _step_value[0], l = _step_value[1];
            Gn(n, Nn(t, o), l);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return n;
}
function Nn(e, t) {
    return e ? e + "[" + t + "]" : t;
}
function Gn(e, t, n) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    if (Array.isArray(n)) try {
        for(var _iterator = n.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), o = _step_value[0], l = _step_value[1];
            Gn(e, Nn(t, o.toString()), l);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    else n instanceof Date ? e.push([
        t,
        n.toISOString()
    ]) : typeof n == "boolean" ? e.push([
        t,
        n ? "1" : "0"
    ]) : typeof n == "string" ? e.push([
        t,
        n
    ]) : typeof n == "number" ? e.push([
        t,
        `${n}`
    ]) : n == null ? e.push([
        t,
        ""
    ]) : Ue(n, t, e);
}
function Ct(e) {
    var n;
    var t = (n = e == null ? void 0 : e.form) != null ? n : e.closest("form");
    if (t) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.elements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var o = _step.value;
                if (o.tagName === "INPUT" && o.type === "submit" || o.tagName === "BUTTON" && o.type === "submit" || o.nodeName === "INPUT" && o.type === "image") {
                    o.click();
                    return;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
}
var Yo = "div";
function Qo(e, t) {
    var tmp = e.features, n = tmp === void 0 ? 1 : tmp, o = (0, _objectWithoutProperties._)(e, [
        "features"
    ]), l = {
        ref: t,
        "aria-hidden": (n & 2) === 2 ? !0 : void 0,
        style: (0, _objectSpread._)({
            position: "fixed",
            top: 1,
            left: 1,
            width: 1,
            height: 0,
            padding: 0,
            margin: -1,
            overflow: "hidden",
            clip: "rect(0, 0, 0, 0)",
            whiteSpace: "nowrap",
            borderWidth: "0"
        }, (n & 4) === 4 && (n & 2) !== 2 && {
            display: "none"
        })
    };
    return h({
        ourProps: l,
        theirProps: o,
        slot: {},
        defaultTag: Yo,
        name: "Hidden"
    });
}
var ue = D(Qo);
var ze = ne(require("79aad0578ed312fe"), 1), $t = (0, ze.createContext)(null);
$t.displayName = "OpenClosedContext";
function ye() {
    return (0, ze.useContext)($t);
}
function Se(param) {
    var e = param.value, t = param.children;
    return ze.default.createElement($t.Provider, {
        value: e
    }, t);
}
var Ze = require("79aad0578ed312fe");
function He(e, t, n) {
    var _ref = (0, _slicedToArray._)((0, Ze.useState)(n), 2), o = _ref[0], l = _ref[1], r = e !== void 0, a = (0, Ze.useRef)(r), i = (0, Ze.useRef)(!1), s = (0, Ze.useRef)(!1);
    return r && !a.current && !i.current ? (i.current = !0, a.current = r, console.error("A component is changing from uncontrolled to controlled. This may be caused by the value changing from undefined to a defined value, which should not happen.")) : !r && a.current && !s.current && (s.current = !0, a.current = r, console.error("A component is changing from controlled to uncontrolled. This may be caused by the value changing from a defined value to undefined, which should not happen.")), [
        r ? e : o,
        m(function(u) {
            return r || l(u), t == null ? void 0 : t(u);
        })
    ];
}
var Lt = require("79aad0578ed312fe");
function Be(e, t) {
    var n = (0, Lt.useRef)([]), o = m(e);
    (0, Lt.useEffect)(function() {
        var l = (0, _toConsumableArray._)(n.current);
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = t.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), r = _step_value[0], a = _step_value[1];
                if (n.current[r] !== a) {
                    var i = o(t, l);
                    return n.current = t, i;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        o
    ].concat((0, _toConsumableArray._)(t)));
}
var Bn = require("79aad0578ed312fe");
function Un(e) {
    return [
        e.screenX,
        e.screenY
    ];
}
function et() {
    var e = (0, Bn.useRef)([
        -1,
        -1
    ]);
    return {
        wasMoved (t) {
            var n = Un(t);
            return e.current[0] === n[0] && e.current[1] === n[1] ? !1 : (e.current = n, !0);
        },
        update (t) {
            e.current = Un(t);
        }
    };
}
function Jt() {
    return /iPhone/gi.test(window.navigator.platform) || /Mac/gi.test(window.navigator.platform) && window.navigator.maxTouchPoints > 0;
}
function zo() {
    return /Android/gi.test(window.navigator.userAgent);
}
function Vn() {
    return Jt() || zo();
}
function qt(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(n) {
        return n;
    };
    var n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, o = ge(t(e.options.slice()), function(r) {
        return r.dataRef.current.domRef.current;
    }), l = n ? o.indexOf(n) : null;
    return l === -1 && (l = null), {
        options: o,
        activeOptionIndex: l
    };
}
var Zo = {
    [1] (e) {
        var t;
        return (t = e.dataRef.current) != null && t.disabled || e.comboboxState === 1 ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            activeOptionIndex: null,
            comboboxState: 1
        });
    },
    [0] (e) {
        var n;
        if ((n = e.dataRef.current) != null && n.disabled || e.comboboxState === 0) return e;
        var t = e.activeOptionIndex;
        if (e.dataRef.current) {
            var _e_dataRef_current = e.dataRef.current, o = _e_dataRef_current.isSelected, l = e.options.findIndex(function(r) {
                return o(r.dataRef.current.value);
            });
            l !== -1 && (t = l);
        }
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            comboboxState: 0,
            activeOptionIndex: t
        });
    },
    [2] (e, t) {
        var l, r, a, i;
        if ((l = e.dataRef.current) != null && l.disabled || (r = e.dataRef.current) != null && r.optionsRef.current && !((a = e.dataRef.current) != null && a.optionsPropsRef.current.static) && e.comboboxState === 1) return e;
        var n = qt(e);
        if (n.activeOptionIndex === null) {
            var s = n.options.findIndex(function(u) {
                return !u.dataRef.current.disabled;
            });
            s !== -1 && (n.activeOptionIndex = s);
        }
        var o = Qe(t, {
            resolveItems: function() {
                return n.options;
            },
            resolveActiveIndex: function() {
                return n.activeOptionIndex;
            },
            resolveId: function(s) {
                return s.id;
            },
            resolveDisabled: function(s) {
                return s.dataRef.current.disabled;
            }
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e, n), {
            activeOptionIndex: o,
            activationTrigger: (i = t.trigger) != null ? i : 1
        });
    },
    [3]: function(e, t) {
        var r, a;
        var n = {
            id: t.id,
            dataRef: t.dataRef
        }, o = qt(e, function(i) {
            return (0, _toConsumableArray._)(i).concat([
                n
            ]);
        });
        e.activeOptionIndex === null && (r = e.dataRef.current) != null && r.isSelected(t.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(n));
        var l = (0, _objectSpreadProps._)((0, _objectSpread._)({}, e, o), {
            activationTrigger: 1
        });
        return (a = e.dataRef.current) != null && a.__demoMode && e.dataRef.current.value === void 0 && (l.activeOptionIndex = 0), l;
    },
    [4]: function(e, t) {
        var n = qt(e, function(o) {
            var l = o.findIndex(function(r) {
                return r.id === t.id;
            });
            return l !== -1 && o.splice(l, 1), o;
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e, n), {
            activationTrigger: 1
        });
    },
    [5]: function(e, t) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            labelId: t.id
        });
    }
}, Yt = (0, B.createContext)(null);
Yt.displayName = "ComboboxActionsContext";
function ft(e) {
    var t = (0, B.useContext)(Yt);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, ft), n;
    }
    return t;
}
var Qt = (0, B.createContext)(null);
Qt.displayName = "ComboboxDataContext";
function nt(e) {
    var t = (0, B.useContext)(Qt);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Combobox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, nt), n;
    }
    return t;
}
function er(e, t) {
    return I(t.type, Zo, e, t);
}
var tr = B.Fragment;
function nr(e, t) {
    var n = e.value, o = e.defaultValue, l = e.onChange, r = e.form, a = e.name, tmp = e.by, i = tmp === void 0 ? function(O, w) {
        return O === w;
    } : tmp, tmp1 = e.disabled, s = tmp1 === void 0 ? !1 : tmp1, tmp2 = e.__demoMode, u = tmp2 === void 0 ? !1 : tmp2, tmp3 = e.nullable, f = tmp3 === void 0 ? !1 : tmp3, tmp4 = e.multiple, p = tmp4 === void 0 ? !1 : tmp4, g = (0, _objectWithoutProperties._)(e, [
        "value",
        "defaultValue",
        "onChange",
        "form",
        "name",
        "by",
        "disabled",
        "__demoMode",
        "nullable",
        "multiple"
    ]), _He = (0, _slicedToArray._)(He(n, l, o), 2), tmp5 = _He[0], b = tmp5 === void 0 ? p ? [] : void 0 : tmp5, d = _He[1], _ref = (0, _slicedToArray._)((0, B.useReducer)(er, {
        dataRef: (0, B.createRef)(),
        comboboxState: u ? 0 : 1,
        options: [],
        activeOptionIndex: null,
        activationTrigger: 1,
        labelId: null
    }), 2), c = _ref[0], y = _ref[1], T = (0, B.useRef)(!1), P = (0, B.useRef)({
        static: !1,
        hold: !1
    }), F = (0, B.useRef)(null), k = (0, B.useRef)(null), M = (0, B.useRef)(null), C = (0, B.useRef)(null), R = m(typeof i == "string" ? function(O, w) {
        var G = i;
        return (O == null ? void 0 : O[G]) === (w == null ? void 0 : w[G]);
    } : i), v = (0, B.useCallback)(function(O) {
        return I(A.mode, {
            [1]: function() {
                return b.some(function(w) {
                    return R(w, O);
                });
            },
            [0]: function() {
                return R(b, O);
            }
        });
    }, [
        b
    ]), A = (0, B.useMemo)(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, c), {
            optionsPropsRef: P,
            labelRef: F,
            inputRef: k,
            buttonRef: M,
            optionsRef: C,
            value: b,
            defaultValue: o,
            disabled: s,
            mode: p ? 1 : 0,
            get activeOptionIndex () {
                if (T.current && c.activeOptionIndex === null && c.options.length > 0) {
                    var O = c.options.findIndex(function(w) {
                        return !w.dataRef.current.disabled;
                    });
                    if (O !== -1) return O;
                }
                return c.activeOptionIndex;
            },
            compare: R,
            isSelected: v,
            nullable: f,
            __demoMode: u
        });
    }, [
        b,
        o,
        s,
        p,
        f,
        u,
        c
    ]), x = (0, B.useRef)(A.activeOptionIndex !== null ? A.options[A.activeOptionIndex] : null);
    (0, B.useEffect)(function() {
        var O = A.activeOptionIndex !== null ? A.options[A.activeOptionIndex] : null;
        x.current !== O && (x.current = O);
    }), H(function() {
        c.dataRef.current = A;
    }, [
        A
    ]), Ie([
        A.buttonRef,
        A.inputRef,
        A.optionsRef
    ], function() {
        return Z.closeCombobox();
    }, A.comboboxState === 0);
    var S = (0, B.useMemo)(function() {
        return {
            open: A.comboboxState === 0,
            disabled: s,
            activeIndex: A.activeOptionIndex,
            activeOption: A.activeOptionIndex === null ? null : A.options[A.activeOptionIndex].dataRef.current.value,
            value: b
        };
    }, [
        A,
        s,
        b
    ]), E = m(function(O) {
        var w = A.options.find(function(G) {
            return G.id === O;
        });
        w && U(w.dataRef.current.value);
    }), L = m(function() {
        if (A.activeOptionIndex !== null) {
            var _A_options_A_activeOptionIndex = A.options[A.activeOptionIndex], O = _A_options_A_activeOptionIndex.dataRef, w = _A_options_A_activeOptionIndex.id;
            U(O.current.value), Z.goToOption(4, w);
        }
    }), J = m(function() {
        y({
            type: 0
        }), T.current = !0;
    }), X = m(function() {
        y({
            type: 1
        }), T.current = !1;
    }), pe = m(function(O, w, G) {
        return T.current = !1, O === 4 ? y({
            type: 2,
            focus: 4,
            id: w,
            trigger: G
        }) : y({
            type: 2,
            focus: O,
            trigger: G
        });
    }), re = m(function(O, w) {
        return y({
            type: 3,
            id: O,
            dataRef: w
        }), function() {
            var G;
            ((G = x.current) == null ? void 0 : G.id) === O && (T.current = !0), y({
                type: 4,
                id: O
            });
        };
    }), ce = m(function(O) {
        return y({
            type: 5,
            id: O
        }), function() {
            return y({
                type: 5,
                id: null
            });
        };
    }), U = m(function(O) {
        return I(A.mode, {
            [0] () {
                return d == null ? void 0 : d(O);
            },
            [1] () {
                var w = A.value.slice(), G = w.findIndex(function(te) {
                    return R(te, O);
                });
                return G === -1 ? w.push(O) : w.splice(G, 1), d == null ? void 0 : d(w);
            }
        });
    }), Z = (0, B.useMemo)(function() {
        return {
            onChange: U,
            registerOption: re,
            registerLabel: ce,
            goToOption: pe,
            closeCombobox: X,
            openCombobox: J,
            selectActiveOption: L,
            selectOption: E
        };
    }, []), $ = t === null ? {} : {
        ref: t
    }, de = (0, B.useRef)(null), me = le();
    return (0, B.useEffect)(function() {
        de.current && o !== void 0 && me.addEventListener(de.current, "reset", function() {
            U(o);
        });
    }, [
        de,
        U
    ]), B.default.createElement(Yt.Provider, {
        value: Z
    }, B.default.createElement(Qt.Provider, {
        value: A
    }, B.default.createElement(Se, {
        value: I(A.comboboxState, {
            [0]: 1,
            [1]: 2
        })
    }, a != null && b != null && Ue({
        [a]: b
    }).map(function(param, G) {
        var _param = (0, _slicedToArray._)(param, 2), O = _param[0], w = _param[1];
        return B.default.createElement(ue, (0, _objectSpread._)({
            features: 4,
            ref: G === 0 ? function(te) {
                var se;
                de.current = (se = te == null ? void 0 : te.closest("form")) != null ? se : null;
            } : void 0
        }, Fe({
            key: O,
            as: "input",
            type: "hidden",
            hidden: !0,
            readOnly: !0,
            form: r,
            name: O,
            value: w
        })));
    }), h({
        ourProps: $,
        theirProps: g,
        slot: S,
        defaultTag: tr,
        name: "Combobox"
    }))));
}
var or = "input";
function rr(e, t) {
    var R, v, A, x;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-combobox-input-${n}` : tmp, l = e.onChange, r = e.displayValue, tmp1 = e.type, a = tmp1 === void 0 ? "text" : tmp1, i = (0, _objectWithoutProperties._)(e, [
        "id",
        "onChange",
        "displayValue",
        "type"
    ]), s = nt("Combobox.Input"), u = ft("Combobox.Input"), f = _(s.inputRef, t), p = (0, B.useRef)(!1), g = le(), b = function() {
        var S;
        return typeof r == "function" && s.value !== void 0 ? (S = r(s.value)) != null ? S : "" : typeof s.value == "string" ? s.value : "";
    }();
    Be(function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 2), S = _param[0], E = _param[1], _param1 = (0, _slicedToArray._)(param1, 2), L = _param1[0], J = _param1[1];
        p.current || s.inputRef.current && (J === 0 && E === 1 || S !== L) && (s.inputRef.current.value = S);
    }, [
        b,
        s.comboboxState
    ]), Be(function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 1), S = _param[0], _param1 = (0, _slicedToArray._)(param1, 1), E = _param1[0];
        if (S === 0 && E === 1) {
            var L = s.inputRef.current;
            if (!L) return;
            var J = L.value, X = L.selectionStart, pe = L.selectionEnd, re = L.selectionDirection;
            L.value = "", L.value = J, re !== null ? L.setSelectionRange(X, pe, re) : L.setSelectionRange(X, pe);
        }
    }, [
        s.comboboxState
    ]);
    var d = (0, B.useRef)(!1), c = m(function() {
        d.current = !0;
    }), y = m(function() {
        setTimeout(function() {
            d.current = !1;
        });
    }), T = m(function(S) {
        switch(p.current = !0, S.key){
            case "Backspace":
            case "Delete":
                if (s.mode !== 0 || !s.nullable) return;
                var E = S.currentTarget;
                g.requestAnimationFrame(function() {
                    E.value === "" && (u.onChange(null), s.optionsRef.current && (s.optionsRef.current.scrollTop = 0), u.goToOption(5));
                });
                break;
            case "Enter":
                if (p.current = !1, s.comboboxState !== 0 || d.current) return;
                if (S.preventDefault(), S.stopPropagation(), s.activeOptionIndex === null) {
                    u.closeCombobox();
                    return;
                }
                u.selectActiveOption(), s.mode === 0 && u.closeCombobox();
                break;
            case "ArrowDown":
                return p.current = !1, S.preventDefault(), S.stopPropagation(), I(s.comboboxState, {
                    [0]: function() {
                        u.goToOption(2);
                    },
                    [1]: function() {
                        u.openCombobox();
                    }
                });
            case "ArrowUp":
                return p.current = !1, S.preventDefault(), S.stopPropagation(), I(s.comboboxState, {
                    [0]: function() {
                        u.goToOption(1);
                    },
                    [1]: function() {
                        u.openCombobox(), g.nextFrame(function() {
                            s.value || u.goToOption(3);
                        });
                    }
                });
            case "Home":
                if (S.shiftKey) break;
                return p.current = !1, S.preventDefault(), S.stopPropagation(), u.goToOption(0);
            case "PageUp":
                return p.current = !1, S.preventDefault(), S.stopPropagation(), u.goToOption(0);
            case "End":
                if (S.shiftKey) break;
                return p.current = !1, S.preventDefault(), S.stopPropagation(), u.goToOption(3);
            case "PageDown":
                return p.current = !1, S.preventDefault(), S.stopPropagation(), u.goToOption(3);
            case "Escape":
                return p.current = !1, s.comboboxState !== 0 ? void 0 : (S.preventDefault(), s.optionsRef.current && !s.optionsPropsRef.current.static && S.stopPropagation(), u.closeCombobox());
            case "Tab":
                if (p.current = !1, s.comboboxState !== 0) return;
                s.mode === 0 && u.selectActiveOption(), u.closeCombobox();
                break;
        }
    }), P = m(function(S) {
        u.openCombobox(), l == null || l(S);
    }), F = m(function() {
        p.current = !1;
    }), k = Ge(function() {
        if (s.labelId) return [
            s.labelId
        ].join(" ");
    }, [
        s.labelId
    ]), M = (0, B.useMemo)(function() {
        return {
            open: s.comboboxState === 0,
            disabled: s.disabled
        };
    }, [
        s
    ]), C = {
        ref: f,
        id: o,
        role: "combobox",
        type: a,
        "aria-controls": (R = s.optionsRef.current) == null ? void 0 : R.id,
        "aria-expanded": s.disabled ? void 0 : s.comboboxState === 0,
        "aria-activedescendant": s.activeOptionIndex === null || (v = s.options[s.activeOptionIndex]) == null ? void 0 : v.id,
        "aria-labelledby": k,
        "aria-autocomplete": "list",
        defaultValue: (x = (A = e.defaultValue) != null ? A : s.defaultValue !== void 0 ? r == null ? void 0 : r(s.defaultValue) : null) != null ? x : s.defaultValue,
        disabled: s.disabled,
        onCompositionStart: c,
        onCompositionEnd: y,
        onKeyDown: T,
        onChange: P,
        onBlur: F
    };
    return h({
        ourProps: C,
        theirProps: i,
        slot: M,
        defaultTag: or,
        name: "Combobox.Input"
    });
}
var ar = "button";
function lr(e, t) {
    var d;
    var n = nt("Combobox.Button"), o = ft("Combobox.Button"), l = _(n.buttonRef, t), r = j(), tmp = e.id, a = tmp === void 0 ? `headlessui-combobox-button-${r}` : tmp, i = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), s = le(), u = m(function(c) {
        switch(c.key){
            case "ArrowDown":
                return c.preventDefault(), c.stopPropagation(), n.comboboxState === 1 && o.openCombobox(), s.nextFrame(function() {
                    var y;
                    return (y = n.inputRef.current) == null ? void 0 : y.focus({
                        preventScroll: !0
                    });
                });
            case "ArrowUp":
                return c.preventDefault(), c.stopPropagation(), n.comboboxState === 1 && (o.openCombobox(), s.nextFrame(function() {
                    n.value || o.goToOption(3);
                })), s.nextFrame(function() {
                    var y;
                    return (y = n.inputRef.current) == null ? void 0 : y.focus({
                        preventScroll: !0
                    });
                });
            case "Escape":
                return n.comboboxState !== 0 ? void 0 : (c.preventDefault(), n.optionsRef.current && !n.optionsPropsRef.current.static && c.stopPropagation(), o.closeCombobox(), s.nextFrame(function() {
                    var y;
                    return (y = n.inputRef.current) == null ? void 0 : y.focus({
                        preventScroll: !0
                    });
                }));
            default:
                return;
        }
    }), f = m(function(c) {
        if (fe(c.currentTarget)) return c.preventDefault();
        n.comboboxState === 0 ? o.closeCombobox() : (c.preventDefault(), o.openCombobox()), s.nextFrame(function() {
            var y;
            return (y = n.inputRef.current) == null ? void 0 : y.focus({
                preventScroll: !0
            });
        });
    }), p = Ge(function() {
        if (n.labelId) return [
            n.labelId,
            a
        ].join(" ");
    }, [
        n.labelId,
        a
    ]), g = (0, B.useMemo)(function() {
        return {
            open: n.comboboxState === 0,
            disabled: n.disabled,
            value: n.value
        };
    }, [
        n
    ]), b = {
        ref: l,
        id: a,
        type: Ee(e, n.buttonRef),
        tabIndex: -1,
        "aria-haspopup": "listbox",
        "aria-controls": (d = n.optionsRef.current) == null ? void 0 : d.id,
        "aria-expanded": n.disabled ? void 0 : n.comboboxState === 0,
        "aria-labelledby": p,
        disabled: n.disabled,
        onClick: f,
        onKeyDown: u
    };
    return h({
        ourProps: b,
        theirProps: i,
        slot: g,
        defaultTag: ar,
        name: "Combobox.Button"
    });
}
var ir = "label";
function sr(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-combobox-label-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), r = nt("Combobox.Label"), a = ft("Combobox.Label"), i = _(r.labelRef, t);
    H(function() {
        return a.registerLabel(o);
    }, [
        o
    ]);
    var s = m(function() {
        var p;
        return (p = r.inputRef.current) == null ? void 0 : p.focus({
            preventScroll: !0
        });
    }), u = (0, B.useMemo)(function() {
        return {
            open: r.comboboxState === 0,
            disabled: r.disabled
        };
    }, [
        r
    ]);
    return h({
        ourProps: {
            ref: i,
            id: o,
            onClick: s
        },
        theirProps: l,
        slot: u,
        defaultTag: ir,
        name: "Combobox.Label"
    });
}
var ur = "ul", pr = 3;
function dr(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-combobox-options-${n}` : tmp, tmp1 = e.hold, l = tmp1 === void 0 ? !1 : tmp1, r = (0, _objectWithoutProperties._)(e, [
        "id",
        "hold"
    ]), a = nt("Combobox.Options"), i = _(a.optionsRef, t), s = ye(), u = function() {
        return s !== null ? (s & 1) === 1 : a.comboboxState === 0;
    }();
    H(function() {
        var b;
        a.optionsPropsRef.current.static = (b = e.static) != null ? b : !1;
    }, [
        a.optionsPropsRef,
        e.static
    ]), H(function() {
        a.optionsPropsRef.current.hold = l;
    }, [
        a.optionsPropsRef,
        l
    ]), Ye({
        container: a.optionsRef.current,
        enabled: a.comboboxState === 0,
        accept (b) {
            return b.getAttribute("role") === "option" ? NodeFilter.FILTER_REJECT : b.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (b) {
            b.setAttribute("role", "none");
        }
    });
    var f = Ge(function() {
        var b, d;
        return (d = a.labelId) != null ? d : (b = a.buttonRef.current) == null ? void 0 : b.id;
    }, [
        a.labelId,
        a.buttonRef.current
    ]), p = (0, B.useMemo)(function() {
        return {
            open: a.comboboxState === 0
        };
    }, [
        a
    ]), g = {
        "aria-labelledby": f,
        role: "listbox",
        "aria-multiselectable": a.mode === 1 ? !0 : void 0,
        id: o,
        ref: i
    };
    return h({
        ourProps: g,
        theirProps: r,
        slot: p,
        defaultTag: ur,
        features: pr,
        visible: u,
        name: "Combobox.Options"
    });
}
var cr = "li";
function fr(e, t) {
    var v, A;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-combobox-option-${n}` : tmp, tmp1 = e.disabled, l = tmp1 === void 0 ? !1 : tmp1, r = e.value, a = (0, _objectWithoutProperties._)(e, [
        "id",
        "disabled",
        "value"
    ]), i = nt("Combobox.Option"), s = ft("Combobox.Option"), u = i.activeOptionIndex !== null ? i.options[i.activeOptionIndex].id === o : !1, f = i.isSelected(r), p = (0, B.useRef)(null), g = Y({
        disabled: l,
        value: r,
        domRef: p,
        textValue: (A = (v = p.current) == null ? void 0 : v.textContent) == null ? void 0 : A.toLowerCase()
    }), b = _(t, p), d = m(function() {
        return s.selectOption(o);
    });
    H(function() {
        return s.registerOption(o, g);
    }, [
        g,
        o
    ]);
    var c = (0, B.useRef)(!i.__demoMode);
    H(function() {
        if (!i.__demoMode) return;
        var x = ae();
        return x.requestAnimationFrame(function() {
            c.current = !0;
        }), x.dispose;
    }, []), H(function() {
        if (i.comboboxState !== 0 || !u || !c.current || i.activationTrigger === 0) return;
        var x = ae();
        return x.requestAnimationFrame(function() {
            var S, E;
            (E = (S = p.current) == null ? void 0 : S.scrollIntoView) == null || E.call(S, {
                block: "nearest"
            });
        }), x.dispose;
    }, [
        p,
        u,
        i.comboboxState,
        i.activationTrigger,
        i.activeOptionIndex
    ]);
    var y = m(function(x) {
        if (l) return x.preventDefault();
        d(), i.mode === 0 && s.closeCombobox(), Vn() || requestAnimationFrame(function() {
            var S;
            return (S = i.inputRef.current) == null ? void 0 : S.focus();
        });
    }), T = m(function() {
        if (l) return s.goToOption(5);
        s.goToOption(4, o);
    }), P = et(), F = m(function(x) {
        return P.update(x);
    }), k = m(function(x) {
        P.wasMoved(x) && (l || u || s.goToOption(4, o, 0));
    }), M = m(function(x) {
        P.wasMoved(x) && (l || u && (i.optionsPropsRef.current.hold || s.goToOption(5)));
    }), C = (0, B.useMemo)(function() {
        return {
            active: u,
            selected: f,
            disabled: l
        };
    }, [
        u,
        f,
        l
    ]);
    return h({
        ourProps: {
            id: o,
            ref: b,
            role: "option",
            tabIndex: l === !0 ? void 0 : -1,
            "aria-disabled": l === !0 ? !0 : void 0,
            "aria-selected": f,
            disabled: void 0,
            onClick: y,
            onFocus: T,
            onPointerEnter: F,
            onMouseEnter: F,
            onPointerMove: k,
            onMouseMove: k,
            onPointerLeave: M,
            onMouseLeave: M
        },
        theirProps: a,
        slot: C,
        defaultTag: cr,
        name: "Combobox.Option"
    });
}
var Tr = D(nr), mr = D(lr), br = D(rr), yr = D(sr), gr = D(dr), Pr = D(fr), Er = Object.assign(Tr, {
    Input: br,
    Button: mr,
    Label: yr,
    Options: gr,
    Option: Pr
});
var W = ne(require("79aad0578ed312fe"), 1);
var ve = ne(require("79aad0578ed312fe"), 1);
var Xn = require("79aad0578ed312fe");
var Wn = require("79aad0578ed312fe");
function Kn(e, t, n) {
    var o = Y(t);
    (0, Wn.useEffect)(function() {
        var l = function l(r) {
            o.current(r);
        };
        return window.addEventListener(e, l, n), function() {
            return window.removeEventListener(e, l, n);
        };
    }, [
        e,
        n
    ]);
}
function Tt() {
    var e = (0, Xn.useRef)(0);
    return Kn("keydown", function(t) {
        t.key === "Tab" && (e.current = t.shiftKey ? 1 : 0);
    }, !0), e;
}
var $n = require("79aad0578ed312fe");
function _e() {
    var e = (0, $n.useRef)(!1);
    return H(function() {
        return e.current = !0, function() {
            e.current = !1;
        };
    }, []), e;
}
var Jn = require("79aad0578ed312fe");
function xe() {
    for(var _len = arguments.length, e = new Array(_len), _key = 0; _key < _len; _key++){
        e[_key] = arguments[_key];
    }
    return (0, Jn.useMemo)(function() {
        return be.apply(void 0, (0, _toConsumableArray._)(e));
    }, (0, _toConsumableArray._)(e));
}
var qn = require("79aad0578ed312fe");
function ot(e, t, n, o) {
    var l = Y(n);
    (0, qn.useEffect)(function() {
        var r = function r(a) {
            l.current(a);
        };
        e = e != null ? e : window;
        return e.addEventListener(t, r, o), function() {
            return e.removeEventListener(t, r, o);
        };
    }, [
        e,
        t,
        o
    ]);
}
function Yn(e) {
    function t() {
        document.readyState !== "loading" && (e(), document.removeEventListener("DOMContentLoaded", t));
    }
    typeof window != "undefined" && typeof document != "undefined" && (document.addEventListener("DOMContentLoaded", t), t());
}
function Qn(e) {
    if (!e) return new Set;
    if (typeof e == "function") return new Set(e());
    var t = new Set;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e.current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            n.current instanceof HTMLElement && t.add(n.current);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
var vr = "div", zn = function(a) {
    return a[a.None = 1] = "None", a[a.InitialFocus = 2] = "InitialFocus", a[a.TabLock = 4] = "TabLock", a[a.FocusLock = 8] = "FocusLock", a[a.RestoreFocus = 16] = "RestoreFocus", a[a.All = 30] = "All", a;
}(zn || {});
function Rr(e, t) {
    var n = (0, ve.useRef)(null), o = _(n, t), l = e.initialFocus, r = e.containers, tmp = e.features, a = tmp === void 0 ? 30 : tmp, i = (0, _objectWithoutProperties._)(e, [
        "initialFocus",
        "containers",
        "features"
    ]);
    Ae() || (a = 1);
    var s = xe(n);
    Ar({
        ownerDocument: s
    }, Boolean(a & 16));
    var u = Cr({
        ownerDocument: s,
        container: n,
        initialFocus: l
    }, Boolean(a & 2));
    Lr({
        ownerDocument: s,
        container: n,
        containers: r,
        previousActiveElement: u
    }, Boolean(a & 8));
    var f = Tt(), p = m(function(c) {
        var y = n.current;
        if (!y) return;
        (function(P) {
            return P();
        })(function() {
            I(f.current, {
                [0]: function() {
                    oe(y, 1, {
                        skipElements: [
                            c.relatedTarget
                        ]
                    });
                },
                [1]: function() {
                    oe(y, 8, {
                        skipElements: [
                            c.relatedTarget
                        ]
                    });
                }
            });
        });
    }), g = le(), b = (0, ve.useRef)(!1), d = {
        ref: o,
        onKeyDown (c) {
            c.key == "Tab" && (b.current = !0, g.requestAnimationFrame(function() {
                b.current = !1;
            }));
        },
        onBlur (c) {
            var y = Qn(r);
            n.current instanceof HTMLElement && y.add(n.current);
            var T = c.relatedTarget;
            T instanceof HTMLElement && T.dataset.headlessuiFocusGuard !== "true" && (Zn(y, T) || (b.current ? oe(n.current, I(f.current, {
                [0]: function() {
                    return 4;
                },
                [1]: function() {
                    return 2;
                }
            }) | 16, {
                relativeTo: c.target
            }) : c.target instanceof HTMLElement && we(c.target)));
        }
    };
    return ve.default.createElement(ve.default.Fragment, null, Boolean(a & 4) && ve.default.createElement(ue, {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: p,
        features: 2
    }), h({
        ourProps: d,
        theirProps: i,
        defaultTag: vr,
        name: "FocusTrap"
    }), Boolean(a & 4) && ve.default.createElement(ue, {
        as: "button",
        type: "button",
        "data-headlessui-focus-guard": !0,
        onFocus: p,
        features: 2
    }));
}
var Sr = D(Rr), We = Object.assign(Sr, {
    features: zn
}), ke = [];
Yn(function() {
    var e = function e(t) {
        t.target instanceof HTMLElement && t.target !== document.body && ke[0] !== t.target && (ke.unshift(t.target), ke = ke.filter(function(n) {
            return n != null && n.isConnected;
        }), ke.splice(10));
    };
    window.addEventListener("click", e, {
        capture: !0
    }), window.addEventListener("mousedown", e, {
        capture: !0
    }), window.addEventListener("focus", e, {
        capture: !0
    }), document.body.addEventListener("click", e, {
        capture: !0
    }), document.body.addEventListener("mousedown", e, {
        capture: !0
    }), document.body.addEventListener("focus", e, {
        capture: !0
    });
});
function Or() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : !0;
    var t = (0, ve.useRef)(ke.slice());
    return Be(function(param, param1) {
        var _param = (0, _slicedToArray._)(param, 1), n = _param[0], _param1 = (0, _slicedToArray._)(param1, 1), o = _param1[0];
        o === !0 && n === !1 && De(function() {
            t.current.splice(0);
        }), o === !1 && n === !0 && (t.current = ke.slice());
    }, [
        e,
        ke,
        t
    ]), m(function() {
        var n;
        return (n = t.current.find(function(o) {
            return o != null && o.isConnected;
        })) != null ? n : null;
    });
}
function Ar(param, t) {
    var e = param.ownerDocument;
    var n = Or(t);
    Be(function() {
        t || (e == null ? void 0 : e.activeElement) === (e == null ? void 0 : e.body) && we(n());
    }, [
        t
    ]);
    var o = (0, ve.useRef)(!1);
    (0, ve.useEffect)(function() {
        return o.current = !1, function() {
            o.current = !0, De(function() {
                o.current && we(n());
            });
        };
    }, []);
}
function Cr(param, o) {
    var e = param.ownerDocument, t = param.container, n = param.initialFocus;
    var l = (0, ve.useRef)(null), r = _e();
    return Be(function() {
        if (!o) return;
        var a = t.current;
        a && De(function() {
            if (!r.current) return;
            var i = e == null ? void 0 : e.activeElement;
            if (n != null && n.current) {
                if ((n == null ? void 0 : n.current) === i) {
                    l.current = i;
                    return;
                }
            } else if (a.contains(i)) {
                l.current = i;
                return;
            }
            n != null && n.current ? we(n.current) : oe(a, 1) === 0 && console.warn("There are no focusable elements inside the <FocusTrap />"), l.current = e == null ? void 0 : e.activeElement;
        });
    }, [
        o
    ]), l;
}
function Lr(param, l) {
    var e = param.ownerDocument, t = param.container, n = param.containers, o = param.previousActiveElement;
    var r = _e();
    ot(e == null ? void 0 : e.defaultView, "focus", function(a) {
        if (!l || !r.current) return;
        var i = Qn(n);
        t.current instanceof HTMLElement && i.add(t.current);
        var s = o.current;
        if (!s) return;
        var u = a.target;
        u && u instanceof HTMLElement ? Zn(i, u) ? (o.current = u, we(u)) : (a.preventDefault(), a.stopPropagation(), we(s)) : we(o.current);
    }, !0);
}
function Zn(e, t) {
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            if (n.contains(t)) return !0;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return !1;
}
var Te = ne(require("79aad0578ed312fe"), 1), no = require("fefc85d48d39c92");
var rt = ne(require("79aad0578ed312fe"), 1), eo = (0, rt.createContext)(!1);
function to() {
    return (0, rt.useContext)(eo);
}
function Dt(e) {
    return rt.default.createElement(eo.Provider, {
        value: e.force
    }, e.children);
}
function hr(e) {
    var t = to(), n = (0, Te.useContext)(oo), o = xe(e), _ref = (0, _slicedToArray._)((0, Te.useState)(function() {
        if (!t && n !== null || Pe.isServer) return null;
        var a = o == null ? void 0 : o.getElementById("headlessui-portal-root");
        if (a) return a;
        if (o === null) return null;
        var i = o.createElement("div");
        return i.setAttribute("id", "headlessui-portal-root"), o.body.appendChild(i);
    }), 2), l = _ref[0], r = _ref[1];
    return (0, Te.useEffect)(function() {
        l !== null && (o != null && o.body.contains(l) || o == null || o.body.appendChild(l));
    }, [
        l,
        o
    ]), (0, Te.useEffect)(function() {
        t || n !== null && r(n.current);
    }, [
        n,
        r,
        t
    ]), l;
}
var Dr = Te.Fragment;
function Ir(e, t) {
    var n = e, o = (0, Te.useRef)(null), l = _(qe(function(p) {
        o.current = p;
    }), t), r = xe(o), a = hr(o), _ref = (0, _slicedToArray._)((0, Te.useState)(function() {
        var p;
        return Pe.isServer ? null : (p = r == null ? void 0 : r.createElement("div")) != null ? p : null;
    }), 1), i = _ref[0], s = Ae(), u = (0, Te.useRef)(!1);
    return H(function() {
        if (u.current = !1, !(!a || !i)) return a.contains(i) || (i.setAttribute("data-headlessui-portal", ""), a.appendChild(i)), function() {
            u.current = !0, De(function() {
                var p;
                u.current && (!a || !i || (i instanceof Node && a.contains(i) && a.removeChild(i), a.childNodes.length <= 0 && ((p = a.parentElement) == null || p.removeChild(a))));
            });
        };
    }, [
        a,
        i
    ]), s ? !a || !i ? null : (0, no.createPortal)(h({
        ourProps: {
            ref: l
        },
        theirProps: n,
        defaultTag: Dr,
        name: "Portal"
    }), i) : null;
}
var Fr = Te.Fragment, oo = (0, Te.createContext)(null);
function Mr(e, t) {
    var n = e.target, o = (0, _objectWithoutProperties._)(e, [
        "target"
    ]), r = {
        ref: _(t)
    };
    return Te.default.createElement(oo.Provider, {
        value: n
    }, h({
        ourProps: r,
        theirProps: o,
        defaultTag: Fr,
        name: "Popover.Group"
    }));
}
var wr = D(Ir), _r = D(Mr), mt = Object.assign(wr, {
    Group: _r
});
var Ce = ne(require("79aad0578ed312fe"), 1);
var ro = (0, Ce.createContext)(null);
function ao() {
    var e = (0, Ce.useContext)(ro);
    if (e === null) {
        var t = new Error("You used a <Description /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, ao), t;
    }
    return e;
}
function Ke() {
    var _ref = (0, _slicedToArray._)((0, Ce.useState)([]), 2), e = _ref[0], t = _ref[1];
    return [
        e.length > 0 ? e.join(" ") : void 0,
        (0, Ce.useMemo)(function() {
            return function(o) {
                var l = m(function(a) {
                    return t(function(i) {
                        return (0, _toConsumableArray._)(i).concat([
                            a
                        ]);
                    }), function() {
                        return t(function(i) {
                            var s = i.slice(), u = s.indexOf(a);
                            return u !== -1 && s.splice(u, 1), s;
                        });
                    };
                }), r = (0, Ce.useMemo)(function() {
                    return {
                        register: l,
                        slot: o.slot,
                        name: o.name,
                        props: o.props
                    };
                }, [
                    l,
                    o.slot,
                    o.name,
                    o.props
                ]);
                return Ce.default.createElement(ro.Provider, {
                    value: r
                }, o.children);
            };
        }, [
            t
        ])
    ];
}
var Hr = "p";
function kr(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-description-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), r = ao(), a = _(t);
    H(function() {
        return r.register(o);
    }, [
        o,
        r.register
    ]);
    var i = (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: a
    }, r.props), {
        id: o
    });
    return h({
        ourProps: i,
        theirProps: l,
        slot: r.slot || {},
        defaultTag: Hr,
        name: r.name || "Description"
    });
}
var Nr = D(kr), at = Object.assign(Nr, {});
var lt = ne(require("79aad0578ed312fe"), 1);
var Zt = (0, lt.createContext)(function() {});
Zt.displayName = "StackContext";
function Gr() {
    return (0, lt.useContext)(Zt);
}
function lo(param) {
    var e = param.children, t = param.onUpdate, n = param.type, o = param.element, l = param.enabled;
    var r = Gr(), a = m(function() {
        for(var _len = arguments.length, i = new Array(_len), _key = 0; _key < _len; _key++){
            i[_key] = arguments[_key];
        }
        t == null || t.apply(void 0, (0, _toConsumableArray._)(i)), r.apply(void 0, (0, _toConsumableArray._)(i));
    });
    return H(function() {
        var i = l === void 0 || l === !0;
        return i && a(0, n, o), function() {
            i && a(1, n, o);
        };
    }, [
        a,
        n,
        o,
        l
    ]), lt.default.createElement(Zt.Provider, {
        value: a
    }, e);
}
var uo = ne(require("79aad0578ed312fe"), 1);
var Ur = ne(require("79aad0578ed312fe"), 1);
function Br(e, t) {
    return e === t && (e !== 0 || 1 / e === 1 / t) || e !== e && t !== t;
}
var Vr = typeof Object.is == "function" ? Object.is : Br, jr = Ur.useState, Wr = Ur.useEffect, Kr = Ur.useLayoutEffect, Xr = Ur.useDebugValue;
function io(e, t, n) {
    var o = t(), _jr = (0, _slicedToArray._)(jr({
        inst: {
            value: o,
            getSnapshot: t
        }
    }), 2), _jr_ = _jr[0], l = _jr_.inst, r = _jr[1];
    return Kr(function() {
        l.value = o, l.getSnapshot = t, en(l) && r({
            inst: l
        });
    }, [
        e,
        o,
        t
    ]), Wr(function() {
        return en(l) && r({
            inst: l
        }), e(function() {
            en(l) && r({
                inst: l
            });
        });
    }, [
        e
    ]), Xr(o), o;
}
function en(e) {
    var t = e.getSnapshot, n = e.value;
    try {
        var o = t();
        return !Vr(n, o);
    } catch (e) {
        return !0;
    }
}
function so(e, t, n) {
    return t();
}
var $r = typeof window != "undefined" && typeof window.document != "undefined" && typeof window.document.createElement != "undefined", Jr = !$r, qr = Jr ? so : io, po = "useSyncExternalStore" in uo ? function(e) {
    return e.useSyncExternalStore;
}(uo) : qr;
function co(e) {
    return po(e.subscribe, e.getSnapshot, e.getSnapshot);
}
function fo(e, t) {
    var n = e(), o = new Set;
    return {
        getSnapshot () {
            return n;
        },
        subscribe (l) {
            return o.add(l), function() {
                return o.delete(l);
            };
        },
        dispatch (l) {
            for(var _len = arguments.length, r = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                r[_key - 1] = arguments[_key];
            }
            var _t_l;
            var a = (_t_l = t[l]).call.apply(_t_l, [
                n
            ].concat((0, _toConsumableArray._)(r)));
            a && (n = a, o.forEach(function(i) {
                return i();
            }));
        }
    };
}
function To() {
    var e;
    return {
        before (param) {
            var t = param.doc;
            var l;
            var n = t.documentElement;
            e = ((l = t.defaultView) != null ? l : window).innerWidth - n.clientWidth;
        },
        after (param) {
            var t = param.doc, n = param.d;
            var o = t.documentElement, l = o.clientWidth - o.offsetWidth, r = e - l;
            n.style(o, "paddingRight", `${r}px`);
        }
    };
}
function mo() {
    if (!Jt()) return {};
    var e;
    return {
        before () {
            e = window.pageYOffset;
        },
        after (param) {
            var t = param.doc, n = param.d, o = param.meta;
            function l(a) {
                return o.containers.flatMap(function(i) {
                    return i();
                }).some(function(i) {
                    return i.contains(a);
                });
            }
            n.style(t.body, "marginTop", `-${e}px`), window.scrollTo(0, 0);
            var r = null;
            n.addEventListener(t, "click", function(a) {
                if (a.target instanceof HTMLElement) try {
                    var i = a.target.closest("a");
                    if (!i) return;
                    var _ref = new URL(i.href), s = _ref.hash, u = t.querySelector(s);
                    u && !l(u) && (r = u);
                } catch (e) {}
            }, !0), n.addEventListener(t, "touchmove", function(a) {
                a.target instanceof HTMLElement && !l(a.target) && a.preventDefault();
            }, {
                passive: !1
            }), n.add(function() {
                window.scrollTo(0, window.pageYOffset + e), r && r.isConnected && (r.scrollIntoView({
                    block: "nearest"
                }), r = null);
            });
        }
    };
}
function bo() {
    return {
        before (param) {
            var e = param.doc, t = param.d;
            t.style(e.documentElement, "overflow", "hidden");
        }
    };
}
function Yr(e) {
    var t = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var n = _step.value;
            Object.assign(t, n(t));
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
var Ne = fo(function() {
    return new Map;
}, {
    PUSH (e, t) {
        var o;
        var n = (o = this.get(e)) != null ? o : {
            doc: e,
            count: 0,
            d: ae(),
            meta: new Set
        };
        return n.count++, n.meta.add(t), this.set(e, n), this;
    },
    POP (e, t) {
        var n = this.get(e);
        return n && (n.count--, n.meta.delete(t)), this;
    },
    SCROLL_PREVENT (param) {
        var e = param.doc, t = param.d, n = param.meta;
        var o = {
            doc: e,
            d: t,
            meta: Yr(n)
        }, l = [
            mo(),
            To(),
            bo()
        ];
        l.forEach(function(param) {
            var r = param.before;
            return r == null ? void 0 : r(o);
        }), l.forEach(function(param) {
            var r = param.after;
            return r == null ? void 0 : r(o);
        });
    },
    SCROLL_ALLOW (param) {
        var e = param.d;
        e.dispose();
    },
    TEARDOWN (param) {
        var e = param.doc;
        this.delete(e);
    }
});
Ne.subscribe(function() {
    var e = Ne.getSnapshot(), t = new Map;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = e[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 1), n = _step_value[0];
            t.set(n, n.documentElement.style.overflow);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = e.values()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var n1 = _step1.value;
            var o = t.get(n1.doc) === "hidden", l = n1.count !== 0;
            (l && !o || !l && o) && Ne.dispatch(n1.count > 0 ? "SCROLL_PREVENT" : "SCROLL_ALLOW", n1), n1.count === 0 && Ne.dispatch("TEARDOWN", n1);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
});
function yo(e, t, n) {
    var o = co(Ne), l = e ? o.get(e) : void 0, r = l ? l.count > 0 : !1;
    return H(function() {
        if (!(!e || !t)) return Ne.dispatch("PUSH", e, n), function() {
            return Ne.dispatch("POP", e, n);
        };
    }, [
        t,
        e
    ]), r;
}
var tn = new Map, bt = new Map;
function nn(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : !0;
    H(function() {
        var o = function o() {
            var s;
            if (!n) return;
            var a = (s = bt.get(n)) != null ? s : 1;
            if (a === 1 ? bt.delete(n) : bt.set(n, a - 1), a !== 1) return;
            var i = tn.get(n);
            i && (i["aria-hidden"] === null ? n.removeAttribute("aria-hidden") : n.setAttribute("aria-hidden", i["aria-hidden"]), n.inert = i.inert, tn.delete(n));
        };
        var r;
        if (!t) return;
        var n = typeof e == "function" ? e() : e.current;
        if (!n) return;
        var l = (r = bt.get(n)) != null ? r : 0;
        return bt.set(n, l + 1), l !== 0 || (tn.set(n, {
            "aria-hidden": n.getAttribute("aria-hidden"),
            inert: n.inert
        }), n.setAttribute("aria-hidden", "true"), n.inert = !0), o;
    }, [
        e,
        t
    ]);
}
var Qr = {
    [0] (e, t) {
        return e.titleId === t.id ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            titleId: t.id
        });
    }
}, It = (0, W.createContext)(null);
It.displayName = "DialogContext";
function yt(e) {
    var t = (0, W.useContext)(It);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Dialog /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, yt), n;
    }
    return t;
}
function zr(e, t) {
    var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : function() {
        return [
            document.body
        ];
    };
    yo(e, t, function(o) {
        var l;
        return {
            containers: (0, _toConsumableArray._)((l = o.containers) != null ? l : []).concat([
                n
            ])
        };
    });
}
function Zr(e, t) {
    return I(t.type, Qr, e, t);
}
var ea = "div", ta = 3;
function na(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-dialog-${n}` : tmp, l = e.open, r = e.onClose, a = e.initialFocus, tmp1 = e.__demoMode, i = tmp1 === void 0 ? !1 : tmp1, s = (0, _objectWithoutProperties._)(e, [
        "id",
        "open",
        "onClose",
        "initialFocus",
        "__demoMode"
    ]), _ref = (0, _slicedToArray._)((0, W.useState)(0), 2), u = _ref[0], f = _ref[1], p = ye();
    l === void 0 && p !== null && (l = (p & 1) === 1);
    var g = (0, W.useRef)(null), b = _(g, t), d = (0, W.useRef)(null), c = xe(g), y = e.hasOwnProperty("open") || p !== null, T = e.hasOwnProperty("onClose");
    if (!y && !T) throw new Error("You have to provide an `open` and an `onClose` prop to the `Dialog` component.");
    if (!y) throw new Error("You provided an `onClose` prop to the `Dialog`, but forgot an `open` prop.");
    if (!T) throw new Error("You provided an `open` prop to the `Dialog`, but forgot an `onClose` prop.");
    if (typeof l != "boolean") throw new Error(`You provided an \`open\` prop to the \`Dialog\`, but the value is not a boolean. Received: ${l}`);
    if (typeof r != "function") throw new Error(`You provided an \`onClose\` prop to the \`Dialog\`, but the value is not a function. Received: ${r}`);
    var P = l ? 0 : 1, _ref1 = (0, _slicedToArray._)((0, W.useReducer)(Zr, {
        titleId: null,
        descriptionId: null,
        panelRef: (0, W.createRef)()
    }), 2), F = _ref1[0], k = _ref1[1], M = m(function() {
        return r(!1);
    }), C = m(function(G) {
        return k({
            type: 0,
            id: G
        });
    }), v = Ae() ? i ? !1 : P === 0 : !1, A = u > 1, x = (0, W.useContext)(It) !== null, S = A ? "parent" : "leaf", E = p !== null ? (p & 4) === 4 : !1, L = function() {
        return x || E ? !1 : v;
    }(), J = (0, W.useCallback)(function() {
        var G, te;
        return (te = Array.from((G = c == null ? void 0 : c.querySelectorAll("body > *")) != null ? G : []).find(function(se) {
            return se.id === "headlessui-portal-root" ? !1 : se.contains(d.current) && se instanceof HTMLElement;
        })) != null ? te : null;
    }, [
        d
    ]);
    nn(J, L);
    var X = function() {
        return A ? !0 : v;
    }(), pe = (0, W.useCallback)(function() {
        var G, te;
        return (te = Array.from((G = c == null ? void 0 : c.querySelectorAll("[data-headlessui-portal]")) != null ? G : []).find(function(se) {
            return se.contains(d.current) && se instanceof HTMLElement;
        })) != null ? te : null;
    }, [
        d
    ]);
    nn(pe, X);
    var re = m(function() {
        var te, se;
        return (0, _toConsumableArray._)(Array.from((te = c == null ? void 0 : c.querySelectorAll("html > *, body > *, [data-headlessui-portal]")) != null ? te : []).filter(function(he) {
            return !(he === document.body || he === document.head || !(he instanceof HTMLElement) || he.contains(d.current) || F.panelRef.current && he.contains(F.panelRef.current));
        })).concat([
            (se = F.panelRef.current) != null ? se : g.current
        ]);
    }), ce = function() {
        return !(!v || A);
    }();
    Ie(function() {
        return re();
    }, M, ce);
    var U = function() {
        return !(A || P !== 0);
    }();
    ot(c == null ? void 0 : c.defaultView, "keydown", function(G) {
        U && (G.defaultPrevented || G.key === "Escape" && (G.preventDefault(), G.stopPropagation(), M()));
    });
    var Z = function() {
        return !(E || P !== 0 || x);
    }();
    zr(c, Z, re), (0, W.useEffect)(function() {
        if (P !== 0 || !g.current) return;
        var G = new ResizeObserver(function(te) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = te[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var se = _step.value;
                    var he = se.target.getBoundingClientRect();
                    he.x === 0 && he.y === 0 && he.width === 0 && he.height === 0 && M();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        });
        return G.observe(g.current), function() {
            return G.disconnect();
        };
    }, [
        P,
        g,
        M
    ]);
    var _Ke = (0, _slicedToArray._)(Ke(), 2), $ = _Ke[0], de = _Ke[1], me = (0, W.useMemo)(function() {
        return [
            {
                dialogState: P,
                close: M,
                setTitleId: C
            },
            F
        ];
    }, [
        P,
        F,
        M,
        C
    ]), O = (0, W.useMemo)(function() {
        return {
            open: P === 0
        };
    }, [
        P
    ]), w = {
        ref: b,
        id: o,
        role: "dialog",
        "aria-modal": P === 0 ? !0 : void 0,
        "aria-labelledby": F.titleId,
        "aria-describedby": $
    };
    return W.default.createElement(lo, {
        type: "Dialog",
        enabled: P === 0,
        element: g,
        onUpdate: m(function(G, te) {
            te === "Dialog" && I(G, {
                [0]: function() {
                    return f(function(se) {
                        return se + 1;
                    });
                },
                [1]: function() {
                    return f(function(se) {
                        return se - 1;
                    });
                }
            });
        })
    }, W.default.createElement(Dt, {
        force: !0
    }, W.default.createElement(mt, null, W.default.createElement(It.Provider, {
        value: me
    }, W.default.createElement(mt.Group, {
        target: g
    }, W.default.createElement(Dt, {
        force: !1
    }, W.default.createElement(de, {
        slot: O,
        name: "Dialog.Description"
    }, W.default.createElement(We, {
        initialFocus: a,
        containers: re,
        features: v ? I(S, {
            parent: We.features.RestoreFocus,
            leaf: We.features.All & ~We.features.FocusLock
        }) : We.features.None
    }, h({
        ourProps: w,
        theirProps: s,
        slot: O,
        defaultTag: ea,
        features: ta,
        visible: P === 0,
        name: "Dialog"
    })))))))), W.default.createElement(ue, {
        features: 4,
        ref: d
    }));
}
var oa = "div";
function ra(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-dialog-overlay-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _yt = (0, _slicedToArray._)(yt("Dialog.Overlay"), 1), _yt_ = _yt[0], r = _yt_.dialogState, a = _yt_.close, i = _(t), s = m(function(p) {
        if (p.target === p.currentTarget) {
            if (fe(p.currentTarget)) return p.preventDefault();
            p.preventDefault(), p.stopPropagation(), a();
        }
    }), u = (0, W.useMemo)(function() {
        return {
            open: r === 0
        };
    }, [
        r
    ]);
    return h({
        ourProps: {
            ref: i,
            id: o,
            "aria-hidden": !0,
            onClick: s
        },
        theirProps: l,
        slot: u,
        defaultTag: oa,
        name: "Dialog.Overlay"
    });
}
var aa = "div";
function la(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-dialog-backdrop-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _yt = (0, _slicedToArray._)(yt("Dialog.Backdrop"), 2), _yt_ = _yt[0], r = _yt_.dialogState, a = _yt[1], i = _(t);
    (0, W.useEffect)(function() {
        if (a.panelRef.current === null) throw new Error("A <Dialog.Backdrop /> component is being used, but a <Dialog.Panel /> component is missing.");
    }, [
        a.panelRef
    ]);
    var s = (0, W.useMemo)(function() {
        return {
            open: r === 0
        };
    }, [
        r
    ]);
    return W.default.createElement(Dt, {
        force: !0
    }, W.default.createElement(mt, null, h({
        ourProps: {
            ref: i,
            id: o,
            "aria-hidden": !0
        },
        theirProps: l,
        slot: s,
        defaultTag: aa,
        name: "Dialog.Backdrop"
    })));
}
var ia = "div";
function sa(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-dialog-panel-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _yt = (0, _slicedToArray._)(yt("Dialog.Panel"), 2), _yt_ = _yt[0], r = _yt_.dialogState, a = _yt[1], i = _(t, a.panelRef), s = (0, W.useMemo)(function() {
        return {
            open: r === 0
        };
    }, [
        r
    ]), u = m(function(p) {
        p.stopPropagation();
    });
    return h({
        ourProps: {
            ref: i,
            id: o,
            onClick: u
        },
        theirProps: l,
        slot: s,
        defaultTag: ia,
        name: "Dialog.Panel"
    });
}
var ua = "h2";
function pa(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-dialog-title-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _yt = (0, _slicedToArray._)(yt("Dialog.Title"), 1), _yt_ = _yt[0], r = _yt_.dialogState, a = _yt_.setTitleId, i = _(t);
    (0, W.useEffect)(function() {
        return a(o), function() {
            return a(null);
        };
    }, [
        o,
        a
    ]);
    var s = (0, W.useMemo)(function() {
        return {
            open: r === 0
        };
    }, [
        r
    ]);
    return h({
        ourProps: {
            ref: i,
            id: o
        },
        theirProps: l,
        slot: s,
        defaultTag: ua,
        name: "Dialog.Title"
    });
}
var da = D(na), ca = D(la), fa = D(sa), Ta = D(ra), ma = D(pa), ba = Object.assign(da, {
    Backdrop: ca,
    Panel: fa,
    Overlay: Ta,
    Title: ma,
    Description: at
});
var q = ne(require("79aad0578ed312fe"), 1);
var Po = ne(require("79aad0578ed312fe"), 1), go, Eo = (go = Po.default.startTransition) != null ? go : function Eo(t) {
    t();
};
var ya = {
    [0]: function(e) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            disclosureState: I(e.disclosureState, {
                [0]: 1,
                [1]: 0
            })
        });
    },
    [1]: function(e) {
        return e.disclosureState === 1 ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            disclosureState: 1
        });
    },
    [4] (e) {
        return e.linkedPanel === !0 ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            linkedPanel: !0
        });
    },
    [5] (e) {
        return e.linkedPanel === !1 ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            linkedPanel: !1
        });
    },
    [2] (e, t) {
        return e.buttonId === t.buttonId ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            buttonId: t.buttonId
        });
    },
    [3] (e, t) {
        return e.panelId === t.panelId ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            panelId: t.panelId
        });
    }
}, on = (0, q.createContext)(null);
on.displayName = "DisclosureContext";
function rn(e) {
    var t = (0, q.useContext)(on);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, rn), n;
    }
    return t;
}
var an = (0, q.createContext)(null);
an.displayName = "DisclosureAPIContext";
function xo(e) {
    var t = (0, q.useContext)(an);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Disclosure /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, xo), n;
    }
    return t;
}
var ln = (0, q.createContext)(null);
ln.displayName = "DisclosurePanelContext";
function ga() {
    return (0, q.useContext)(ln);
}
function Pa(e, t) {
    return I(t.type, ya, e, t);
}
var Ea = q.Fragment;
function xa(e, t) {
    var tmp = e.defaultOpen, n = tmp === void 0 ? !1 : tmp, o = (0, _objectWithoutProperties._)(e, [
        "defaultOpen"
    ]), l = (0, q.useRef)(null), r = _(t, qe(function(y) {
        l.current = y;
    }, e.as === void 0 || e.as === q.Fragment)), a = (0, q.useRef)(null), i = (0, q.useRef)(null), s = (0, q.useReducer)(Pa, {
        disclosureState: n ? 0 : 1,
        linkedPanel: !1,
        buttonRef: i,
        panelRef: a,
        buttonId: null,
        panelId: null
    }), _s = (0, _slicedToArray._)(s, 2), _s_ = _s[0], u = _s_.disclosureState, f = _s_.buttonId, p = _s[1], g = m(function(y) {
        p({
            type: 1
        });
        var T = be(l);
        if (!T || !f) return;
        var P = function() {
            return y ? y instanceof HTMLElement ? y : y.current instanceof HTMLElement ? y.current : T.getElementById(f) : T.getElementById(f);
        }();
        P == null || P.focus();
    }), b = (0, q.useMemo)(function() {
        return {
            close: g
        };
    }, [
        g
    ]), d = (0, q.useMemo)(function() {
        return {
            open: u === 0,
            close: g
        };
    }, [
        u,
        g
    ]), c = {
        ref: r
    };
    return q.default.createElement(on.Provider, {
        value: s
    }, q.default.createElement(an.Provider, {
        value: b
    }, q.default.createElement(Se, {
        value: I(u, {
            [0]: 1,
            [1]: 2
        })
    }, h({
        ourProps: c,
        theirProps: o,
        slot: d,
        defaultTag: Ea,
        name: "Disclosure"
    }))));
}
var va = "button";
function Ra(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-disclosure-button-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _rn = (0, _slicedToArray._)(rn("Disclosure.Button"), 2), r = _rn[0], a = _rn[1], i = ga(), s = i === null ? !1 : i === r.panelId, u = (0, q.useRef)(null), f = _(u, t, s ? null : r.buttonRef);
    (0, q.useEffect)(function() {
        if (!s) return a({
            type: 2,
            buttonId: o
        }), function() {
            a({
                type: 2,
                buttonId: null
            });
        };
    }, [
        o,
        a,
        s
    ]);
    var p = m(function(T) {
        var P;
        if (s) {
            if (r.disclosureState === 1) return;
            switch(T.key){
                case " ":
                case "Enter":
                    T.preventDefault(), T.stopPropagation(), a({
                        type: 0
                    }), (P = r.buttonRef.current) == null || P.focus();
                    break;
            }
        } else switch(T.key){
            case " ":
            case "Enter":
                T.preventDefault(), T.stopPropagation(), a({
                    type: 0
                });
                break;
        }
    }), g = m(function(T) {
        switch(T.key){
            case " ":
                T.preventDefault();
                break;
        }
    }), b = m(function(T) {
        var P;
        fe(T.currentTarget) || e.disabled || (s ? (a({
            type: 0
        }), (P = r.buttonRef.current) == null || P.focus()) : a({
            type: 0
        }));
    }), d = (0, q.useMemo)(function() {
        return {
            open: r.disclosureState === 0
        };
    }, [
        r
    ]), c = Ee(e, u), y = s ? {
        ref: f,
        type: c,
        onKeyDown: p,
        onClick: b
    } : {
        ref: f,
        id: o,
        type: c,
        "aria-expanded": e.disabled ? void 0 : r.disclosureState === 0,
        "aria-controls": r.linkedPanel ? r.panelId : void 0,
        onKeyDown: p,
        onKeyUp: g,
        onClick: b
    };
    return h({
        ourProps: y,
        theirProps: l,
        slot: d,
        defaultTag: va,
        name: "Disclosure.Button"
    });
}
var Sa = "div", Oa = 3;
function Aa(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-disclosure-panel-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _rn = (0, _slicedToArray._)(rn("Disclosure.Panel"), 2), r = _rn[0], a = _rn[1], _xo = xo("Disclosure.Panel"), i = _xo.close, s = _(t, r.panelRef, function(b) {
        Eo(function() {
            return a({
                type: b ? 4 : 5
            });
        });
    });
    (0, q.useEffect)(function() {
        return a({
            type: 3,
            panelId: o
        }), function() {
            a({
                type: 3,
                panelId: null
            });
        };
    }, [
        o,
        a
    ]);
    var u = ye(), f = function() {
        return u !== null ? (u & 1) === 1 : r.disclosureState === 0;
    }(), p = (0, q.useMemo)(function() {
        return {
            open: r.disclosureState === 0,
            close: i
        };
    }, [
        r,
        i
    ]), g = {
        ref: s,
        id: o
    };
    return q.default.createElement(ln.Provider, {
        value: r.panelId
    }, h({
        ourProps: g,
        theirProps: l,
        slot: p,
        defaultTag: Sa,
        features: Oa,
        visible: f,
        name: "Disclosure.Panel"
    }));
}
var Ca = D(xa), La = D(Ra), ha = D(Aa), Da = Object.assign(Ca, {
    Button: La,
    Panel: ha
});
var K = ne(require("79aad0578ed312fe"), 1);
function sn(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(n) {
        return n;
    };
    var n = e.activeOptionIndex !== null ? e.options[e.activeOptionIndex] : null, o = ge(t(e.options.slice()), function(r) {
        return r.dataRef.current.domRef.current;
    }), l = n ? o.indexOf(n) : null;
    return l === -1 && (l = null), {
        options: o,
        activeOptionIndex: l
    };
}
var Ia = {
    [1] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            activeOptionIndex: null,
            listboxState: 1
        });
    },
    [0] (e) {
        if (e.dataRef.current.disabled || e.listboxState === 0) return e;
        var t = e.activeOptionIndex, _e_dataRef_current = e.dataRef.current, n = _e_dataRef_current.isSelected, o = e.options.findIndex(function(l) {
            return n(l.dataRef.current.value);
        });
        return o !== -1 && (t = o), (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            listboxState: 0,
            activeOptionIndex: t
        });
    },
    [2] (e, t) {
        var l;
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        var n = sn(e), o = Qe(t, {
            resolveItems: function() {
                return n.options;
            },
            resolveActiveIndex: function() {
                return n.activeOptionIndex;
            },
            resolveId: function(r) {
                return r.id;
            },
            resolveDisabled: function(r) {
                return r.dataRef.current.disabled;
            }
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e, n), {
            searchQuery: "",
            activeOptionIndex: o,
            activationTrigger: (l = t.trigger) != null ? l : 1
        });
    },
    [3]: function(e, t) {
        if (e.dataRef.current.disabled || e.listboxState === 1) return e;
        var o = e.searchQuery !== "" ? 0 : 1, l = e.searchQuery + t.value.toLowerCase(), a = (e.activeOptionIndex !== null ? e.options.slice(e.activeOptionIndex + o).concat(e.options.slice(0, e.activeOptionIndex + o)) : e.options).find(function(s) {
            var u;
            return !s.dataRef.current.disabled && ((u = s.dataRef.current.textValue) == null ? void 0 : u.startsWith(l));
        }), i = a ? e.options.indexOf(a) : -1;
        return i === -1 || i === e.activeOptionIndex ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            searchQuery: l
        }) : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            searchQuery: l,
            activeOptionIndex: i,
            activationTrigger: 1
        });
    },
    [4] (e) {
        return e.dataRef.current.disabled || e.listboxState === 1 || e.searchQuery === "" ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            searchQuery: ""
        });
    },
    [5]: function(e, t) {
        var n = {
            id: t.id,
            dataRef: t.dataRef
        }, o = sn(e, function(l) {
            return (0, _toConsumableArray._)(l).concat([
                n
            ]);
        });
        return e.activeOptionIndex === null && e.dataRef.current.isSelected(t.dataRef.current.value) && (o.activeOptionIndex = o.options.indexOf(n)), (0, _objectSpread._)({}, e, o);
    },
    [6]: function(e, t) {
        var n = sn(e, function(o) {
            var l = o.findIndex(function(r) {
                return r.id === t.id;
            });
            return l !== -1 && o.splice(l, 1), o;
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e, n), {
            activationTrigger: 1
        });
    },
    [7]: function(e, t) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            labelId: t.id
        });
    }
}, un = (0, K.createContext)(null);
un.displayName = "ListboxActionsContext";
function gt(e) {
    var t = (0, K.useContext)(un);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, gt), n;
    }
    return t;
}
var pn = (0, K.createContext)(null);
pn.displayName = "ListboxDataContext";
function Pt(e) {
    var t = (0, K.useContext)(pn);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Listbox /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, Pt), n;
    }
    return t;
}
function Fa(e, t) {
    return I(t.type, Ia, e, t);
}
var Ma = K.Fragment;
function wa(e, t) {
    var n = e.value, o = e.defaultValue, l = e.form, r = e.name, a = e.onChange, tmp = e.by, i = tmp === void 0 ? function(O, w) {
        return O === w;
    } : tmp, tmp1 = e.disabled, s = tmp1 === void 0 ? !1 : tmp1, tmp2 = e.horizontal, u = tmp2 === void 0 ? !1 : tmp2, tmp3 = e.multiple, f = tmp3 === void 0 ? !1 : tmp3, p = (0, _objectWithoutProperties._)(e, [
        "value",
        "defaultValue",
        "form",
        "name",
        "onChange",
        "by",
        "disabled",
        "horizontal",
        "multiple"
    ]), g = u ? "horizontal" : "vertical", b = _(t), _He = (0, _slicedToArray._)(He(n, a, o), 2), tmp4 = _He[0], d = tmp4 === void 0 ? f ? [] : void 0 : tmp4, c = _He[1], _ref = (0, _slicedToArray._)((0, K.useReducer)(Fa, {
        dataRef: (0, K.createRef)(),
        listboxState: 1,
        options: [],
        searchQuery: "",
        labelId: null,
        activeOptionIndex: null,
        activationTrigger: 1
    }), 2), y = _ref[0], T = _ref[1], P = (0, K.useRef)({
        static: !1,
        hold: !1
    }), F = (0, K.useRef)(null), k = (0, K.useRef)(null), M = (0, K.useRef)(null), C = m(typeof i == "string" ? function(O, w) {
        var G = i;
        return (O == null ? void 0 : O[G]) === (w == null ? void 0 : w[G]);
    } : i), R = (0, K.useCallback)(function(O) {
        return I(v.mode, {
            [1]: function() {
                return d.some(function(w) {
                    return C(w, O);
                });
            },
            [0]: function() {
                return C(d, O);
            }
        });
    }, [
        d
    ]), v = (0, K.useMemo)(function() {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, y), {
            value: d,
            disabled: s,
            mode: f ? 1 : 0,
            orientation: g,
            compare: C,
            isSelected: R,
            optionsPropsRef: P,
            labelRef: F,
            buttonRef: k,
            optionsRef: M
        });
    }, [
        d,
        s,
        f,
        y
    ]);
    H(function() {
        y.dataRef.current = v;
    }, [
        v
    ]), Ie([
        v.buttonRef,
        v.optionsRef
    ], function(O, w) {
        var G;
        T({
            type: 1
        }), Me(w, 1) || (O.preventDefault(), (G = v.buttonRef.current) == null || G.focus());
    }, v.listboxState === 0);
    var A = (0, K.useMemo)(function() {
        return {
            open: v.listboxState === 0,
            disabled: s,
            value: d
        };
    }, [
        v,
        s,
        d
    ]), x = m(function(O) {
        var w = v.options.find(function(G) {
            return G.id === O;
        });
        w && re(w.dataRef.current.value);
    }), S = m(function() {
        if (v.activeOptionIndex !== null) {
            var _v_options_v_activeOptionIndex = v.options[v.activeOptionIndex], O = _v_options_v_activeOptionIndex.dataRef, w = _v_options_v_activeOptionIndex.id;
            re(O.current.value), T({
                type: 2,
                focus: 4,
                id: w
            });
        }
    }), E = m(function() {
        return T({
            type: 0
        });
    }), L = m(function() {
        return T({
            type: 1
        });
    }), J = m(function(O, w, G) {
        return O === 4 ? T({
            type: 2,
            focus: 4,
            id: w,
            trigger: G
        }) : T({
            type: 2,
            focus: O,
            trigger: G
        });
    }), X = m(function(O, w) {
        return T({
            type: 5,
            id: O,
            dataRef: w
        }), function() {
            return T({
                type: 6,
                id: O
            });
        };
    }), pe = m(function(O) {
        return T({
            type: 7,
            id: O
        }), function() {
            return T({
                type: 7,
                id: null
            });
        };
    }), re = m(function(O) {
        return I(v.mode, {
            [0] () {
                return c == null ? void 0 : c(O);
            },
            [1] () {
                var w = v.value.slice(), G = w.findIndex(function(te) {
                    return C(te, O);
                });
                return G === -1 ? w.push(O) : w.splice(G, 1), c == null ? void 0 : c(w);
            }
        });
    }), ce = m(function(O) {
        return T({
            type: 3,
            value: O
        });
    }), U = m(function() {
        return T({
            type: 4
        });
    }), Z = (0, K.useMemo)(function() {
        return {
            onChange: re,
            registerOption: X,
            registerLabel: pe,
            goToOption: J,
            closeListbox: L,
            openListbox: E,
            selectActiveOption: S,
            selectOption: x,
            search: ce,
            clearSearch: U
        };
    }, []), $ = {
        ref: b
    }, de = (0, K.useRef)(null), me = le();
    return (0, K.useEffect)(function() {
        de.current && o !== void 0 && me.addEventListener(de.current, "reset", function() {
            re(o);
        });
    }, [
        de,
        re
    ]), K.default.createElement(un.Provider, {
        value: Z
    }, K.default.createElement(pn.Provider, {
        value: v
    }, K.default.createElement(Se, {
        value: I(v.listboxState, {
            [0]: 1,
            [1]: 2
        })
    }, r != null && d != null && Ue({
        [r]: d
    }).map(function(param, G) {
        var _param = (0, _slicedToArray._)(param, 2), O = _param[0], w = _param[1];
        return K.default.createElement(ue, (0, _objectSpread._)({
            features: 4,
            ref: G === 0 ? function(te) {
                var se;
                de.current = (se = te == null ? void 0 : te.closest("form")) != null ? se : null;
            } : void 0
        }, Fe({
            key: O,
            as: "input",
            type: "hidden",
            hidden: !0,
            readOnly: !0,
            form: l,
            name: O,
            value: w
        })));
    }), h({
        ourProps: $,
        theirProps: p,
        slot: A,
        defaultTag: Ma,
        name: "Listbox"
    }))));
}
var _a = "button";
function Ha(e, t) {
    var c;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-listbox-button-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), r = Pt("Listbox.Button"), a = gt("Listbox.Button"), i = _(r.buttonRef, t), s = le(), u = m(function(y) {
        switch(y.key){
            case " ":
            case "Enter":
            case "ArrowDown":
                y.preventDefault(), a.openListbox(), s.nextFrame(function() {
                    r.value || a.goToOption(0);
                });
                break;
            case "ArrowUp":
                y.preventDefault(), a.openListbox(), s.nextFrame(function() {
                    r.value || a.goToOption(3);
                });
                break;
        }
    }), f = m(function(y) {
        switch(y.key){
            case " ":
                y.preventDefault();
                break;
        }
    }), p = m(function(y) {
        if (fe(y.currentTarget)) return y.preventDefault();
        r.listboxState === 0 ? (a.closeListbox(), s.nextFrame(function() {
            var T;
            return (T = r.buttonRef.current) == null ? void 0 : T.focus({
                preventScroll: !0
            });
        })) : (y.preventDefault(), a.openListbox());
    }), g = Ge(function() {
        if (r.labelId) return [
            r.labelId,
            o
        ].join(" ");
    }, [
        r.labelId,
        o
    ]), b = (0, K.useMemo)(function() {
        return {
            open: r.listboxState === 0,
            disabled: r.disabled,
            value: r.value
        };
    }, [
        r
    ]), d = {
        ref: i,
        id: o,
        type: Ee(e, r.buttonRef),
        "aria-haspopup": "listbox",
        "aria-controls": (c = r.optionsRef.current) == null ? void 0 : c.id,
        "aria-expanded": r.disabled ? void 0 : r.listboxState === 0,
        "aria-labelledby": g,
        disabled: r.disabled,
        onKeyDown: u,
        onKeyUp: f,
        onClick: p
    };
    return h({
        ourProps: d,
        theirProps: l,
        slot: b,
        defaultTag: _a,
        name: "Listbox.Button"
    });
}
var ka = "label";
function Na(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-listbox-label-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), r = Pt("Listbox.Label"), a = gt("Listbox.Label"), i = _(r.labelRef, t);
    H(function() {
        return a.registerLabel(o);
    }, [
        o
    ]);
    var s = m(function() {
        var p;
        return (p = r.buttonRef.current) == null ? void 0 : p.focus({
            preventScroll: !0
        });
    }), u = (0, K.useMemo)(function() {
        return {
            open: r.listboxState === 0,
            disabled: r.disabled
        };
    }, [
        r
    ]);
    return h({
        ourProps: {
            ref: i,
            id: o,
            onClick: s
        },
        theirProps: l,
        slot: u,
        defaultTag: ka,
        name: "Listbox.Label"
    });
}
var Ga = "ul", Ua = 3;
function Ba(e, t) {
    var y;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-listbox-options-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), r = Pt("Listbox.Options"), a = gt("Listbox.Options"), i = _(r.optionsRef, t), s = le(), u = le(), f = ye(), p = function() {
        return f !== null ? (f & 1) === 1 : r.listboxState === 0;
    }();
    (0, K.useEffect)(function() {
        var P;
        var T = r.optionsRef.current;
        T && r.listboxState === 0 && T !== ((P = be(T)) == null ? void 0 : P.activeElement) && T.focus({
            preventScroll: !0
        });
    }, [
        r.listboxState,
        r.optionsRef
    ]);
    var g = m(function(T) {
        switch(u.dispose(), T.key){
            case " ":
                if (r.searchQuery !== "") return T.preventDefault(), T.stopPropagation(), a.search(T.key);
            case "Enter":
                if (T.preventDefault(), T.stopPropagation(), r.activeOptionIndex !== null) {
                    var _r_options_r_activeOptionIndex = r.options[r.activeOptionIndex], P = _r_options_r_activeOptionIndex.dataRef;
                    a.onChange(P.current.value);
                }
                r.mode === 0 && (a.closeListbox(), ae().nextFrame(function() {
                    var P;
                    return (P = r.buttonRef.current) == null ? void 0 : P.focus({
                        preventScroll: !0
                    });
                }));
                break;
            case I(r.orientation, {
                vertical: "ArrowDown",
                horizontal: "ArrowRight"
            }):
                return T.preventDefault(), T.stopPropagation(), a.goToOption(2);
            case I(r.orientation, {
                vertical: "ArrowUp",
                horizontal: "ArrowLeft"
            }):
                return T.preventDefault(), T.stopPropagation(), a.goToOption(1);
            case "Home":
            case "PageUp":
                return T.preventDefault(), T.stopPropagation(), a.goToOption(0);
            case "End":
            case "PageDown":
                return T.preventDefault(), T.stopPropagation(), a.goToOption(3);
            case "Escape":
                return T.preventDefault(), T.stopPropagation(), a.closeListbox(), s.nextFrame(function() {
                    var P;
                    return (P = r.buttonRef.current) == null ? void 0 : P.focus({
                        preventScroll: !0
                    });
                });
            case "Tab":
                T.preventDefault(), T.stopPropagation();
                break;
            default:
                T.key.length === 1 && (a.search(T.key), u.setTimeout(function() {
                    return a.clearSearch();
                }, 350));
                break;
        }
    }), b = Ge(function() {
        var T, P, F;
        return (F = (T = r.labelRef.current) == null ? void 0 : T.id) != null ? F : (P = r.buttonRef.current) == null ? void 0 : P.id;
    }, [
        r.labelRef.current,
        r.buttonRef.current
    ]), d = (0, K.useMemo)(function() {
        return {
            open: r.listboxState === 0
        };
    }, [
        r
    ]), c = {
        "aria-activedescendant": r.activeOptionIndex === null || (y = r.options[r.activeOptionIndex]) == null ? void 0 : y.id,
        "aria-multiselectable": r.mode === 1 ? !0 : void 0,
        "aria-labelledby": b,
        "aria-orientation": r.orientation,
        id: o,
        onKeyDown: g,
        role: "listbox",
        tabIndex: 0,
        ref: i
    };
    return h({
        ourProps: c,
        theirProps: l,
        slot: d,
        defaultTag: Ga,
        features: Ua,
        visible: p,
        name: "Listbox.Options"
    });
}
var Va = "li";
function ja(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-listbox-option-${n}` : tmp, tmp1 = e.disabled, l = tmp1 === void 0 ? !1 : tmp1, r = e.value, a = (0, _objectWithoutProperties._)(e, [
        "id",
        "disabled",
        "value"
    ]), i = Pt("Listbox.Option"), s = gt("Listbox.Option"), u = i.activeOptionIndex !== null ? i.options[i.activeOptionIndex].id === o : !1, f = i.isSelected(r), p = (0, K.useRef)(null), g = Y({
        disabled: l,
        value: r,
        domRef: p,
        get textValue () {
            var C, R;
            return (R = (C = p.current) == null ? void 0 : C.textContent) == null ? void 0 : R.toLowerCase();
        }
    }), b = _(t, p);
    H(function() {
        if (i.listboxState !== 0 || !u || i.activationTrigger === 0) return;
        var C = ae();
        return C.requestAnimationFrame(function() {
            var R, v;
            (v = (R = p.current) == null ? void 0 : R.scrollIntoView) == null || v.call(R, {
                block: "nearest"
            });
        }), C.dispose;
    }, [
        p,
        u,
        i.listboxState,
        i.activationTrigger,
        i.activeOptionIndex
    ]), H(function() {
        return s.registerOption(o, g);
    }, [
        g,
        o
    ]);
    var d = m(function(C) {
        if (l) return C.preventDefault();
        s.onChange(r), i.mode === 0 && (s.closeListbox(), ae().nextFrame(function() {
            var R;
            return (R = i.buttonRef.current) == null ? void 0 : R.focus({
                preventScroll: !0
            });
        }));
    }), c = m(function() {
        if (l) return s.goToOption(5);
        s.goToOption(4, o);
    }), y = et(), T = m(function(C) {
        return y.update(C);
    }), P = m(function(C) {
        y.wasMoved(C) && (l || u || s.goToOption(4, o, 0));
    }), F = m(function(C) {
        y.wasMoved(C) && (l || u && s.goToOption(5));
    }), k = (0, K.useMemo)(function() {
        return {
            active: u,
            selected: f,
            disabled: l
        };
    }, [
        u,
        f,
        l
    ]);
    return h({
        ourProps: {
            id: o,
            ref: b,
            role: "option",
            tabIndex: l === !0 ? void 0 : -1,
            "aria-disabled": l === !0 ? !0 : void 0,
            "aria-selected": f,
            disabled: void 0,
            onClick: d,
            onFocus: c,
            onPointerEnter: T,
            onMouseEnter: T,
            onPointerMove: P,
            onMouseMove: P,
            onPointerLeave: F,
            onMouseLeave: F
        },
        theirProps: a,
        slot: k,
        defaultTag: Va,
        name: "Listbox.Option"
    });
}
var Wa = D(wa), Ka = D(Ha), Xa = D(Na), $a = D(Ba), Ja = D(ja), qa = Object.assign(Wa, {
    Button: Ka,
    Label: Xa,
    Options: $a,
    Option: Ja
});
var ee = ne(require("79aad0578ed312fe"), 1);
function dn(e) {
    var t = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : function(n) {
        return n;
    };
    var n = e.activeItemIndex !== null ? e.items[e.activeItemIndex] : null, o = ge(t(e.items.slice()), function(r) {
        return r.dataRef.current.domRef.current;
    }), l = n ? o.indexOf(n) : null;
    return l === -1 && (l = null), {
        items: o,
        activeItemIndex: l
    };
}
var Ya = {
    [1] (e) {
        return e.menuState === 1 ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            activeItemIndex: null,
            menuState: 1
        });
    },
    [0] (e) {
        return e.menuState === 0 ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            menuState: 0
        });
    },
    [2]: function(e, t) {
        var l;
        var n = dn(e), o = Qe(t, {
            resolveItems: function() {
                return n.items;
            },
            resolveActiveIndex: function() {
                return n.activeItemIndex;
            },
            resolveId: function(r) {
                return r.id;
            },
            resolveDisabled: function(r) {
                return r.dataRef.current.disabled;
            }
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e, n), {
            searchQuery: "",
            activeItemIndex: o,
            activationTrigger: (l = t.trigger) != null ? l : 1
        });
    },
    [3]: function(e, t) {
        var o = e.searchQuery !== "" ? 0 : 1, l = e.searchQuery + t.value.toLowerCase(), a = (e.activeItemIndex !== null ? e.items.slice(e.activeItemIndex + o).concat(e.items.slice(0, e.activeItemIndex + o)) : e.items).find(function(s) {
            var u;
            return ((u = s.dataRef.current.textValue) == null ? void 0 : u.startsWith(l)) && !s.dataRef.current.disabled;
        }), i = a ? e.items.indexOf(a) : -1;
        return i === -1 || i === e.activeItemIndex ? (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            searchQuery: l
        }) : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            searchQuery: l,
            activeItemIndex: i,
            activationTrigger: 1
        });
    },
    [4] (e) {
        return e.searchQuery === "" ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            searchQuery: "",
            searchActiveItemIndex: null
        });
    },
    [5]: function(e, t) {
        var n = dn(e, function(o) {
            return (0, _toConsumableArray._)(o).concat([
                {
                    id: t.id,
                    dataRef: t.dataRef
                }
            ]);
        });
        return (0, _objectSpread._)({}, e, n);
    },
    [6]: function(e, t) {
        var n = dn(e, function(o) {
            var l = o.findIndex(function(r) {
                return r.id === t.id;
            });
            return l !== -1 && o.splice(l, 1), o;
        });
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e, n), {
            activationTrigger: 1
        });
    }
}, cn = (0, ee.createContext)(null);
cn.displayName = "MenuContext";
function Ft(e) {
    var t = (0, ee.useContext)(cn);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Menu /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, Ft), n;
    }
    return t;
}
function Qa(e, t) {
    return I(t.type, Ya, e, t);
}
var za = ee.Fragment;
function Za(e, t) {
    var n = (0, ee.useReducer)(Qa, {
        menuState: 1,
        buttonRef: (0, ee.createRef)(),
        itemsRef: (0, ee.createRef)(),
        items: [],
        searchQuery: "",
        activeItemIndex: null,
        activationTrigger: 1
    }), _n = (0, _slicedToArray._)(n, 2), _n_ = _n[0], o = _n_.menuState, l = _n_.itemsRef, r = _n_.buttonRef, a = _n[1], i = _(t);
    Ie([
        r,
        l
    ], function(g, b) {
        var d;
        a({
            type: 1
        }), Me(b, 1) || (g.preventDefault(), (d = r.current) == null || d.focus());
    }, o === 0);
    var s = m(function() {
        a({
            type: 1
        });
    }), u = (0, ee.useMemo)(function() {
        return {
            open: o === 0,
            close: s
        };
    }, [
        o,
        s
    ]), f = e, p = {
        ref: i
    };
    return ee.default.createElement(cn.Provider, {
        value: n
    }, ee.default.createElement(Se, {
        value: I(o, {
            [0]: 1,
            [1]: 2
        })
    }, h({
        ourProps: p,
        theirProps: f,
        slot: u,
        defaultTag: za,
        name: "Menu"
    })));
}
var el = "button";
function tl(e, t) {
    var d;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-menu-button-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _Ft = (0, _slicedToArray._)(Ft("Menu.Button"), 2), r = _Ft[0], a = _Ft[1], i = _(r.buttonRef, t), s = le(), u = m(function(c) {
        switch(c.key){
            case " ":
            case "Enter":
            case "ArrowDown":
                c.preventDefault(), c.stopPropagation(), a({
                    type: 0
                }), s.nextFrame(function() {
                    return a({
                        type: 2,
                        focus: 0
                    });
                });
                break;
            case "ArrowUp":
                c.preventDefault(), c.stopPropagation(), a({
                    type: 0
                }), s.nextFrame(function() {
                    return a({
                        type: 2,
                        focus: 3
                    });
                });
                break;
        }
    }), f = m(function(c) {
        switch(c.key){
            case " ":
                c.preventDefault();
                break;
        }
    }), p = m(function(c) {
        if (fe(c.currentTarget)) return c.preventDefault();
        e.disabled || (r.menuState === 0 ? (a({
            type: 1
        }), s.nextFrame(function() {
            var y;
            return (y = r.buttonRef.current) == null ? void 0 : y.focus({
                preventScroll: !0
            });
        })) : (c.preventDefault(), a({
            type: 0
        })));
    }), g = (0, ee.useMemo)(function() {
        return {
            open: r.menuState === 0
        };
    }, [
        r
    ]), b = {
        ref: i,
        id: o,
        type: Ee(e, r.buttonRef),
        "aria-haspopup": "menu",
        "aria-controls": (d = r.itemsRef.current) == null ? void 0 : d.id,
        "aria-expanded": e.disabled ? void 0 : r.menuState === 0,
        onKeyDown: u,
        onKeyUp: f,
        onClick: p
    };
    return h({
        ourProps: b,
        theirProps: l,
        slot: g,
        defaultTag: el,
        name: "Menu.Button"
    });
}
var nl = "div", ol = 3;
function rl(e, t) {
    var y, T;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-menu-items-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _Ft = (0, _slicedToArray._)(Ft("Menu.Items"), 2), r = _Ft[0], a = _Ft[1], i = _(r.itemsRef, t), s = xe(r.itemsRef), u = le(), f = ye(), p = function() {
        return f !== null ? (f & 1) === 1 : r.menuState === 0;
    }();
    (0, ee.useEffect)(function() {
        var P = r.itemsRef.current;
        P && r.menuState === 0 && P !== (s == null ? void 0 : s.activeElement) && P.focus({
            preventScroll: !0
        });
    }, [
        r.menuState,
        r.itemsRef,
        s
    ]), Ye({
        container: r.itemsRef.current,
        enabled: r.menuState === 0,
        accept (P) {
            return P.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : P.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (P) {
            P.setAttribute("role", "none");
        }
    });
    var g = m(function(P) {
        var F, k;
        switch(u.dispose(), P.key){
            case " ":
                if (r.searchQuery !== "") return P.preventDefault(), P.stopPropagation(), a({
                    type: 3,
                    value: P.key
                });
            case "Enter":
                if (P.preventDefault(), P.stopPropagation(), a({
                    type: 1
                }), r.activeItemIndex !== null) {
                    var _r_items_r_activeItemIndex = r.items[r.activeItemIndex], M = _r_items_r_activeItemIndex.dataRef;
                    (k = (F = M.current) == null ? void 0 : F.domRef.current) == null || k.click();
                }
                Wt(r.buttonRef.current);
                break;
            case "ArrowDown":
                return P.preventDefault(), P.stopPropagation(), a({
                    type: 2,
                    focus: 2
                });
            case "ArrowUp":
                return P.preventDefault(), P.stopPropagation(), a({
                    type: 2,
                    focus: 1
                });
            case "Home":
            case "PageUp":
                return P.preventDefault(), P.stopPropagation(), a({
                    type: 2,
                    focus: 0
                });
            case "End":
            case "PageDown":
                return P.preventDefault(), P.stopPropagation(), a({
                    type: 2,
                    focus: 3
                });
            case "Escape":
                P.preventDefault(), P.stopPropagation(), a({
                    type: 1
                }), ae().nextFrame(function() {
                    var M;
                    return (M = r.buttonRef.current) == null ? void 0 : M.focus({
                        preventScroll: !0
                    });
                });
                break;
            case "Tab":
                P.preventDefault(), P.stopPropagation(), a({
                    type: 1
                }), ae().nextFrame(function() {
                    Fn(r.buttonRef.current, P.shiftKey ? 2 : 4);
                });
                break;
            default:
                P.key.length === 1 && (a({
                    type: 3,
                    value: P.key
                }), u.setTimeout(function() {
                    return a({
                        type: 4
                    });
                }, 350));
                break;
        }
    }), b = m(function(P) {
        switch(P.key){
            case " ":
                P.preventDefault();
                break;
        }
    }), d = (0, ee.useMemo)(function() {
        return {
            open: r.menuState === 0
        };
    }, [
        r
    ]), c = {
        "aria-activedescendant": r.activeItemIndex === null || (y = r.items[r.activeItemIndex]) == null ? void 0 : y.id,
        "aria-labelledby": (T = r.buttonRef.current) == null ? void 0 : T.id,
        id: o,
        onKeyDown: g,
        onKeyUp: b,
        role: "menu",
        tabIndex: 0,
        ref: i
    };
    return h({
        ourProps: c,
        theirProps: l,
        slot: d,
        defaultTag: nl,
        features: ol,
        visible: p,
        name: "Menu.Items"
    });
}
var al = ee.Fragment;
function ll(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-menu-item-${n}` : tmp, tmp1 = e.disabled, l = tmp1 === void 0 ? !1 : tmp1, r = (0, _objectWithoutProperties._)(e, [
        "id",
        "disabled"
    ]), _Ft = (0, _slicedToArray._)(Ft("Menu.Item"), 2), a = _Ft[0], i = _Ft[1], s = a.activeItemIndex !== null ? a.items[a.activeItemIndex].id === o : !1, u = (0, ee.useRef)(null), f = _(t, u);
    H(function() {
        if (a.menuState !== 0 || !s || a.activationTrigger === 0) return;
        var M = ae();
        return M.requestAnimationFrame(function() {
            var C, R;
            (R = (C = u.current) == null ? void 0 : C.scrollIntoView) == null || R.call(C, {
                block: "nearest"
            });
        }), M.dispose;
    }, [
        u,
        s,
        a.menuState,
        a.activationTrigger,
        a.activeItemIndex
    ]);
    var p = (0, ee.useRef)({
        disabled: l,
        domRef: u
    });
    H(function() {
        p.current.disabled = l;
    }, [
        p,
        l
    ]), H(function() {
        var M, C;
        p.current.textValue = (C = (M = u.current) == null ? void 0 : M.textContent) == null ? void 0 : C.toLowerCase();
    }, [
        p,
        u
    ]), H(function() {
        return i({
            type: 5,
            id: o,
            dataRef: p
        }), function() {
            return i({
                type: 6,
                id: o
            });
        };
    }, [
        p,
        o
    ]);
    var g = m(function() {
        i({
            type: 1
        });
    }), b = m(function(M) {
        if (l) return M.preventDefault();
        i({
            type: 1
        }), Wt(a.buttonRef.current);
    }), d = m(function() {
        if (l) return i({
            type: 2,
            focus: 5
        });
        i({
            type: 2,
            focus: 4,
            id: o
        });
    }), c = et(), y = m(function(M) {
        return c.update(M);
    }), T = m(function(M) {
        c.wasMoved(M) && (l || s || i({
            type: 2,
            focus: 4,
            id: o,
            trigger: 0
        }));
    }), P = m(function(M) {
        c.wasMoved(M) && (l || s && i({
            type: 2,
            focus: 5
        }));
    }), F = (0, ee.useMemo)(function() {
        return {
            active: s,
            disabled: l,
            close: g
        };
    }, [
        s,
        l,
        g
    ]);
    return h({
        ourProps: {
            id: o,
            ref: f,
            role: "menuitem",
            tabIndex: l === !0 ? void 0 : -1,
            "aria-disabled": l === !0 ? !0 : void 0,
            disabled: void 0,
            onClick: b,
            onFocus: d,
            onPointerEnter: y,
            onMouseEnter: y,
            onPointerMove: T,
            onMouseMove: T,
            onPointerLeave: P,
            onMouseLeave: P
        },
        theirProps: r,
        slot: F,
        defaultTag: al,
        name: "Menu.Item"
    });
}
var il = D(Za), sl = D(tl), ul = D(rl), pl = D(ll), dl = Object.assign(il, {
    Button: sl,
    Items: ul,
    Item: pl
});
var N = ne(require("79aad0578ed312fe"), 1);
var cl = {
    [0]: function(e) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            popoverState: I(e.popoverState, {
                [0]: 1,
                [1]: 0
            })
        });
    },
    [1] (e) {
        return e.popoverState === 1 ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            popoverState: 1
        });
    },
    [2] (e, t) {
        return e.button === t.button ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            button: t.button
        });
    },
    [3] (e, t) {
        return e.buttonId === t.buttonId ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            buttonId: t.buttonId
        });
    },
    [4] (e, t) {
        return e.panel === t.panel ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            panel: t.panel
        });
    },
    [5] (e, t) {
        return e.panelId === t.panelId ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            panelId: t.panelId
        });
    }
}, fn = (0, N.createContext)(null);
fn.displayName = "PopoverContext";
function Mt(e) {
    var t = (0, N.useContext)(fn);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, Mt), n;
    }
    return t;
}
var Tn = (0, N.createContext)(null);
Tn.displayName = "PopoverAPIContext";
function mn(e) {
    var t = (0, N.useContext)(Tn);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Popover /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, mn), n;
    }
    return t;
}
var bn = (0, N.createContext)(null);
bn.displayName = "PopoverGroupContext";
function vo() {
    return (0, N.useContext)(bn);
}
var wt = (0, N.createContext)(null);
wt.displayName = "PopoverPanelContext";
function fl() {
    return (0, N.useContext)(wt);
}
function Tl(e, t) {
    return I(t.type, cl, e, t);
}
var ml = "div";
function bl(e, t) {
    var S;
    var n = (0, N.useRef)(null), o = _(t, qe(function(E) {
        n.current = E;
    })), l = (0, N.useRef)([]), r = (0, N.useReducer)(Tl, {
        popoverState: 1,
        buttons: l,
        button: null,
        buttonId: null,
        panel: null,
        panelId: null,
        beforePanelSentinel: (0, N.createRef)(),
        afterPanelSentinel: (0, N.createRef)()
    }), _r = (0, _slicedToArray._)(r, 2), _r_ = _r[0], a = _r_.popoverState, i = _r_.button, s = _r_.buttonId, u = _r_.panel, f = _r_.panelId, p = _r_.beforePanelSentinel, g = _r_.afterPanelSentinel, b = _r[1], d = xe((S = n.current) != null ? S : i), c = (0, N.useMemo)(function() {
        if (!i || !u) return !1;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = document.querySelectorAll("body > *")[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var ce = _step.value;
                if (Number(ce == null ? void 0 : ce.contains(i)) ^ Number(ce == null ? void 0 : ce.contains(u))) return !0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var E = Je(), L = E.indexOf(i), J = (L + E.length - 1) % E.length, X = (L + 1) % E.length, pe = E[J], re = E[X];
        return !u.contains(pe) && !u.contains(re);
    }, [
        i,
        u
    ]), y = Y(s), T = Y(f), P = (0, N.useMemo)(function() {
        return {
            buttonId: y,
            panelId: T,
            close: function() {
                return b({
                    type: 1
                });
            }
        };
    }, [
        y,
        T,
        b
    ]), F = vo(), k = F == null ? void 0 : F.registerPopover, M = m(function() {
        var E;
        return (E = F == null ? void 0 : F.isFocusWithinPopoverGroup()) != null ? E : (d == null ? void 0 : d.activeElement) && ((i == null ? void 0 : i.contains(d.activeElement)) || (u == null ? void 0 : u.contains(d.activeElement)));
    });
    (0, N.useEffect)(function() {
        return k == null ? void 0 : k(P);
    }, [
        k,
        P
    ]), ot(d == null ? void 0 : d.defaultView, "focus", function(E) {
        var L, J, X, pe;
        a === 0 && (M() || i && u && E.target !== window && ((J = (L = p.current) == null ? void 0 : L.contains) != null && J.call(L, E.target) || (pe = (X = g.current) == null ? void 0 : X.contains) != null && pe.call(X, E.target) || b({
            type: 1
        })));
    }, !0), Ie([
        i,
        u
    ], function(E, L) {
        b({
            type: 1
        }), Me(L, 1) || (E.preventDefault(), i == null || i.focus());
    }, a === 0);
    var C = m(function(E) {
        b({
            type: 1
        });
        var L = function() {
            return E ? E instanceof HTMLElement ? E : "current" in E && E.current instanceof HTMLElement ? E.current : i : i;
        }();
        L == null || L.focus();
    }), R = (0, N.useMemo)(function() {
        return {
            close: C,
            isPortalled: c
        };
    }, [
        C,
        c
    ]), v = (0, N.useMemo)(function() {
        return {
            open: a === 0,
            close: C
        };
    }, [
        a,
        C
    ]), A = e, x = {
        ref: o
    };
    return N.default.createElement(wt.Provider, {
        value: null
    }, N.default.createElement(fn.Provider, {
        value: r
    }, N.default.createElement(Tn.Provider, {
        value: R
    }, N.default.createElement(Se, {
        value: I(a, {
            [0]: 1,
            [1]: 2
        })
    }, h({
        ourProps: x,
        theirProps: A,
        slot: v,
        defaultTag: ml,
        name: "Popover"
    })))));
}
var yl = "button";
function gl(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-popover-button-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _Mt = (0, _slicedToArray._)(Mt("Popover.Button"), 2), r = _Mt[0], a = _Mt[1], _mn = mn("Popover.Button"), i = _mn.isPortalled, s = (0, N.useRef)(null), u = `headlessui-focus-sentinel-${j()}`, f = vo(), p = f == null ? void 0 : f.closeOthers, b = fl() !== null;
    (0, N.useEffect)(function() {
        if (!b) return a({
            type: 3,
            buttonId: o
        }), function() {
            a({
                type: 3,
                buttonId: null
            });
        };
    }, [
        b,
        o,
        a
    ]);
    var _ref = (0, _slicedToArray._)((0, N.useState)(function() {
        return Symbol();
    }), 1), d = _ref[0], c = _(s, t, b ? null : function(E) {
        if (E) r.buttons.current.push(d);
        else {
            var L = r.buttons.current.indexOf(d);
            L !== -1 && r.buttons.current.splice(L, 1);
        }
        r.buttons.current.length > 1 && console.warn("You are already using a <Popover.Button /> but only 1 <Popover.Button /> is supported."), E && a({
            type: 2,
            button: E
        });
    }), y = _(s, t), T = xe(s), P = m(function(E) {
        var L, J, X;
        if (b) {
            if (r.popoverState === 1) return;
            switch(E.key){
                case " ":
                case "Enter":
                    E.preventDefault(), (J = (L = E.target).click) == null || J.call(L), a({
                        type: 1
                    }), (X = r.button) == null || X.focus();
                    break;
            }
        } else switch(E.key){
            case " ":
            case "Enter":
                E.preventDefault(), E.stopPropagation(), r.popoverState === 1 && (p == null || p(r.buttonId)), a({
                    type: 0
                });
                break;
            case "Escape":
                if (r.popoverState !== 0) return p == null ? void 0 : p(r.buttonId);
                if (!s.current || T != null && T.activeElement && !s.current.contains(T.activeElement)) return;
                E.preventDefault(), E.stopPropagation(), a({
                    type: 1
                });
                break;
        }
    }), F = m(function(E) {
        b || E.key === " " && E.preventDefault();
    }), k = m(function(E) {
        var L, J;
        fe(E.currentTarget) || e.disabled || (b ? (a({
            type: 1
        }), (L = r.button) == null || L.focus()) : (E.preventDefault(), E.stopPropagation(), r.popoverState === 1 && (p == null || p(r.buttonId)), a({
            type: 0
        }), (J = r.button) == null || J.focus()));
    }), M = m(function(E) {
        E.preventDefault(), E.stopPropagation();
    }), C = r.popoverState === 0, R = (0, N.useMemo)(function() {
        return {
            open: C
        };
    }, [
        C
    ]), v = Ee(e, s), A = b ? {
        ref: y,
        type: v,
        onKeyDown: P,
        onClick: k
    } : {
        ref: c,
        id: r.buttonId,
        type: v,
        "aria-expanded": e.disabled ? void 0 : r.popoverState === 0,
        "aria-controls": r.panel ? r.panelId : void 0,
        onKeyDown: P,
        onKeyUp: F,
        onClick: k,
        onMouseDown: M
    }, x = Tt(), S = m(function() {
        var L = function L() {
            I(x.current, {
                [0]: function() {
                    return oe(E, 1);
                },
                [1]: function() {
                    return oe(E, 8);
                }
            }) === 0 && oe(Je().filter(function(X) {
                return X.dataset.headlessuiFocusGuard !== "true";
            }), I(x.current, {
                [0]: 4,
                [1]: 2
            }), {
                relativeTo: r.button
            });
        };
        var E = r.panel;
        if (!E) return;
        L();
    });
    return N.default.createElement(N.default.Fragment, null, h({
        ourProps: A,
        theirProps: l,
        slot: R,
        defaultTag: yl,
        name: "Popover.Button"
    }), C && !b && i && N.default.createElement(ue, {
        id: u,
        features: 2,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: S
    }));
}
var Pl = "div", El = 3;
function xl(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-popover-overlay-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _Mt = (0, _slicedToArray._)(Mt("Popover.Overlay"), 2), _Mt_ = _Mt[0], r = _Mt_.popoverState, a = _Mt[1], i = _(t), s = ye(), u = function() {
        return s !== null ? (s & 1) === 1 : r === 0;
    }(), f = m(function(b) {
        if (fe(b.currentTarget)) return b.preventDefault();
        a({
            type: 1
        });
    }), p = (0, N.useMemo)(function() {
        return {
            open: r === 0
        };
    }, [
        r
    ]);
    return h({
        ourProps: {
            ref: i,
            id: o,
            "aria-hidden": !0,
            onClick: f
        },
        theirProps: l,
        slot: p,
        defaultTag: Pl,
        features: El,
        visible: u,
        name: "Popover.Overlay"
    });
}
var vl = "div", Rl = 3;
function Sl(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-popover-panel-${n}` : tmp, tmp1 = e.focus, l = tmp1 === void 0 ? !1 : tmp1, r = (0, _objectWithoutProperties._)(e, [
        "id",
        "focus"
    ]), _Mt = (0, _slicedToArray._)(Mt("Popover.Panel"), 2), a = _Mt[0], i = _Mt[1], _mn = mn("Popover.Panel"), s = _mn.close, u = _mn.isPortalled, f = `headlessui-focus-sentinel-before-${j()}`, p = `headlessui-focus-sentinel-after-${j()}`, g = (0, N.useRef)(null), b = _(g, t, function(R) {
        i({
            type: 4,
            panel: R
        });
    }), d = xe(g);
    H(function() {
        return i({
            type: 5,
            panelId: o
        }), function() {
            i({
                type: 5,
                panelId: null
            });
        };
    }, [
        o,
        i
    ]);
    var c = ye(), y = function() {
        return c !== null ? (c & 1) === 1 : a.popoverState === 0;
    }(), T = m(function(R) {
        var v;
        switch(R.key){
            case "Escape":
                if (a.popoverState !== 0 || !g.current || d != null && d.activeElement && !g.current.contains(d.activeElement)) return;
                R.preventDefault(), R.stopPropagation(), i({
                    type: 1
                }), (v = a.button) == null || v.focus();
                break;
        }
    });
    (0, N.useEffect)(function() {
        var R;
        e.static || a.popoverState === 1 && ((R = e.unmount) == null || R) && i({
            type: 4,
            panel: null
        });
    }, [
        a.popoverState,
        e.unmount,
        e.static,
        i
    ]), (0, N.useEffect)(function() {
        if (!l || a.popoverState !== 0 || !g.current) return;
        var R = d == null ? void 0 : d.activeElement;
        g.current.contains(R) || oe(g.current, 1);
    }, [
        l,
        g,
        a.popoverState
    ]);
    var P = (0, N.useMemo)(function() {
        return {
            open: a.popoverState === 0,
            close: s
        };
    }, [
        a,
        s
    ]), F = {
        ref: b,
        id: o,
        onKeyDown: T,
        onBlur: l && a.popoverState === 0 ? function(R) {
            var A, x, S, E, L;
            var v = R.relatedTarget;
            v && g.current && ((A = g.current) != null && A.contains(v) || (i({
                type: 1
            }), ((S = (x = a.beforePanelSentinel.current) == null ? void 0 : x.contains) != null && S.call(x, v) || (L = (E = a.afterPanelSentinel.current) == null ? void 0 : E.contains) != null && L.call(E, v)) && v.focus({
                preventScroll: !0
            })));
        } : void 0,
        tabIndex: -1
    }, k = Tt(), M = m(function() {
        var v = function v() {
            I(k.current, {
                [0]: function() {
                    var x;
                    oe(R, 1) === 0 && ((x = a.afterPanelSentinel.current) == null || x.focus());
                },
                [1]: function() {
                    var A;
                    (A = a.button) == null || A.focus({
                        preventScroll: !0
                    });
                }
            });
        };
        var R = g.current;
        if (!R) return;
        v();
    }), C = m(function() {
        var v = function v() {
            I(k.current, {
                [0]: function() {
                    var J;
                    if (!a.button) return;
                    var A = Je(), x = A.indexOf(a.button), S = A.slice(0, x + 1), L = (0, _toConsumableArray._)(A.slice(x + 1)).concat((0, _toConsumableArray._)(S));
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = L.slice()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var X = _step.value;
                            if (X.dataset.headlessuiFocusGuard === "true" || (J = a.panel) != null && J.contains(X)) {
                                var pe = L.indexOf(X);
                                pe !== -1 && L.splice(pe, 1);
                            }
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    oe(L, 1, {
                        sorted: !1
                    });
                },
                [1]: function() {
                    var x;
                    oe(R, 2) === 0 && ((x = a.button) == null || x.focus());
                }
            });
        };
        var R = g.current;
        if (!R) return;
        v();
    });
    return N.default.createElement(wt.Provider, {
        value: o
    }, y && u && N.default.createElement(ue, {
        id: f,
        ref: a.beforePanelSentinel,
        features: 2,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: M
    }), h({
        ourProps: F,
        theirProps: r,
        slot: P,
        defaultTag: vl,
        features: Rl,
        visible: y,
        name: "Popover.Panel"
    }), y && u && N.default.createElement(ue, {
        id: p,
        ref: a.afterPanelSentinel,
        features: 2,
        "data-headlessui-focus-guard": !0,
        as: "button",
        type: "button",
        onFocus: C
    }));
}
var Ol = "div";
function Al(e, t) {
    var n = (0, N.useRef)(null), o = _(n, t), _ref = (0, _slicedToArray._)((0, N.useState)([]), 2), l = _ref[0], r = _ref[1], a = m(function(d) {
        r(function(c) {
            var y = c.indexOf(d);
            if (y !== -1) {
                var T = c.slice();
                return T.splice(y, 1), T;
            }
            return c;
        });
    }), i = m(function(d) {
        return r(function(c) {
            return (0, _toConsumableArray._)(c).concat([
                d
            ]);
        }), function() {
            return a(d);
        };
    }), s = m(function() {
        var y;
        var d = be(n);
        if (!d) return !1;
        var c = d.activeElement;
        return (y = n.current) != null && y.contains(c) ? !0 : l.some(function(T) {
            var P, F;
            return ((P = d.getElementById(T.buttonId.current)) == null ? void 0 : P.contains(c)) || ((F = d.getElementById(T.panelId.current)) == null ? void 0 : F.contains(c));
        });
    }), u = m(function(d) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = l[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var c = _step.value;
                c.buttonId.current !== d && c.close();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }), f = (0, N.useMemo)(function() {
        return {
            registerPopover: i,
            unregisterPopover: a,
            isFocusWithinPopoverGroup: s,
            closeOthers: u
        };
    }, [
        i,
        a,
        s,
        u
    ]), p = (0, N.useMemo)(function() {
        return {};
    }, []), g = e, b = {
        ref: o
    };
    return N.default.createElement(bn.Provider, {
        value: f
    }, h({
        ourProps: b,
        theirProps: g,
        slot: p,
        defaultTag: Ol,
        name: "Popover.Group"
    }));
}
var Cl = D(bl), Ll = D(gl), hl = D(xl), Dl = D(Sl), Il = D(Al), Fl = Object.assign(Cl, {
    Button: Ll,
    Overlay: hl,
    Panel: Dl,
    Group: Il
});
var Q = ne(require("79aad0578ed312fe"), 1);
var Xe = require("79aad0578ed312fe");
function _t() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
    var _ref = (0, _slicedToArray._)((0, Xe.useState)(e), 2), t = _ref[0], n = _ref[1], o = _e(), l = (0, Xe.useCallback)(function(s) {
        o.current && n(function(u) {
            return u | s;
        });
    }, [
        t,
        o
    ]), r = (0, Xe.useCallback)(function(s) {
        return Boolean(t & s);
    }, [
        t
    ]), a = (0, Xe.useCallback)(function(s) {
        o.current && n(function(u) {
            return u & ~s;
        });
    }, [
        n,
        o
    ]), i = (0, Xe.useCallback)(function(s) {
        o.current && n(function(u) {
            return u ^ s;
        });
    }, [
        n
    ]);
    return {
        flags: t,
        addFlag: l,
        hasFlag: r,
        removeFlag: a,
        toggleFlag: i
    };
}
var Le = ne(require("79aad0578ed312fe"), 1);
var Ro = (0, Le.createContext)(null);
function So() {
    var e = (0, Le.useContext)(Ro);
    if (e === null) {
        var t = new Error("You used a <Label /> component, but it is not inside a relevant parent.");
        throw Error.captureStackTrace && Error.captureStackTrace(t, So), t;
    }
    return e;
}
function Et() {
    var _ref = (0, _slicedToArray._)((0, Le.useState)([]), 2), e = _ref[0], t = _ref[1];
    return [
        e.length > 0 ? e.join(" ") : void 0,
        (0, Le.useMemo)(function() {
            return function(o) {
                var l = m(function(a) {
                    return t(function(i) {
                        return (0, _toConsumableArray._)(i).concat([
                            a
                        ]);
                    }), function() {
                        return t(function(i) {
                            var s = i.slice(), u = s.indexOf(a);
                            return u !== -1 && s.splice(u, 1), s;
                        });
                    };
                }), r = (0, Le.useMemo)(function() {
                    return {
                        register: l,
                        slot: o.slot,
                        name: o.name,
                        props: o.props
                    };
                }, [
                    l,
                    o.slot,
                    o.name,
                    o.props
                ]);
                return Le.default.createElement(Ro.Provider, {
                    value: r
                }, o.children);
            };
        }, [
            t
        ])
    ];
}
var Ml = "label";
function wl(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-label-${n}` : tmp, tmp1 = e.passive, l = tmp1 === void 0 ? !1 : tmp1, r = (0, _objectWithoutProperties._)(e, [
        "id",
        "passive"
    ]), a = So(), i = _(t);
    H(function() {
        return a.register(o);
    }, [
        o,
        a.register
    ]);
    var s = (0, _objectSpreadProps._)((0, _objectSpread._)({
        ref: i
    }, a.props), {
        id: o
    });
    return l && ("onClick" in s && (delete s.htmlFor, delete s.onClick), "onClick" in r && delete r.onClick), h({
        ourProps: s,
        theirProps: r,
        slot: a.slot || {},
        defaultTag: Ml,
        name: a.name || "Label"
    });
}
var _l = D(wl), Ht = Object.assign(_l, {});
var Hl = {
    [0] (e, t) {
        var n = (0, _toConsumableArray._)(e.options).concat([
            {
                id: t.id,
                element: t.element,
                propsRef: t.propsRef
            }
        ]);
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            options: ge(n, function(o) {
                return o.element.current;
            })
        });
    },
    [1] (e, t) {
        var n = e.options.slice(), o = e.options.findIndex(function(l) {
            return l.id === t.id;
        });
        return o === -1 ? e : (n.splice(o, 1), (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            options: n
        }));
    }
}, yn = (0, Q.createContext)(null);
yn.displayName = "RadioGroupDataContext";
function Oo(e) {
    var t = (0, Q.useContext)(yn);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, Oo), n;
    }
    return t;
}
var gn = (0, Q.createContext)(null);
gn.displayName = "RadioGroupActionsContext";
function Ao(e) {
    var t = (0, Q.useContext)(gn);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <RadioGroup /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, Ao), n;
    }
    return t;
}
function kl(e, t) {
    return I(t.type, Hl, e, t);
}
var Nl = "div";
function Gl(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-radiogroup-${n}` : tmp, l = e.value, r = e.defaultValue, a = e.form, i = e.name, s = e.onChange, tmp1 = e.by, u = tmp1 === void 0 ? function(U, Z) {
        return U === Z;
    } : tmp1, tmp2 = e.disabled, f = tmp2 === void 0 ? !1 : tmp2, p = (0, _objectWithoutProperties._)(e, [
        "id",
        "value",
        "defaultValue",
        "form",
        "name",
        "onChange",
        "by",
        "disabled"
    ]), g = m(typeof u == "string" ? function(U, Z) {
        var $ = u;
        return (U == null ? void 0 : U[$]) === (Z == null ? void 0 : Z[$]);
    } : u), _ref = (0, _slicedToArray._)((0, Q.useReducer)(kl, {
        options: []
    }), 2), b = _ref[0], d = _ref[1], c = b.options, _Et = (0, _slicedToArray._)(Et(), 2), y = _Et[0], T = _Et[1], _Ke = (0, _slicedToArray._)(Ke(), 2), P = _Ke[0], F = _Ke[1], k = (0, Q.useRef)(null), M = _(k, t), _He = (0, _slicedToArray._)(He(l, s, r), 2), C = _He[0], R = _He[1], v = (0, Q.useMemo)(function() {
        return c.find(function(U) {
            return !U.propsRef.current.disabled;
        });
    }, [
        c
    ]), A = (0, Q.useMemo)(function() {
        return c.some(function(U) {
            return g(U.propsRef.current.value, C);
        });
    }, [
        c,
        C
    ]), x = m(function(U) {
        var $;
        if (f || g(U, C)) return !1;
        var Z = ($ = c.find(function(de) {
            return g(de.propsRef.current.value, U);
        })) == null ? void 0 : $.propsRef.current;
        return Z != null && Z.disabled ? !1 : (R == null || R(U), !0);
    });
    Ye({
        container: k.current,
        accept (U) {
            return U.getAttribute("role") === "radio" ? NodeFilter.FILTER_REJECT : U.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
        },
        walk (U) {
            U.setAttribute("role", "none");
        }
    });
    var S = m(function(U) {
        var Z = k.current;
        if (!Z) return;
        var $ = be(Z), de = c.filter(function(me) {
            return me.propsRef.current.disabled === !1;
        }).map(function(me) {
            return me.element.current;
        });
        switch(U.key){
            case "Enter":
                Ct(U.currentTarget);
                break;
            case "ArrowLeft":
            case "ArrowUp":
                if (U.preventDefault(), U.stopPropagation(), oe(de, 18) === 2) {
                    var O = c.find(function(w) {
                        return w.element.current === ($ == null ? void 0 : $.activeElement);
                    });
                    O && x(O.propsRef.current.value);
                }
                break;
            case "ArrowRight":
            case "ArrowDown":
                if (U.preventDefault(), U.stopPropagation(), oe(de, 20) === 2) {
                    var O1 = c.find(function(w) {
                        return w.element.current === ($ == null ? void 0 : $.activeElement);
                    });
                    O1 && x(O1.propsRef.current.value);
                }
                break;
            case " ":
                {
                    U.preventDefault(), U.stopPropagation();
                    var me = c.find(function(O) {
                        return O.element.current === ($ == null ? void 0 : $.activeElement);
                    });
                    me && x(me.propsRef.current.value);
                }
                break;
        }
    }), E = m(function(U) {
        return d((0, _objectSpread._)({
            type: 0
        }, U)), function() {
            return d({
                type: 1,
                id: U.id
            });
        };
    }), L = (0, Q.useMemo)(function() {
        return (0, _objectSpread._)({
            value: C,
            firstOption: v,
            containsCheckedOption: A,
            disabled: f,
            compare: g
        }, b);
    }, [
        C,
        v,
        A,
        f,
        g,
        b
    ]), J = (0, Q.useMemo)(function() {
        return {
            registerOption: E,
            change: x
        };
    }, [
        E,
        x
    ]), X = {
        ref: M,
        id: o,
        role: "radiogroup",
        "aria-labelledby": y,
        "aria-describedby": P,
        onKeyDown: S
    }, pe = (0, Q.useMemo)(function() {
        return {
            value: C
        };
    }, [
        C
    ]), re = (0, Q.useRef)(null), ce = le();
    return (0, Q.useEffect)(function() {
        re.current && r !== void 0 && ce.addEventListener(re.current, "reset", function() {
            x(r);
        });
    }, [
        re,
        x
    ]), Q.default.createElement(F, {
        name: "RadioGroup.Description"
    }, Q.default.createElement(T, {
        name: "RadioGroup.Label"
    }, Q.default.createElement(gn.Provider, {
        value: J
    }, Q.default.createElement(yn.Provider, {
        value: L
    }, i != null && C != null && Ue({
        [i]: C
    }).map(function(param, $) {
        var _param = (0, _slicedToArray._)(param, 2), U = _param[0], Z = _param[1];
        return Q.default.createElement(ue, (0, _objectSpread._)({
            features: 4,
            ref: $ === 0 ? function(de) {
                var me;
                re.current = (me = de == null ? void 0 : de.closest("form")) != null ? me : null;
            } : void 0
        }, Fe({
            key: U,
            as: "input",
            type: "radio",
            checked: Z != null,
            hidden: !0,
            readOnly: !0,
            form: a,
            name: U,
            value: Z
        })));
    }), h({
        ourProps: X,
        theirProps: p,
        slot: pe,
        defaultTag: Nl,
        name: "RadioGroup"
    })))));
}
var Ul = "div";
function Bl(e, t) {
    var S;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-radiogroup-option-${n}` : tmp, l = e.value, tmp1 = e.disabled, r = tmp1 === void 0 ? !1 : tmp1, a = (0, _objectWithoutProperties._)(e, [
        "id",
        "value",
        "disabled"
    ]), i = (0, Q.useRef)(null), s = _(i, t), _Et = (0, _slicedToArray._)(Et(), 2), u = _Et[0], f = _Et[1], _Ke = (0, _slicedToArray._)(Ke(), 2), p = _Ke[0], g = _Ke[1], _$_t = _t(1), b = _$_t.addFlag, d = _$_t.removeFlag, c = _$_t.hasFlag, y = Y({
        value: l,
        disabled: r
    }), T = Oo("RadioGroup.Option"), P = Ao("RadioGroup.Option");
    H(function() {
        return P.registerOption({
            id: o,
            element: i,
            propsRef: y
        });
    }, [
        o,
        P,
        i,
        e
    ]);
    var F = m(function(E) {
        var L;
        if (fe(E.currentTarget)) return E.preventDefault();
        P.change(l) && (b(2), (L = i.current) == null || L.focus());
    }), k = m(function(E) {
        if (fe(E.currentTarget)) return E.preventDefault();
        b(2);
    }), M = m(function() {
        return d(2);
    }), C = ((S = T.firstOption) == null ? void 0 : S.id) === o, R = T.disabled || r, v = T.compare(T.value, l), A = {
        ref: s,
        id: o,
        role: "radio",
        "aria-checked": v ? "true" : "false",
        "aria-labelledby": u,
        "aria-describedby": p,
        "aria-disabled": R ? !0 : void 0,
        tabIndex: function() {
            return R ? -1 : v || !T.containsCheckedOption && C ? 0 : -1;
        }(),
        onClick: R ? void 0 : F,
        onFocus: R ? void 0 : k,
        onBlur: R ? void 0 : M
    }, x = (0, Q.useMemo)(function() {
        return {
            checked: v,
            disabled: R,
            active: c(2)
        };
    }, [
        v,
        R,
        c
    ]);
    return Q.default.createElement(g, {
        name: "RadioGroup.Description"
    }, Q.default.createElement(f, {
        name: "RadioGroup.Label"
    }, h({
        ourProps: A,
        theirProps: a,
        slot: x,
        defaultTag: Ul,
        name: "RadioGroup.Option"
    })));
}
var Vl = D(Gl), jl = D(Bl), Wl = Object.assign(Vl, {
    Option: jl,
    Label: Ht,
    Description: at
});
var ie = ne(require("79aad0578ed312fe"), 1);
var Pn = (0, ie.createContext)(null);
Pn.displayName = "GroupContext";
var Kl = ie.Fragment;
function Xl(e) {
    var f;
    var _ref = (0, _slicedToArray._)((0, ie.useState)(null), 2), t = _ref[0], n = _ref[1], _Et = (0, _slicedToArray._)(Et(), 2), o = _Et[0], l = _Et[1], _Ke = (0, _slicedToArray._)(Ke(), 2), r = _Ke[0], a = _Ke[1], i = (0, ie.useMemo)(function() {
        return {
            switch: t,
            setSwitch: n,
            labelledby: o,
            describedby: r
        };
    }, [
        t,
        n,
        o,
        r
    ]), s = {}, u = e;
    return ie.default.createElement(a, {
        name: "Switch.Description"
    }, ie.default.createElement(l, {
        name: "Switch.Label",
        props: {
            htmlFor: (f = i.switch) == null ? void 0 : f.id,
            onClick (p) {
                t && (p.currentTarget.tagName === "LABEL" && p.preventDefault(), t.click(), t.focus({
                    preventScroll: !0
                }));
            }
        }
    }, ie.default.createElement(Pn.Provider, {
        value: i
    }, h({
        ourProps: s,
        theirProps: u,
        defaultTag: Kl,
        name: "Switch.Group"
    }))));
}
var $l = "button";
function Jl(e, t) {
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-switch-${n}` : tmp, l = e.checked, tmp1 = e.defaultChecked, r = tmp1 === void 0 ? !1 : tmp1, a = e.onChange, i = e.name, s = e.value, u = e.form, f = (0, _objectWithoutProperties._)(e, [
        "id",
        "checked",
        "defaultChecked",
        "onChange",
        "name",
        "value",
        "form"
    ]), p = (0, ie.useContext)(Pn), g = (0, ie.useRef)(null), b = _(g, t, p === null ? null : p.setSwitch), _He = (0, _slicedToArray._)(He(l, a, r), 2), d = _He[0], c = _He[1], y = m(function() {
        return c == null ? void 0 : c(!d);
    }), T = m(function(R) {
        if (fe(R.currentTarget)) return R.preventDefault();
        R.preventDefault(), y();
    }), P = m(function(R) {
        R.key === " " ? (R.preventDefault(), y()) : R.key === "Enter" && Ct(R.currentTarget);
    }), F = m(function(R) {
        return R.preventDefault();
    }), k = (0, ie.useMemo)(function() {
        return {
            checked: d
        };
    }, [
        d
    ]), M = {
        id: o,
        ref: b,
        role: "switch",
        type: Ee(e, g),
        tabIndex: 0,
        "aria-checked": d,
        "aria-labelledby": p == null ? void 0 : p.labelledby,
        "aria-describedby": p == null ? void 0 : p.describedby,
        onClick: T,
        onKeyUp: P,
        onKeyPress: F
    }, C = le();
    return (0, ie.useEffect)(function() {
        var v;
        var R = (v = g.current) == null ? void 0 : v.closest("form");
        R && r !== void 0 && C.addEventListener(R, "reset", function() {
            c(r);
        });
    }, [
        g,
        c
    ]), ie.default.createElement(ie.default.Fragment, null, i != null && d && ie.default.createElement(ue, (0, _objectSpread._)({
        features: 4
    }, Fe({
        as: "input",
        type: "checkbox",
        hidden: !0,
        readOnly: !0,
        form: u,
        checked: d,
        name: i,
        value: s
    }))), h({
        ourProps: M,
        theirProps: f,
        slot: k,
        defaultTag: $l,
        name: "Switch"
    }));
}
var ql = D(Jl), Yl = Xl, Ql = Object.assign(ql, {
    Group: Yl,
    Label: Ht,
    Description: at
});
var z = ne(require("79aad0578ed312fe"), 1);
var kt = ne(require("79aad0578ed312fe"), 1);
function Co(param) {
    var e = param.onFocus;
    var _ref = (0, _slicedToArray._)((0, kt.useState)(!0), 2), t = _ref[0], n = _ref[1];
    return t ? kt.default.createElement(ue, {
        as: "button",
        type: "button",
        features: 2,
        onFocus: function(o) {
            o.preventDefault();
            var l, r = 50;
            function a() {
                if (r-- <= 0) {
                    l && cancelAnimationFrame(l);
                    return;
                }
                if (e()) {
                    n(!1), cancelAnimationFrame(l);
                    return;
                }
                l = requestAnimationFrame(a);
            }
            l = requestAnimationFrame(a);
        }
    }) : null;
}
var Oe = ne(require("79aad0578ed312fe"), 1), Lo = Oe.createContext(null);
function zl() {
    return {
        groups: new Map,
        get (e, t) {
            var a;
            var n = this.groups.get(e);
            n || (n = new Map, this.groups.set(e, n));
            var o = (a = n.get(t)) != null ? a : 0;
            n.set(t, o + 1);
            var l = Array.from(n.keys()).indexOf(t);
            function r() {
                var i = n.get(t);
                i > 1 ? n.set(t, i - 1) : n.delete(t);
            }
            return [
                l,
                r
            ];
        }
    };
}
function ho(param) {
    var e = param.children;
    var t = Oe.useRef(zl());
    return Oe.createElement(Lo.Provider, {
        value: t
    }, e);
}
function En(e) {
    var t = Oe.useContext(Lo);
    if (!t) throw new Error("You must wrap your component in a <StableCollection>");
    var n = Zl(), _t_current_get = (0, _slicedToArray._)(t.current.get(e, n), 2), o = _t_current_get[0], l = _t_current_get[1];
    return Oe.useEffect(function() {
        return l;
    }, []), o;
}
function Zl() {
    var o, l, r;
    var e = (r = (l = (o = Oe.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) == null ? void 0 : o.ReactCurrentOwner) == null ? void 0 : l.current) != null ? r : null;
    if (!e) return Symbol();
    var t = [], n = e;
    for(; n;)t.push(n.index), n = n.return;
    return "$." + t.join(".");
}
var ei = {
    [0] (e, t) {
        var f;
        var n = ge(e.tabs, function(p) {
            return p.current;
        }), o = ge(e.panels, function(p) {
            return p.current;
        }), l = n.filter(function(p) {
            var g;
            return !((g = p.current) != null && g.hasAttribute("disabled"));
        }), r = (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            tabs: n,
            panels: o
        });
        if (t.index < 0 || t.index > n.length - 1) {
            var p = I(Math.sign(t.index - e.selectedIndex), {
                [-1]: function() {
                    return 1;
                },
                [0]: function() {
                    return I(Math.sign(t.index), {
                        [-1]: function() {
                            return 0;
                        },
                        [0]: function() {
                            return 0;
                        },
                        [1]: function() {
                            return 1;
                        }
                    });
                },
                [1]: function() {
                    return 0;
                }
            });
            return l.length === 0 ? r : (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
                selectedIndex: I(p, {
                    [0]: function() {
                        return n.indexOf(l[0]);
                    },
                    [1]: function() {
                        return n.indexOf(l[l.length - 1]);
                    }
                })
            });
        }
        var a = n.slice(0, t.index), s = (0, _toConsumableArray._)(n.slice(t.index)).concat((0, _toConsumableArray._)(a)).find(function(p) {
            return l.includes(p);
        });
        if (!s) return r;
        var u = (f = n.indexOf(s)) != null ? f : e.selectedIndex;
        return u === -1 && (u = e.selectedIndex), (0, _objectSpreadProps._)((0, _objectSpread._)({}, r), {
            selectedIndex: u
        });
    },
    [1] (e, t) {
        var r;
        if (e.tabs.includes(t.tab)) return e;
        var n = e.tabs[e.selectedIndex], o = ge((0, _toConsumableArray._)(e.tabs).concat([
            t.tab
        ]), function(a) {
            return a.current;
        }), l = (r = o.indexOf(n)) != null ? r : e.selectedIndex;
        return l === -1 && (l = e.selectedIndex), (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            tabs: o,
            selectedIndex: l
        });
    },
    [2] (e, t) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            tabs: e.tabs.filter(function(n) {
                return n !== t.tab;
            })
        });
    },
    [3] (e, t) {
        return e.panels.includes(t.panel) ? e : (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            panels: ge((0, _toConsumableArray._)(e.panels).concat([
                t.panel
            ]), function(n) {
                return n.current;
            })
        });
    },
    [4] (e, t) {
        return (0, _objectSpreadProps._)((0, _objectSpread._)({}, e), {
            panels: e.panels.filter(function(n) {
                return n !== t.panel;
            })
        });
    }
}, xn = (0, z.createContext)(null);
xn.displayName = "TabsDataContext";
function it(e) {
    var t = (0, z.useContext)(xn);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, it), n;
    }
    return t;
}
var vn = (0, z.createContext)(null);
vn.displayName = "TabsActionsContext";
function Rn(e) {
    var t = (0, z.useContext)(vn);
    if (t === null) {
        var n = new Error(`<${e} /> is missing a parent <Tab.Group /> component.`);
        throw Error.captureStackTrace && Error.captureStackTrace(n, Rn), n;
    }
    return t;
}
function ti(e, t) {
    return I(t.type, ei, e, t);
}
var ni = z.Fragment;
function oi(e, t) {
    var tmp = e.defaultIndex, n = tmp === void 0 ? 0 : tmp, tmp1 = e.vertical, o = tmp1 === void 0 ? !1 : tmp1, tmp2 = e.manual, l = tmp2 === void 0 ? !1 : tmp2, r = e.onChange, tmp3 = e.selectedIndex, a = tmp3 === void 0 ? null : tmp3, i = (0, _objectWithoutProperties._)(e, [
        "defaultIndex",
        "vertical",
        "manual",
        "onChange",
        "selectedIndex"
    ]), s = o ? "vertical" : "horizontal", u = l ? "manual" : "auto", f = a !== null, p = _(t), _ref = (0, _slicedToArray._)((0, z.useReducer)(ti, {
        selectedIndex: a != null ? a : n,
        tabs: [],
        panels: []
    }), 2), g = _ref[0], b = _ref[1], d = (0, z.useMemo)(function() {
        return {
            selectedIndex: g.selectedIndex
        };
    }, [
        g.selectedIndex
    ]), c = Y(r || function() {}), y = Y(g.tabs), T = (0, z.useMemo)(function() {
        return (0, _objectSpread._)({
            orientation: s,
            activation: u
        }, g);
    }, [
        s,
        u,
        g
    ]), P = m(function(v) {
        return b({
            type: 1,
            tab: v
        }), function() {
            return b({
                type: 2,
                tab: v
            });
        };
    }), F = m(function(v) {
        return b({
            type: 3,
            panel: v
        }), function() {
            return b({
                type: 4,
                panel: v
            });
        };
    }), k = m(function(v) {
        M.current !== v && c.current(v), f || b({
            type: 0,
            index: v
        });
    }), M = Y(f ? e.selectedIndex : g.selectedIndex), C = (0, z.useMemo)(function() {
        return {
            registerTab: P,
            registerPanel: F,
            change: k
        };
    }, []);
    H(function() {
        b({
            type: 0,
            index: a != null ? a : n
        });
    }, [
        a
    ]), H(function() {
        if (M.current === void 0 || g.tabs.length <= 0) return;
        var v = ge(g.tabs, function(x) {
            return x.current;
        });
        v.some(function(x, S) {
            return g.tabs[S] !== x;
        }) && k(v.indexOf(g.tabs[M.current]));
    });
    var R = {
        ref: p
    };
    return z.default.createElement(ho, null, z.default.createElement(vn.Provider, {
        value: C
    }, z.default.createElement(xn.Provider, {
        value: T
    }, T.tabs.length <= 0 && z.default.createElement(Co, {
        onFocus: function() {
            var v, A;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = y.current[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var x = _step.value;
                    if (((v = x.current) == null ? void 0 : v.tabIndex) === 0) return (A = x.current) == null || A.focus(), !0;
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return !1;
        }
    }), h({
        ourProps: R,
        theirProps: i,
        slot: d,
        defaultTag: ni,
        name: "Tabs"
    }))));
}
var ri = "div";
function ai(e, t) {
    var _it = it("Tab.List"), n = _it.orientation, o = _it.selectedIndex, l = _(t);
    return h({
        ourProps: {
            ref: l,
            role: "tablist",
            "aria-orientation": n
        },
        theirProps: e,
        slot: {
            selectedIndex: o
        },
        defaultTag: ri,
        name: "Tabs.List"
    });
}
var li = "button";
function ii(e, t) {
    var v, A;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-tabs-tab-${n}` : tmp, l = (0, _objectWithoutProperties._)(e, [
        "id"
    ]), _it = it("Tab"), r = _it.orientation, a = _it.activation, i = _it.selectedIndex, s = _it.tabs, u = _it.panels, f = Rn("Tab"), p = it("Tab"), g = (0, z.useRef)(null), b = _(g, t);
    H(function() {
        return f.registerTab(g);
    }, [
        f,
        g
    ]);
    var d = En("tabs"), c = s.indexOf(g);
    c === -1 && (c = d);
    var y = c === i, T = m(function(x) {
        var E;
        var S = x();
        if (S === 2 && a === "auto") {
            var L = (E = be(g)) == null ? void 0 : E.activeElement, J = p.tabs.findIndex(function(X) {
                return X.current === L;
            });
            J !== -1 && f.change(J);
        }
        return S;
    }), P = m(function(x) {
        var S = s.map(function(L) {
            return L.current;
        }).filter(Boolean);
        if (x.key === " " || x.key === "Enter") {
            x.preventDefault(), x.stopPropagation(), f.change(c);
            return;
        }
        switch(x.key){
            case "Home":
            case "PageUp":
                return x.preventDefault(), x.stopPropagation(), T(function() {
                    return oe(S, 1);
                });
            case "End":
            case "PageDown":
                return x.preventDefault(), x.stopPropagation(), T(function() {
                    return oe(S, 8);
                });
        }
        if (T(function() {
            return I(r, {
                vertical () {
                    return x.key === "ArrowUp" ? oe(S, 18) : x.key === "ArrowDown" ? oe(S, 20) : 0;
                },
                horizontal () {
                    return x.key === "ArrowLeft" ? oe(S, 18) : x.key === "ArrowRight" ? oe(S, 20) : 0;
                }
            });
        }) === 2) return x.preventDefault();
    }), F = (0, z.useRef)(!1), k = m(function() {
        var x;
        F.current || (F.current = !0, (x = g.current) == null || x.focus(), f.change(c), De(function() {
            F.current = !1;
        }));
    }), M = m(function(x) {
        x.preventDefault();
    }), C = (0, z.useMemo)(function() {
        return {
            selected: y
        };
    }, [
        y
    ]), R = {
        ref: b,
        onKeyDown: P,
        onMouseDown: M,
        onClick: k,
        id: o,
        role: "tab",
        type: Ee(e, g),
        "aria-controls": (A = (v = u[c]) == null ? void 0 : v.current) == null ? void 0 : A.id,
        "aria-selected": y,
        tabIndex: y ? 0 : -1
    };
    return h({
        ourProps: R,
        theirProps: l,
        slot: C,
        defaultTag: li,
        name: "Tabs.Tab"
    });
}
var si = "div";
function ui(e, t) {
    var _it = it("Tab.Panels"), n = _it.selectedIndex, o = _(t), l = (0, z.useMemo)(function() {
        return {
            selectedIndex: n
        };
    }, [
        n
    ]);
    return h({
        ourProps: {
            ref: o
        },
        theirProps: e,
        slot: l,
        defaultTag: si,
        name: "Tabs.Panels"
    });
}
var pi = "div", di = 3;
function ci(e, t) {
    var T, P, F, k;
    var n = j(), tmp = e.id, o = tmp === void 0 ? `headlessui-tabs-panel-${n}` : tmp, tmp1 = e.tabIndex, l = tmp1 === void 0 ? 0 : tmp1, r = (0, _objectWithoutProperties._)(e, [
        "id",
        "tabIndex"
    ]), _it = it("Tab.Panel"), a = _it.selectedIndex, i = _it.tabs, s = _it.panels, u = Rn("Tab.Panel"), f = (0, z.useRef)(null), p = _(f, t);
    H(function() {
        return u.registerPanel(f);
    }, [
        u,
        f
    ]);
    var g = En("panels"), b = s.indexOf(f);
    b === -1 && (b = g);
    var d = b === a, c = (0, z.useMemo)(function() {
        return {
            selected: d
        };
    }, [
        d
    ]), y = {
        ref: p,
        id: o,
        role: "tabpanel",
        "aria-labelledby": (P = (T = i[b]) == null ? void 0 : T.current) == null ? void 0 : P.id,
        tabIndex: d ? l : -1
    };
    return !d && ((F = r.unmount) == null || F) && !((k = r.static) != null && k) ? z.default.createElement(ue, (0, _objectSpread._)({
        as: "span"
    }, y)) : h({
        ourProps: y,
        theirProps: r,
        slot: c,
        defaultTag: pi,
        features: di,
        visible: d,
        name: "Tabs.Panel"
    });
}
var fi = D(ii), Ti = D(oi), mi = D(ai), bi = D(ui), yi = D(ci), gi = Object.assign(fi, {
    Group: Ti,
    List: mi,
    Panels: bi,
    Panel: yi
});
var V = ne(require("79aad0578ed312fe"), 1);
function Do(e) {
    var t = {
        called: !1
    };
    return function() {
        for(var _len = arguments.length, n = new Array(_len), _key = 0; _key < _len; _key++){
            n[_key] = arguments[_key];
        }
        if (!t.called) return t.called = !0, e.apply(void 0, (0, _toConsumableArray._)(n));
    };
}
function Sn(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    var _e_classList;
    e && t.length > 0 && (_e_classList = e.classList).add.apply(_e_classList, (0, _toConsumableArray._)(t));
}
function On(e) {
    for(var _len = arguments.length, t = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        t[_key - 1] = arguments[_key];
    }
    var _e_classList;
    e && t.length > 0 && (_e_classList = e.classList).remove.apply(_e_classList, (0, _toConsumableArray._)(t));
}
function Pi(e, t) {
    var n = ae();
    if (!e) return n.dispose;
    var _getComputedStyle = getComputedStyle(e), o = _getComputedStyle.transitionDuration, l = _getComputedStyle.transitionDelay, _map = (0, _slicedToArray._)([
        o,
        l
    ].map(function(s) {
        var _s_split_filter_map_sort = (0, _slicedToArray._)(s.split(",").filter(Boolean).map(function(f) {
            return f.includes("ms") ? parseFloat(f) : parseFloat(f) * 1e3;
        }).sort(function(f, p) {
            return p - f;
        }), 1), tmp = _s_split_filter_map_sort[0], u = tmp === void 0 ? 0 : tmp;
        return u;
    }), 2), r = _map[0], a = _map[1], i = r + a;
    if (i !== 0) {
        n.group(function(u) {
            u.setTimeout(function() {
                t(), u.dispose();
            }, i), u.addEventListener(e, "transitionrun", function(f) {
                f.target === f.currentTarget && u.dispose();
            });
        });
        var s = n.addEventListener(e, "transitionend", function(u) {
            u.target === u.currentTarget && (t(), s());
        });
    } else t();
    return n.add(function() {
        return t();
    }), n.dispose;
}
function Io(e, t, n, o) {
    var l = n ? "enter" : "leave", r = ae(), a = o !== void 0 ? Do(o) : function() {};
    l === "enter" && (e.removeAttribute("hidden"), e.style.display = "");
    var i = I(l, {
        enter: function() {
            return t.enter;
        },
        leave: function() {
            return t.leave;
        }
    }), s = I(l, {
        enter: function() {
            return t.enterTo;
        },
        leave: function() {
            return t.leaveTo;
        }
    }), u = I(l, {
        enter: function() {
            return t.enterFrom;
        },
        leave: function() {
            return t.leaveFrom;
        }
    });
    return On.apply(void 0, [
        e
    ].concat((0, _toConsumableArray._)(t.enter), (0, _toConsumableArray._)(t.enterTo), (0, _toConsumableArray._)(t.enterFrom), (0, _toConsumableArray._)(t.leave), (0, _toConsumableArray._)(t.leaveFrom), (0, _toConsumableArray._)(t.leaveTo), (0, _toConsumableArray._)(t.entered))), Sn.apply(void 0, [
        e
    ].concat((0, _toConsumableArray._)(i), (0, _toConsumableArray._)(u))), r.nextFrame(function() {
        On.apply(void 0, [
            e
        ].concat((0, _toConsumableArray._)(u))), Sn.apply(void 0, [
            e
        ].concat((0, _toConsumableArray._)(s))), Pi(e, function() {
            return On.apply(void 0, [
                e
            ].concat((0, _toConsumableArray._)(i))), Sn.apply(void 0, [
                e
            ].concat((0, _toConsumableArray._)(t.entered))), a();
        });
    }), r.dispose;
}
function Fo(param) {
    var e = param.container, t = param.direction, n = param.classes, o = param.onStart, l = param.onStop;
    var r = _e(), a = le(), i = Y(t);
    H(function() {
        var s = ae();
        a.add(s.dispose);
        var u = e.current;
        if (u && i.current !== "idle" && r.current) return s.dispose(), o.current(i.current), s.add(Io(u, n.current, i.current === "enter", function() {
            s.dispose(), l.current(i.current);
        })), s.dispose;
    }, [
        t
    ]);
}
function $e() {
    var e = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return e.split(" ").filter(function(t) {
        return t.trim().length > 1;
    });
}
var Nt = (0, V.createContext)(null);
Nt.displayName = "TransitionContext";
function Ei() {
    var e = (0, V.useContext)(Nt);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
function xi() {
    var e = (0, V.useContext)(Gt);
    if (e === null) throw new Error("A <Transition.Child /> is used but it is missing a parent <Transition /> or <Transition.Root />.");
    return e;
}
var Gt = (0, V.createContext)(null);
Gt.displayName = "NestingContext";
function Ut(e) {
    return "children" in e ? Ut(e.children) : e.current.filter(function(param) {
        var t = param.el;
        return t.current !== null;
    }).filter(function(param) {
        var t = param.state;
        return t === "visible";
    }).length > 0;
}
function wo(e, t) {
    var n = Y(e), o = (0, V.useRef)([]), l = _e(), r = le(), a = m(function(b) {
        var d = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 1;
        var c = o.current.findIndex(function(param) {
            var y = param.el;
            return y === b;
        });
        c !== -1 && (I(d, {
            [0] () {
                o.current.splice(c, 1);
            },
            [1] () {
                o.current[c].state = "hidden";
            }
        }), r.microTask(function() {
            var y;
            !Ut(o) && l.current && ((y = n.current) == null || y.call(n));
        }));
    }), i = m(function(b) {
        var d = o.current.find(function(param) {
            var c = param.el;
            return c === b;
        });
        return d ? d.state !== "visible" && (d.state = "visible") : o.current.push({
            el: b,
            state: "visible"
        }), function() {
            return a(b, 0);
        };
    }), s = (0, V.useRef)([]), u = (0, V.useRef)(Promise.resolve()), f = (0, V.useRef)({
        enter: [],
        leave: [],
        idle: []
    }), p = m(function(b, d, c) {
        s.current.splice(0), t && (t.chains.current[d] = t.chains.current[d].filter(function(param) {
            var _param = (0, _slicedToArray._)(param, 1), y = _param[0];
            return y !== b;
        })), t == null || t.chains.current[d].push([
            b,
            new Promise(function(y) {
                s.current.push(y);
            })
        ]), t == null || t.chains.current[d].push([
            b,
            new Promise(function(y) {
                Promise.all(f.current[d].map(function(param) {
                    var _param = (0, _slicedToArray._)(param, 2), T = _param[0], P = _param[1];
                    return P;
                })).then(function() {
                    return y();
                });
            })
        ]), d === "enter" ? u.current = u.current.then(function() {
            return t == null ? void 0 : t.wait.current;
        }).then(function() {
            return c(d);
        }) : c(d);
    }), g = m(function(b, d, c) {
        Promise.all(f.current[d].splice(0).map(function(param) {
            var _param = (0, _slicedToArray._)(param, 2), y = _param[0], T = _param[1];
            return T;
        })).then(function() {
            var y;
            (y = s.current.shift()) == null || y();
        }).then(function() {
            return c(d);
        });
    });
    return (0, V.useMemo)(function() {
        return {
            children: o,
            register: i,
            unregister: a,
            onStart: p,
            onStop: g,
            wait: u,
            chains: f
        };
    }, [
        i,
        a,
        o,
        p,
        g,
        f,
        u
    ]);
}
function vi() {}
var Ri = [
    "beforeEnter",
    "afterEnter",
    "beforeLeave",
    "afterLeave"
];
function Mo(e) {
    var n;
    var t = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Ri[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var o = _step.value;
            t[o] = (n = e[o]) != null ? n : vi;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return t;
}
function Si(e) {
    var t = (0, V.useRef)(Mo(e));
    return (0, V.useEffect)(function() {
        t.current = Mo(e);
    }, [
        e
    ]), t;
}
var Oi = "div", _o = 1;
function Ai(e, t) {
    var n = e.beforeEnter, o = e.afterEnter, l = e.beforeLeave, r = e.afterLeave, a = e.enter, i = e.enterFrom, s = e.enterTo, u = e.entered, f = e.leave, p = e.leaveFrom, g = e.leaveTo, b = (0, _objectWithoutProperties._)(e, [
        "beforeEnter",
        "afterEnter",
        "beforeLeave",
        "afterLeave",
        "enter",
        "enterFrom",
        "enterTo",
        "entered",
        "leave",
        "leaveFrom",
        "leaveTo"
    ]), d = (0, V.useRef)(null), c = _(d, t), y = b.unmount ? 0 : 1, _Ei = Ei(), T = _Ei.show, P = _Ei.appear, F = _Ei.initial, _ref = (0, _slicedToArray._)((0, V.useState)(T ? "visible" : "hidden"), 2), k = _ref[0], M = _ref[1], C = xi(), R = C.register, v = C.unregister, A = (0, V.useRef)(null);
    (0, V.useEffect)(function() {
        return R(d);
    }, [
        R,
        d
    ]), (0, V.useEffect)(function() {
        if (y === 1 && d.current) {
            if (T && k !== "visible") {
                M("visible");
                return;
            }
            return I(k, {
                ["hidden"]: function() {
                    return v(d);
                },
                ["visible"]: function() {
                    return R(d);
                }
            });
        }
    }, [
        k,
        d,
        R,
        v,
        T,
        y
    ]);
    var x = Y({
        enter: $e(a),
        enterFrom: $e(i),
        enterTo: $e(s),
        entered: $e(u),
        leave: $e(f),
        leaveFrom: $e(p),
        leaveTo: $e(g)
    }), S = Si({
        beforeEnter: n,
        afterEnter: o,
        beforeLeave: l,
        afterLeave: r
    }), E = Ae();
    (0, V.useEffect)(function() {
        if (E && k === "visible" && d.current === null) throw new Error("Did you forget to passthrough the `ref` to the actual DOM node?");
    }, [
        d,
        k,
        E
    ]);
    var L = F && !P, J = function() {
        return !E || L || A.current === T ? "idle" : T ? "enter" : "leave";
    }(), X = _t(0), pe = m(function($) {
        return I($, {
            enter: function() {
                X.addFlag(8), S.current.beforeEnter();
            },
            leave: function() {
                X.addFlag(4), S.current.beforeLeave();
            },
            idle: function() {}
        });
    }), re = m(function($) {
        return I($, {
            enter: function() {
                X.removeFlag(8), S.current.afterEnter();
            },
            leave: function() {
                X.removeFlag(4), S.current.afterLeave();
            },
            idle: function() {}
        });
    }), ce = wo(function() {
        M("hidden"), v(d);
    }, C);
    Fo({
        container: d,
        classes: x,
        direction: J,
        onStart: Y(function($) {
            ce.onStart(d, $, pe);
        }),
        onStop: Y(function($) {
            ce.onStop(d, $, re), $ === "leave" && !Ut(ce) && (M("hidden"), v(d));
        })
    }), (0, V.useEffect)(function() {
        L && (y === 1 ? A.current = null : A.current = T);
    }, [
        T,
        L,
        k
    ]);
    var U = b, Z = {
        ref: c
    };
    return P && T && (U = (0, _objectSpreadProps._)((0, _objectSpread._)({}, U), {
        className: ct.apply(void 0, [
            b.className
        ].concat((0, _toConsumableArray._)(x.current.enter), (0, _toConsumableArray._)(x.current.enterFrom)))
    })), V.default.createElement(Gt.Provider, {
        value: ce
    }, V.default.createElement(Se, {
        value: I(k, {
            ["visible"]: 1,
            ["hidden"]: 2
        }) | X.flags
    }, h({
        ourProps: Z,
        theirProps: U,
        defaultTag: Oi,
        features: _o,
        visible: k === "visible",
        name: "Transition.Child"
    })));
}
function Ci(e, t) {
    var n = e.show, tmp = e.appear, o = tmp === void 0 ? !1 : tmp, l = e.unmount, r = (0, _objectWithoutProperties._)(e, [
        "show",
        "appear",
        "unmount"
    ]), a = (0, V.useRef)(null), i = _(a, t);
    Ae();
    var s = ye();
    if (n === void 0 && s !== null && (n = (s & 1) === 1), ![
        !0,
        !1
    ].includes(n)) throw new Error("A <Transition /> is used but it is missing a `show={true | false}` prop.");
    var _ref = (0, _slicedToArray._)((0, V.useState)(n ? "visible" : "hidden"), 2), u = _ref[0], f = _ref[1], p = wo(function() {
        f("hidden");
    }), _ref1 = (0, _slicedToArray._)((0, V.useState)(!0), 2), g = _ref1[0], b = _ref1[1], d = (0, V.useRef)([
        n
    ]);
    H(function() {
        g !== !1 && d.current[d.current.length - 1] !== n && (d.current.push(n), b(!1));
    }, [
        d,
        n
    ]);
    var c = (0, V.useMemo)(function() {
        return {
            show: n,
            appear: o,
            initial: g
        };
    }, [
        n,
        o,
        g
    ]);
    (0, V.useEffect)(function() {
        if (n) f("visible");
        else if (!Ut(p)) f("hidden");
        else {
            var T = a.current;
            if (!T) return;
            var P = T.getBoundingClientRect();
            P.x === 0 && P.y === 0 && P.width === 0 && P.height === 0 && f("hidden");
        }
    }, [
        n,
        p
    ]);
    var y = {
        unmount: l
    };
    return V.default.createElement(Gt.Provider, {
        value: p
    }, V.default.createElement(Nt.Provider, {
        value: c
    }, h({
        ourProps: (0, _objectSpreadProps._)((0, _objectSpread._)({}, y), {
            as: V.Fragment,
            children: V.default.createElement(Ho, (0, _objectSpread._)({
                ref: i
            }, y, r))
        }),
        theirProps: {},
        defaultTag: V.Fragment,
        features: _o,
        visible: u === "visible",
        name: "Transition"
    })));
}
function Li(e, t) {
    var n = (0, V.useContext)(Nt) !== null, o = ye() !== null;
    return V.default.createElement(V.default.Fragment, null, !n && o ? V.default.createElement(An, (0, _objectSpread._)({
        ref: t
    }, e)) : V.default.createElement(Ho, (0, _objectSpread._)({
        ref: t
    }, e)));
}
var An = D(Ci), Ho = D(Ai), hi = D(Li), Di = Object.assign(An, {
    Child: hi,
    Root: An
});

},{"@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","@swc/helpers/_/_object_without_properties":"4Ofw8","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","79aad0578ed312fe":"9MtAM","fefc85d48d39c92":"5Yfvl"}],"93i5p":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _class_call_check;
});
function _class_call_check(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"9mBzM":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _create_class;
});
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _create_class(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"4Ofw8":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties;
});
var _objectWithoutPropertiesLooseJs = require("./_object_without_properties_loose.js");
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = (0, _objectWithoutPropertiesLooseJs._)(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}

},{"./_object_without_properties_loose.js":"etfzF","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"etfzF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _object_without_properties_loose;
});
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"lAYt5":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _sliced_to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayLimitJs = require("./_iterable_to_array_limit.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _sliced_to_array(arr, i) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayLimitJs._)(arr, i) || (0, _unsupportedIterableToArrayJs._)(arr, i) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"bmtDq","./_iterable_to_array_limit.js":"d7Wiv","./_non_iterable_rest.js":"6iEkD","./_unsupported_iterable_to_array.js":"5obbp","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"bmtDq":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_with_holes;
});
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"d7Wiv":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array_limit;
});
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"6iEkD":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_rest;
});
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"5obbp":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _unsupported_iterable_to_array;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, _arrayLikeToArrayJs._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, _arrayLikeToArrayJs._)(o, minLen);
}

},{"./_array_like_to_array.js":"bD27E","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"bD27E":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_like_to_array;
});
function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"jg7I9":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_consumable_array;
});
var _arrayWithoutHolesJs = require("./_array_without_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableSpreadJs = require("./_non_iterable_spread.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_consumable_array(arr) {
    return (0, _arrayWithoutHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableSpreadJs._)();
}

},{"./_array_without_holes.js":"54Ttz","./_iterable_to_array.js":"2gg5C","./_non_iterable_spread.js":"5JKcJ","./_unsupported_iterable_to_array.js":"5obbp","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"54Ttz":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _array_without_holes;
});
var _arrayLikeToArrayJs = require("./_array_like_to_array.js");
function _array_without_holes(arr) {
    if (Array.isArray(arr)) return (0, _arrayLikeToArrayJs._)(arr);
}

},{"./_array_like_to_array.js":"bD27E","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"2gg5C":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _iterable_to_array;
});
function _iterable_to_array(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"5JKcJ":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _non_iterable_spread;
});
function _non_iterable_spread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"kPxkp":[function(require,module,exports) {
var _objectSpread = require("@swc/helpers/_/_object_spread");
var _objectSpreadProps = require("@swc/helpers/_/_object_spread_props");
var _jsxRuntime = require("react/jsx-runtime");
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = Chevron;
function _typeof(o) {
    "@babel/helpers - typeof";
    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, _typeof(o);
}
function ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function _objectSpread1(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? ownKeys(Object(t), !0).forEach(function(r) {
            _defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function _defineProperty(e, r, t) {
    return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
    if ("object" != _typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != _typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function Chevron(props) {
    var _props$style, _props$style$transfor, _props$style2;
    var rotation = {
        left: 90,
        right: 270,
        up: 0,
        down: 180
    }[props.direction || "left"];
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("svg", (0, _objectSpreadProps._)((0, _objectSpread._)({
        className: "w-6 h-6",
        xmlns: "http://www.w3.org/2000/svg",
        fill: "currentColor",
        viewBox: "0 0 24 24",
        strokeWidth: 1.5,
        stroke: "currentColor"
    }, props), {
        style: _objectSpread1(_objectSpread1({}, (_props$style = props.style) !== null && _props$style !== void 0 ? _props$style : {}), {}, {
            transform: "".concat((_props$style$transfor = (_props$style2 = props.style) === null || _props$style2 === void 0 ? void 0 : _props$style2.transform) !== null && _props$style$transfor !== void 0 ? _props$style$transfor : "", " rotate(").concat(rotation, "deg)")
        }),
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("path", {
            d: "M16.59 8.59003L12 13.17L7.41 8.59003L6 10L12 16L18 10L16.59 8.59003Z"
        })
    }));
}

},{"@swc/helpers/_/_object_spread":"lezcN","@swc/helpers/_/_object_spread_props":"e2OFH","react/jsx-runtime":"iKGFf"}],"2Hr5H":[function(require,module,exports) {
/**
 * React Router DOM v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return 0, _reactRouter.AbortedDeferredError;
});
parcelHelpers.export(exports, "Await", function() {
    return 0, _reactRouter.Await;
});
parcelHelpers.export(exports, "MemoryRouter", function() {
    return 0, _reactRouter.MemoryRouter;
});
parcelHelpers.export(exports, "Navigate", function() {
    return 0, _reactRouter.Navigate;
});
parcelHelpers.export(exports, "NavigationType", function() {
    return 0, _reactRouter.NavigationType;
});
parcelHelpers.export(exports, "Outlet", function() {
    return 0, _reactRouter.Outlet;
});
parcelHelpers.export(exports, "Route", function() {
    return 0, _reactRouter.Route;
});
parcelHelpers.export(exports, "Router", function() {
    return 0, _reactRouter.Router;
});
parcelHelpers.export(exports, "RouterProvider", function() {
    return 0, _reactRouter.RouterProvider;
});
parcelHelpers.export(exports, "Routes", function() {
    return 0, _reactRouter.Routes;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", function() {
    return 0, _reactRouter.UNSAFE_DataRouterContext;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", function() {
    return 0, _reactRouter.UNSAFE_DataRouterStateContext;
});
parcelHelpers.export(exports, "UNSAFE_LocationContext", function() {
    return 0, _reactRouter.UNSAFE_LocationContext;
});
parcelHelpers.export(exports, "UNSAFE_NavigationContext", function() {
    return 0, _reactRouter.UNSAFE_NavigationContext;
});
parcelHelpers.export(exports, "UNSAFE_RouteContext", function() {
    return 0, _reactRouter.UNSAFE_RouteContext;
});
parcelHelpers.export(exports, "UNSAFE_useRouteId", function() {
    return 0, _reactRouter.UNSAFE_useRouteId;
});
parcelHelpers.export(exports, "createMemoryRouter", function() {
    return 0, _reactRouter.createMemoryRouter;
});
parcelHelpers.export(exports, "createPath", function() {
    return 0, _reactRouter.createPath;
});
parcelHelpers.export(exports, "createRoutesFromChildren", function() {
    return 0, _reactRouter.createRoutesFromChildren;
});
parcelHelpers.export(exports, "createRoutesFromElements", function() {
    return 0, _reactRouter.createRoutesFromElements;
});
parcelHelpers.export(exports, "defer", function() {
    return 0, _reactRouter.defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _reactRouter.generatePath;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return 0, _reactRouter.isRouteErrorResponse;
});
parcelHelpers.export(exports, "json", function() {
    return 0, _reactRouter.json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return 0, _reactRouter.matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return 0, _reactRouter.matchRoutes;
});
parcelHelpers.export(exports, "parsePath", function() {
    return 0, _reactRouter.parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return 0, _reactRouter.redirect;
});
parcelHelpers.export(exports, "renderMatches", function() {
    return 0, _reactRouter.renderMatches;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return 0, _reactRouter.resolvePath;
});
parcelHelpers.export(exports, "unstable_useBlocker", function() {
    return 0, _reactRouter.unstable_useBlocker;
});
parcelHelpers.export(exports, "useActionData", function() {
    return 0, _reactRouter.useActionData;
});
parcelHelpers.export(exports, "useAsyncError", function() {
    return 0, _reactRouter.useAsyncError;
});
parcelHelpers.export(exports, "useAsyncValue", function() {
    return 0, _reactRouter.useAsyncValue;
});
parcelHelpers.export(exports, "useHref", function() {
    return 0, _reactRouter.useHref;
});
parcelHelpers.export(exports, "useInRouterContext", function() {
    return 0, _reactRouter.useInRouterContext;
});
parcelHelpers.export(exports, "useLoaderData", function() {
    return 0, _reactRouter.useLoaderData;
});
parcelHelpers.export(exports, "useLocation", function() {
    return 0, _reactRouter.useLocation;
});
parcelHelpers.export(exports, "useMatch", function() {
    return 0, _reactRouter.useMatch;
});
parcelHelpers.export(exports, "useMatches", function() {
    return 0, _reactRouter.useMatches;
});
parcelHelpers.export(exports, "useNavigate", function() {
    return 0, _reactRouter.useNavigate;
});
parcelHelpers.export(exports, "useNavigation", function() {
    return 0, _reactRouter.useNavigation;
});
parcelHelpers.export(exports, "useNavigationType", function() {
    return 0, _reactRouter.useNavigationType;
});
parcelHelpers.export(exports, "useOutlet", function() {
    return 0, _reactRouter.useOutlet;
});
parcelHelpers.export(exports, "useOutletContext", function() {
    return 0, _reactRouter.useOutletContext;
});
parcelHelpers.export(exports, "useParams", function() {
    return 0, _reactRouter.useParams;
});
parcelHelpers.export(exports, "useResolvedPath", function() {
    return 0, _reactRouter.useResolvedPath;
});
parcelHelpers.export(exports, "useRevalidator", function() {
    return 0, _reactRouter.useRevalidator;
});
parcelHelpers.export(exports, "useRouteError", function() {
    return 0, _reactRouter.useRouteError;
});
parcelHelpers.export(exports, "useRouteLoaderData", function() {
    return 0, _reactRouter.useRouteLoaderData;
});
parcelHelpers.export(exports, "useRoutes", function() {
    return 0, _reactRouter.useRoutes;
});
//#endregion
parcelHelpers.export(exports, "BrowserRouter", function() {
    return BrowserRouter;
});
parcelHelpers.export(exports, "Form", function() {
    return Form;
});
parcelHelpers.export(exports, "HashRouter", function() {
    return HashRouter;
});
parcelHelpers.export(exports, "Link", function() {
    return Link;
});
parcelHelpers.export(exports, "NavLink", function() {
    return NavLink;
});
parcelHelpers.export(exports, "ScrollRestoration", function() {
    return ScrollRestoration;
});
parcelHelpers.export(exports, "UNSAFE_useScrollRestoration", function() {
    return useScrollRestoration;
});
parcelHelpers.export(exports, "createBrowserRouter", function() {
    return createBrowserRouter;
});
parcelHelpers.export(exports, "createHashRouter", function() {
    return createHashRouter;
});
parcelHelpers.export(exports, "createSearchParams", function() {
    return createSearchParams;
});
parcelHelpers.export(exports, "unstable_HistoryRouter", function() {
    return HistoryRouter;
});
parcelHelpers.export(exports, "unstable_usePrompt", function() {
    return usePrompt;
});
parcelHelpers.export(exports, "useBeforeUnload", function() {
    return useBeforeUnload;
});
parcelHelpers.export(exports, "useFetcher", function() {
    return useFetcher;
});
parcelHelpers.export(exports, "useFetchers", function() {
    return useFetchers;
});
parcelHelpers.export(exports, "useFormAction", function() {
    return useFormAction;
});
parcelHelpers.export(exports, "useLinkClickHandler", function() {
    return useLinkClickHandler;
});
parcelHelpers.export(exports, "useSearchParams", function() {
    return useSearchParams;
});
parcelHelpers.export(exports, "useSubmit", function() {
    return useSubmit;
});
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _react = require("react");
var _reactRouter = require("react-router");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
var defaultMethod = "get";
var defaultEncType = "application/x-www-form-urlencoded";
function isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function isButtonElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function isFormElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function isInputElement(object) {
    return isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function shouldProcessLinkClick(event, target) {
    return event.button === 0 && (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function createSearchParams(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    var searchParams = createSearchParams(locationSearch);
    if (defaultSearchParams) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var key = _step.value;
                if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
                    searchParams.append(key, value);
                });
            };
            for(var _iterator = defaultSearchParams.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    return searchParams;
}
function getFormSubmissionInfo(target, options, basename) {
    var method;
    var action = null;
    var encType;
    var formData;
    if (isFormElement(target)) {
        var submissionTrigger = options.submissionTrigger;
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            var attr = target.getAttribute("action");
            action = attr ? (0, _router.stripBasename)(attr, basename) : null;
        }
        method = options.method || target.getAttribute("method") || defaultMethod;
        encType = options.encType || target.getAttribute("enctype") || defaultEncType;
        formData = new FormData(target);
        if (submissionTrigger && submissionTrigger.name) formData.append(submissionTrigger.name, submissionTrigger.value);
    } else if (isButtonElement(target) || isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
         // <button>/<input type="submit"> may override attributes of <form>
        if (options.action) action = options.action;
        else {
            // When grabbing the action from the element, it will have had the basename
            // prefixed to ensure non-JS scenarios work, so strip it since we'll
            // re-prefix in the router
            var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
            action = attr1 ? (0, _router.stripBasename)(attr1, basename) : null;
        }
        method = options.method || target.getAttribute("formmethod") || form.getAttribute("method") || defaultMethod;
        encType = options.encType || target.getAttribute("formenctype") || form.getAttribute("enctype") || defaultEncType;
        formData = new FormData(form); // Include name + value from a <button>, appending in case the button name
        // matches an existing input name
        if (target.name) formData.append(target.name, target.value);
    } else if (isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = options.method || defaultMethod;
        action = options.action || null;
        encType = options.encType || defaultEncType;
        if (target instanceof FormData) formData = target;
        else {
            formData = new FormData();
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined, _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            if (target instanceof URLSearchParams) try {
                for(var _iterator = target[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, _slicedToArray._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                    formData.append(name, value);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            else if (target != null) try {
                for(var _iterator1 = Object.keys(target)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var name1 = _step1.value;
                    formData.append(name1, target[name1]);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    }
    return {
        action,
        method: method.toLowerCase(),
        encType,
        formData
    };
}
var _excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset"
], _excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "children"
], _excluded3 = [
    "reloadDocument",
    "replace",
    "method",
    "action",
    "onSubmit",
    "fetcherKey",
    "routeId",
    "relative",
    "preventScrollReset"
];
function createBrowserRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createBrowserHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties)
    }).initialize();
}
function createHashRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createHashHistory)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || parseHydrationData(),
        routes,
        mapRouteProperties: (0, _reactRouter.UNSAFE_mapRouteProperties)
    }).initialize();
}
function parseHydrationData() {
    var _window;
    var state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = _extends({}, state, {
        errors: deserializeErrors(state.errors)
    });
    return state;
}
function deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            // Hey you!  If you change this, please change the corresponding logic in
            // serializeErrors in react-router-dom/server.tsx :)
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, _router.ErrorResponse)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                var error = new Error(val.message); // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function BrowserRouter(_ref) {
    var basename = _ref.basename, children = _ref.children, _$window = _ref.window;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function HashRouter(_ref2) {
    var basename = _ref2.basename, children = _ref2.children, _$window = _ref2.window;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function HistoryRouter(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, history = _ref3.history;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ _react.createElement((0, _reactRouter.Router), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware <a>.
 */ var Link = /*#__PURE__*/ _react.forwardRef(function LinkWithRef(_ref4, ref) {
    var onClick = _ref4.onClick, relative = _ref4.relative, reloadDocument = _ref4.reloadDocument, replace = _ref4.replace, state = _ref4.state, target = _ref4.target, to = _ref4.to, preventScrollReset = _ref4.preventScrollReset, rest = _objectWithoutPropertiesLoose(_ref4, _excluded);
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename; // Rendered into <a href> for absolute URLs
    var absoluteHref;
    var isExternal = false;
    if (typeof to === "string" && ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to; // Only check for external origins client-side
        if (isBrowser) try {
            var currentUrl = new URL(window.location.href);
            var targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            var path = (0, _router.stripBasename)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    } // Rendered into <a href> for relative URLs
    var href = (0, _reactRouter.useHref)(to, {
        relative
    });
    var internalOnClick = useLinkClickHandler(to, {
        replace,
        state,
        target,
        preventScrollReset,
        relative
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    _react.createElement("a", _extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A <Link> wrapper that knows if it's "active" or not.
 */ var NavLink = /*#__PURE__*/ _react.forwardRef(function NavLinkWithRef(_ref5, ref) {
    var tmp = _ref5["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _ref5_caseSensitive = _ref5.caseSensitive, caseSensitive = _ref5_caseSensitive === void 0 ? false : _ref5_caseSensitive, tmp1 = _ref5.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _ref5_end = _ref5.end, end = _ref5_end === void 0 ? false : _ref5_end, styleProp = _ref5.style, to = _ref5.to, children = _ref5.children, rest = _objectWithoutPropertiesLoose(_ref5, _excluded2);
    var path = (0, _reactRouter.useResolvedPath)(to, {
        relative: rest.relative
    });
    var location = (0, _reactRouter.useLocation)();
    var routerState = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    var navigator = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).navigator;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(toPathname.length) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    var ariaCurrent = isActive ? ariaCurrentProp : undefined;
    var className;
    if (typeof classNameProp === "function") className = classNameProp({
        isActive,
        isPending
    });
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp({
        isActive,
        isPending
    }) : styleProp;
    return /*#__PURE__*/ _react.createElement(Link, _extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to
    }), typeof children === "function" ? children({
        isActive,
        isPending
    }) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ var Form = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
    return /*#__PURE__*/ _react.createElement(FormImpl, _extends({}, props, {
        ref: ref
    }));
});
var FormImpl = /*#__PURE__*/ _react.forwardRef(function(_ref6, forwardedRef) {
    var reloadDocument = _ref6.reloadDocument, replace = _ref6.replace, _ref6_method = _ref6.method, method = _ref6_method === void 0 ? defaultMethod : _ref6_method, action = _ref6.action, onSubmit = _ref6.onSubmit, fetcherKey = _ref6.fetcherKey, routeId = _ref6.routeId, relative = _ref6.relative, preventScrollReset = _ref6.preventScrollReset, props = _objectWithoutPropertiesLoose(_ref6, _excluded3);
    var submit = useSubmitImpl(fetcherKey, routeId);
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var formAction = useFormAction(action, {
        relative
    });
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            method: submitMethod,
            replace,
            relative,
            preventScrollReset
        });
    };
    return /*#__PURE__*/ _react.createElement("form", _extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function ScrollRestoration(_ref7) {
    var getKey = _ref7.getKey, storageKey = _ref7.storageKey;
    useScrollRestoration({
        getKey,
        storageKey
    });
    return null;
}
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmitImpl"] = "useSubmitImpl";
    DataRouterHook["UseFetcher"] = "useFetcher";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})(DataRouterStateHook || (DataRouterStateHook = {}));
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    var ctx = _react.useContext((0, _reactRouter.UNSAFE_DataRouterContext));
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    var state = _react.useContext((0, _reactRouter.UNSAFE_DataRouterStateContext));
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function useLinkClickHandler(to, _temp) {
    var _ref = _temp === void 0 ? {} : _temp, target = _ref.target, replaceProp = _ref.replace, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative;
    var navigate = (0, _reactRouter.useNavigate)();
    var location = (0, _reactRouter.useLocation)();
    var path = (0, _reactRouter.useResolvedPath)(to, {
        relative
    });
    return _react.useCallback(function(event) {
        if (shouldProcessLinkClick(event, target)) {
            event.preventDefault(); // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            var replace = replaceProp !== undefined ? replaceProp : (0, _reactRouter.createPath)(location) === (0, _reactRouter.createPath)(path);
            navigate(to, {
                replace,
                state,
                preventScrollReset,
                relative
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function useSearchParams(defaultInit) {
    var defaultSearchParamsRef = _react.useRef(createSearchParams(defaultInit));
    var hasSetSearchParamsRef = _react.useRef(false);
    var location = (0, _reactRouter.useLocation)();
    var searchParams = _react.useMemo(function() {
        return(// Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current));
    }, [
        location.search
    ]);
    var navigate = (0, _reactRouter.useNavigate)();
    var setSearchParams = _react.useCallback(function(nextInit, navigateOptions) {
        var newSearchParams = createSearchParams(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function useSubmit() {
    return useSubmitImpl();
}
function useSubmitImpl(fetcherKey, fetcherRouteId) {
    var router = useDataRouterContext(DataRouterHook.UseSubmitImpl).router;
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    var currentRouteId = (0, _reactRouter.UNSAFE_useRouteId)();
    return _react.useCallback(function(target, options) {
        if (options === void 0) options = {};
        if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
        var _getFormSubmissionInfo = getFormSubmissionInfo(target, options, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData; // Base options shared between fetch() and navigate()
        var opts = {
            preventScrollReset: options.preventScrollReset,
            formData,
            formMethod: method,
            formEncType: encType
        };
        if (fetcherKey) {
            !(fetcherRouteId != null) && (0, _router.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, fetcherRouteId, action, opts);
        } else router.navigate(action, _extends({}, opts, {
            replace: options.replace,
            fromRouteId: currentRouteId
        }));
    }, [
        router,
        basename,
        fetcherKey,
        fetcherRouteId,
        currentRouteId
    ]);
} // v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function useFormAction(action, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var basename = _react.useContext((0, _reactRouter.UNSAFE_NavigationContext)).basename;
    var routeContext = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !routeContext && (0, _router.UNSAFE_invariant)(false);
    var _routeContext_matches_slice = (0, _slicedToArray._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0]; // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    var path = _extends({}, (0, _reactRouter.useResolvedPath)(action ? action : ".", {
        relative
    })); // Previously we set the default action to ".". The problem with this is that
    // `useResolvedPath(".")` excludes search params and the hash of the resolved
    // URL. This is the intended behavior of when "." is specifically provided as
    // the form action, but inconsistent w/ browsers when the action is omitted.
    // https://github.com/remix-run/remix/issues/927
    var location = (0, _reactRouter.useLocation)();
    if (action == null) {
        // Safe to write to these directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        // or hash
        path.search = location.search;
        path.hash = location.hash; // When grabbing search params from the URL, remove the automatically
        // inserted ?index param so we match the useResolvedPath search behavior
        // which would not include ?index
        if (match.route.index) {
            var params = new URLSearchParams(path.search);
            params.delete("index");
            path.search = params.toString() ? "?" + params.toString() : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, _reactRouter.createPath)(path);
}
function createFetcherForm(fetcherKey, routeId) {
    var FetcherForm = /*#__PURE__*/ _react.forwardRef(function(props, ref) {
        return /*#__PURE__*/ _react.createElement(FormImpl, _extends({}, props, {
            ref: ref,
            fetcherKey: fetcherKey,
            routeId: routeId
        }));
    });
    return FetcherForm;
}
var fetcherId = 0;
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function useFetcher() {
    var _route$matches;
    var router = useDataRouterContext(DataRouterHook.UseFetcher).router;
    var route = _react.useContext((0, _reactRouter.UNSAFE_RouteContext));
    !route && (0, _router.UNSAFE_invariant)(false);
    var routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !(routeId != null) && (0, _router.UNSAFE_invariant)(false);
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return String(++fetcherId);
    }), 1), fetcherKey = _React_useState[0];
    var _React_useState1 = (0, _slicedToArray._)(_react.useState(function() {
        !routeId && (0, _router.UNSAFE_invariant)(false);
        return createFetcherForm(fetcherKey, routeId);
    }), 1), Form = _React_useState1[0];
    var _React_useState2 = (0, _slicedToArray._)(_react.useState(function() {
        return function(href) {
            !router && (0, _router.UNSAFE_invariant)(false);
            !routeId && (0, _router.UNSAFE_invariant)(false);
            router.fetch(fetcherKey, routeId, href);
        };
    }), 1), load = _React_useState2[0];
    var submit = useSubmitImpl(fetcherKey, routeId);
    var fetcher = router.getFetcher(fetcherKey);
    var fetcherWithComponents = _react.useMemo(function() {
        return _extends({
            Form,
            submit,
            load
        }, fetcher);
    }, [
        fetcher,
        Form,
        submit,
        load
    ]);
    _react.useEffect(function() {
        // Is this busted when the React team gets real weird and calls effects
        // twice on mount?  We really just need to garbage collect here when this
        // fetcher is no longer around.
        return function() {
            if (!router) {
                console.warn("No router available to clean up from useFetcher()");
                return;
            }
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function useFetchers() {
    var state = useDataRouterState(DataRouterStateHook.UseFetchers);
    return (0, _toConsumableArray._)(state.fetchers.values());
}
var SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function useScrollRestoration(_temp3) {
    var _ref = _temp3 === void 0 ? {} : _temp3, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = useDataRouterContext(DataRouterHook.UseScrollRestoration).router;
    var _useDataRouterState = useDataRouterState(DataRouterStateHook.UseScrollRestoration), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var location = (0, _reactRouter.useLocation)();
    var matches = (0, _reactRouter.useMatches)();
    var navigation = (0, _reactRouter.useNavigation)(); // Trigger manual scroll restoration while we're active
    _react.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []); // Save positions on pagehide
    usePageHide(_react.useCallback(function() {
        if (navigation.state === "idle") {
            var key = (getKey ? getKey(location, matches) : null) || location.key;
            savedScrollPositions[key] = window.scrollY;
        }
        sessionStorage.setItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify(savedScrollPositions));
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ])); // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]); // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            var disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration(savedScrollPositions, function() {
                return window.scrollY;
            }, getKey);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            getKey
        ]); // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        _react.useLayoutEffect(function() {
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
             // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            } // try to scroll to the hash
            if (location.hash) {
                var el = document.getElementById(location.hash.slice(1));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            } // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
             // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function useBeforeUnload(callback, options) {
    var capture = (options || {}).capture;
    _react.useEffect(function() {
        var opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function usePageHide(callback, options) {
    var capture = (options || {}).capture;
    _react.useEffect(function() {
        var opts = capture != null ? {
            capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function usePrompt(_ref8) {
    var when = _ref8.when, message = _ref8.message;
    var blocker = (0, _reactRouter.unstable_useBlocker)(when);
    _react.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
    _react.useEffect(function() {
        if (blocker.state === "blocked") {
            var proceed = window.confirm(message);
            if (proceed) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
}

},{"@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","react":"9MtAM","react-router":"521S2","@remix-run/router":"2sGdx","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"521S2":[function(require,module,exports) {
/**
 * React Router v6.11.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return 0, _router.AbortedDeferredError;
});
parcelHelpers.export(exports, "NavigationType", function() {
    return 0, _router.Action;
});
parcelHelpers.export(exports, "createPath", function() {
    return 0, _router.createPath;
});
parcelHelpers.export(exports, "defer", function() {
    return 0, _router.defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return 0, _router.generatePath;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return 0, _router.isRouteErrorResponse;
});
parcelHelpers.export(exports, "json", function() {
    return 0, _router.json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return 0, _router.matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return 0, _router.matchRoutes;
});
parcelHelpers.export(exports, "parsePath", function() {
    return 0, _router.parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return 0, _router.redirect;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return 0, _router.resolvePath;
});
parcelHelpers.export(exports, "Await", function() {
    return Await;
});
parcelHelpers.export(exports, "MemoryRouter", function() {
    return MemoryRouter;
});
parcelHelpers.export(exports, "Navigate", function() {
    return Navigate;
});
parcelHelpers.export(exports, "Outlet", function() {
    return Outlet;
});
parcelHelpers.export(exports, "Route", function() {
    return Route;
});
parcelHelpers.export(exports, "Router", function() {
    return Router;
});
parcelHelpers.export(exports, "RouterProvider", function() {
    return RouterProvider;
});
parcelHelpers.export(exports, "Routes", function() {
    return Routes;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterContext", function() {
    return DataRouterContext;
});
parcelHelpers.export(exports, "UNSAFE_DataRouterStateContext", function() {
    return DataRouterStateContext;
});
parcelHelpers.export(exports, "UNSAFE_LocationContext", function() {
    return LocationContext;
});
parcelHelpers.export(exports, "UNSAFE_NavigationContext", function() {
    return NavigationContext;
});
parcelHelpers.export(exports, "UNSAFE_RouteContext", function() {
    return RouteContext;
});
parcelHelpers.export(exports, "UNSAFE_mapRouteProperties", function() {
    return mapRouteProperties;
});
parcelHelpers.export(exports, "UNSAFE_useRouteId", function() {
    return useRouteId;
});
parcelHelpers.export(exports, "UNSAFE_useRoutesImpl", function() {
    return useRoutesImpl;
});
parcelHelpers.export(exports, "createMemoryRouter", function() {
    return createMemoryRouter;
});
parcelHelpers.export(exports, "createRoutesFromChildren", function() {
    return createRoutesFromChildren;
});
parcelHelpers.export(exports, "createRoutesFromElements", function() {
    return createRoutesFromChildren;
});
parcelHelpers.export(exports, "renderMatches", function() {
    return renderMatches;
});
parcelHelpers.export(exports, "unstable_useBlocker", function() {
    return useBlocker;
});
parcelHelpers.export(exports, "useActionData", function() {
    return useActionData;
});
parcelHelpers.export(exports, "useAsyncError", function() {
    return useAsyncError;
});
parcelHelpers.export(exports, "useAsyncValue", function() {
    return useAsyncValue;
});
parcelHelpers.export(exports, "useHref", function() {
    return useHref;
});
parcelHelpers.export(exports, "useInRouterContext", function() {
    return useInRouterContext;
});
parcelHelpers.export(exports, "useLoaderData", function() {
    return useLoaderData;
});
parcelHelpers.export(exports, "useLocation", function() {
    return useLocation;
});
parcelHelpers.export(exports, "useMatch", function() {
    return useMatch;
});
parcelHelpers.export(exports, "useMatches", function() {
    return useMatches;
});
parcelHelpers.export(exports, "useNavigate", function() {
    return useNavigate;
});
parcelHelpers.export(exports, "useNavigation", function() {
    return useNavigation;
});
parcelHelpers.export(exports, "useNavigationType", function() {
    return useNavigationType;
});
parcelHelpers.export(exports, "useOutlet", function() {
    return useOutlet;
});
parcelHelpers.export(exports, "useOutletContext", function() {
    return useOutletContext;
});
parcelHelpers.export(exports, "useParams", function() {
    return useParams;
});
parcelHelpers.export(exports, "useResolvedPath", function() {
    return useResolvedPath;
});
parcelHelpers.export(exports, "useRevalidator", function() {
    return useRevalidator;
});
parcelHelpers.export(exports, "useRouteError", function() {
    return useRouteError;
});
parcelHelpers.export(exports, "useRouteLoaderData", function() {
    return useRouteLoaderData;
});
parcelHelpers.export(exports, "useRoutes", function() {
    return useRoutes;
});
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _createSuper = require("@swc/helpers/_/_create_super");
var _react = require("react");
var _router = require("@remix-run/router");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
var DataRouterContext = /*#__PURE__*/ _react.createContext(null);
var DataRouterStateContext = /*#__PURE__*/ _react.createContext(null);
var AwaitContext = /*#__PURE__*/ _react.createContext(null);
var NavigationContext = /*#__PURE__*/ _react.createContext(null);
var LocationContext = /*#__PURE__*/ _react.createContext(null);
var RouteContext = /*#__PURE__*/ _react.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
var RouteErrorContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/hooks/use-href
 */ function useHref(to, _temp) {
    var relative = (_temp === void 0 ? {} : _temp).relative;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var _React_useContext = _react.useContext(NavigationContext), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var _useResolvedPath = useResolvedPath(to, {
        relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname; // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, _router.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search,
        hash
    });
}
/**
 * Returns true if this component is a descendant of a <Router>.
 *
 * @see https://reactrouter.com/hooks/use-in-router-context
 */ function useInRouterContext() {
    return _react.useContext(LocationContext) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/hooks/use-location
 */ function useLocation() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    return _react.useContext(LocationContext).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/hooks/use-navigation-type
 */ function useNavigationType() {
    return _react.useContext(LocationContext).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * <NavLink>.
 *
 * @see https://reactrouter.com/hooks/use-match
 */ function useMatch(pattern) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var pathname = useLocation().pathname;
    return _react.useMemo(function() {
        return (0, _router.matchPath)(pattern, pathname);
    }, [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ var navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered."; // Mute warnings for calls to useNavigate in SSR environments
function useIsomorphicLayoutEffect(cb) {
    var isStatic = _react.useContext(NavigationContext).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    _react.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by <Link>s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/hooks/use-navigate
 */ function useNavigate() {
    var isDataRoute = _react.useContext(RouteContext).isDataRoute; // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? useNavigateStable() : useNavigateUnstable();
}
function useNavigateUnstable() {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var dataRouterContext = _react.useContext(DataRouterContext);
    var _React_useContext = _react.useContext(NavigationContext), basename = _React_useContext.basename, navigator = _React_useContext.navigator;
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    var activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path"); // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, _router.joinPaths)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
var OutletContext = /*#__PURE__*/ _react.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/hooks/use-outlet-context
 */ function useOutletContext() {
    return _react.useContext(OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by <Outlet> to render child routes.
 *
 * @see https://reactrouter.com/hooks/use-outlet
 */ function useOutlet(context) {
    var outlet = _react.useContext(RouteContext).outlet;
    if (outlet) return /*#__PURE__*/ _react.createElement(OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/hooks/use-params
 */ function useParams() {
    var matches = _react.useContext(RouteContext).matches;
    var routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/hooks/use-resolved-path
 */ function useResolvedPath(to, _temp2) {
    var relative = (_temp2 === void 0 ? {} : _temp2).relative;
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, _router.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }));
    return _react.useMemo(function() {
        return (0, _router.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an <Outlet> to render their child route's
 * element.
 *
 * @see https://reactrouter.com/hooks/use-routes
 */ function useRoutes(routes, locationArg) {
    return useRoutesImpl(routes, locationArg);
} // Internal implementation with accept optional param for RouterProvider usage
function useRoutesImpl(routes, locationArg, dataRouterState) {
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var navigator = _react.useContext(NavigationContext).navigator;
    var _React_useContext = _react.useContext(RouteContext), parentMatches = _React_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    var parentPathname = routeMatch ? routeMatch.pathname : "/";
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    var parentRoute = routeMatch && routeMatch.route;
    var locationFromContext = useLocation();
    var location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        var parsedLocationArg = typeof locationArg === "string" ? (0, _router.parsePath)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, _router.UNSAFE_invariant)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = parentPathnameBase === "/" ? pathname : pathname.slice(parentPathnameBase.length) || "/";
    var matches = (0, _router.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = _renderMatches(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, _router.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, _router.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterState); // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        value: {
            location: _extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, _router.Action).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function DefaultErrorComponent() {
    var error = useRouteError();
    var message = (0, _router.isRouteErrorResponse)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    var lightgrey = "rgba(200,200,200, 0.5)";
    var preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    var codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    var devInfo = null;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ _react.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ _react.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
var defaultErrorElement = /*#__PURE__*/ _react.createElement(DefaultErrorComponent, null);
var RenderErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(RenderErrorBoundary, _React_Component);
    var _super = (0, _createSuper._)(RenderErrorBoundary);
    function RenderErrorBoundary(props) {
        (0, _classCallCheck._)(this, RenderErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, _createClass._)(RenderErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("React Router caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                return this.state.error ? /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
                    value: this.props.routeContext
                }, /*#__PURE__*/ _react.createElement(RouteErrorContext.Provider, {
                    value: this.state.error,
                    children: this.props.component
                })) : this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                // When we get into an error state, the user will likely click "back" to the
                // previous page that didn't have an error. Because this wraps the entire
                // application, that will have no effect--the error page continues to display.
                // This gives us a mechanism to recover from the error when the location changes.
                //
                // Whether we're in an error state or not, we update the location in state
                // so that when we are in an error state, it gets reset when a new location
                // comes in and the user recovers from the error.
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                 // If we're not changing locations, preserve the location but still surface
                // any new errors that may come through. We retain the existing error, we do
                // this because the error provided from the app state may be cleared without
                // the location changing.
                return {
                    error: props.error || state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return RenderErrorBoundary;
}(_react.Component);
function RenderedRoute(_ref) {
    var routeContext = _ref.routeContext, match = _ref.match, children = _ref.children;
    var dataRouterContext = _react.useContext(DataRouterContext); // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ _react.createElement(RouteContext.Provider, {
        value: routeContext
    }, children);
}
function _renderMatches(matches, parentMatches, dataRouterState) {
    var _dataRouterState2;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (matches == null) {
        var _dataRouterState;
        if ((_dataRouterState = dataRouterState) != null && _dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches; // If we have data errors, trim matches to the highest error boundary
    var errors = (_dataRouterState2 = dataRouterState) == null ? void 0 : _dataRouterState2.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors == null ? void 0 : errors[m.route.id]);
        });
        !(errorIndex >= 0) && (0, _router.UNSAFE_invariant)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error = match.route.id ? errors == null ? void 0 : errors[match.route.id] : null; // Only data routers handle errors
        var errorElement = null;
        if (dataRouterState) errorElement = match.route.errorElement || defaultErrorElement;
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ _react.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ _react.createElement(RenderedRoute, {
                match: match,
                routeContext: {
                    outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        }; // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ _react.createElement(RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
})(DataRouterHook || (DataRouterHook = {}));
var DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
})(DataRouterStateHook || (DataRouterStateHook = {}));
function getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/routers/picking-a-router.";
}
function useDataRouterContext(hookName) {
    var ctx = _react.useContext(DataRouterContext);
    !ctx && (0, _router.UNSAFE_invariant)(false);
    return ctx;
}
function useDataRouterState(hookName) {
    var state = _react.useContext(DataRouterStateContext);
    !state && (0, _router.UNSAFE_invariant)(false);
    return state;
}
function useRouteContext(hookName) {
    var route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return route;
} // Internal version with hookName-aware debugging
function useCurrentRouteId(hookName) {
    var route = useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, _router.UNSAFE_invariant)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function useRouteId() {
    return useCurrentRouteId(DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function useNavigation() {
    var state = useDataRouterState(DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function useRevalidator() {
    var dataRouterContext = useDataRouterContext(DataRouterHook.UseRevalidator);
    var state = useDataRouterState(DataRouterStateHook.UseRevalidator);
    return {
        revalidate: dataRouterContext.router.revalidate,
        state: state.revalidation
    };
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function useMatches() {
    var _useDataRouterState = useDataRouterState(DataRouterStateHook.UseMatches), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return _react.useMemo(function() {
        return matches.map(function(match) {
            var pathname = match.pathname, params = match.params; // Note: This structure matches that created by createUseMatchesMatch
            // in the @remix-run/router , so if you change this please also change
            // that :)  Eventually we'll DRY this up
            return {
                id: match.route.id,
                pathname,
                params,
                data: loaderData[match.route.id],
                handle: match.route.handle
            };
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function useLoaderData() {
    var state = useDataRouterState(DataRouterStateHook.UseLoaderData);
    var routeId = useCurrentRouteId(DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function useRouteLoaderData(routeId) {
    var state = useDataRouterState(DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function useActionData() {
    var state = useDataRouterState(DataRouterStateHook.UseActionData);
    var route = _react.useContext(RouteContext);
    !route && (0, _router.UNSAFE_invariant)(false);
    return Object.values((state == null ? void 0 : state.actionData) || {})[0];
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function useRouteError() {
    var _state$errors;
    var error = _react.useContext(RouteErrorContext);
    var state = useDataRouterState(DataRouterStateHook.UseRouteError);
    var routeId = useCurrentRouteId(DataRouterStateHook.UseRouteError); // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error) return error;
     // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor <Await /> value
 */ function useAsyncValue() {
    var value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor <Await /> value
 */ function useAsyncError() {
    var value = _react.useContext(AwaitContext);
    return value == null ? void 0 : value._error;
}
var blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function useBlocker(shouldBlock) {
    var router = useDataRouterContext(DataRouterHook.UseBlocker).router;
    var state = useDataRouterState(DataRouterStateHook.UseBlocker);
    var _React_useState = (0, _slicedToArray._)(_react.useState(function() {
        return String(++blockerId);
    }), 1), blockerKey = _React_useState[0];
    var blockerFunction = _react.useCallback(function(args) {
        return typeof shouldBlock === "function" ? !!shouldBlock(args) : !!shouldBlock;
    }, [
        shouldBlock
    ]);
    var blocker = router.getBlocker(blockerKey, blockerFunction); // Cleanup on unmount
    _react.useEffect(function() {
        return function() {
            return router.deleteBlocker(blockerKey);
        };
    }, [
        router,
        blockerKey
    ]); // Prefer the blocker from state since DataRouterContext is memoized so this
    // ensures we update on blocker state updates
    return state.blockers.get(blockerKey) || blocker;
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function useNavigateStable() {
    var router = useDataRouterContext(DataRouterHook.UseNavigateStable).router;
    var id = useCurrentRouteId(DataRouterStateHook.UseNavigateStable);
    var activeRef = _react.useRef(false);
    useIsomorphicLayoutEffect(function() {
        activeRef.current = true;
    });
    var navigate = _react.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, _extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
var alreadyWarned = {};
function warningOnce(key, cond, message) {
    if (!cond && !alreadyWarned[key]) alreadyWarned[key] = true;
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function RouterProvider(_ref) {
    var fallbackElement = _ref.fallbackElement, router = _ref.router;
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    var _React_useState = (0, _slicedToArray._)(_react.useState(router.state), 2), state = _React_useState[0], setState = _React_useState[1];
    _react.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    var navigator = _react.useMemo(function() {
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = _react.useMemo(function() {
        return {
            router,
            navigator,
            static: false,
            basename
        };
    }, [
        router,
        navigator,
        basename
    ]); // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, /*#__PURE__*/ _react.createElement(DataRouterContext.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ _react.createElement(DataRouterStateContext.Provider, {
        value: state
    }, /*#__PURE__*/ _react.createElement(Router, {
        basename: router.basename,
        location: router.state.location,
        navigationType: router.state.historyAction,
        navigator: navigator
    }, router.state.initialized ? /*#__PURE__*/ _react.createElement(DataRoutes, {
        routes: router.routes,
        state: state
    }) : fallbackElement))), null);
}
function DataRoutes(_ref2) {
    var routes = _ref2.routes, state = _ref2.state;
    return useRoutesImpl(routes, undefined, state);
}
/**
 * A <Router> that stores all entries in memory.
 *
 * @see https://reactrouter.com/router-components/memory-router
 */ function MemoryRouter(_ref3) {
    var basename = _ref3.basename, children = _ref3.children, initialEntries = _ref3.initialEntries, initialIndex = _ref3.initialIndex;
    var historyRef = _react.useRef();
    if (historyRef.current == null) historyRef.current = (0, _router.createMemoryHistory)({
        initialEntries,
        initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React_useState = (0, _slicedToArray._)(_react.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React_useState[0], setState = _React_useState[1];
    _react.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history
    ]);
    return /*#__PURE__*/ _react.createElement(Router, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/components/navigate
 */ function Navigate(_ref4) {
    var to = _ref4.to, replace = _ref4.replace, state = _ref4.state, relative = _ref4.relative;
    !useInRouterContext() && (0, _router.UNSAFE_invariant)(false);
    var matches = _react.useContext(RouteContext).matches;
    var _useLocation = useLocation(), locationPathname = _useLocation.pathname;
    var navigate = useNavigate(); // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    var path = (0, _router.resolveTo)(to, (0, _router.UNSAFE_getPathContributingMatches)(matches).map(function(match) {
        return match.pathnameBase;
    }), locationPathname, relative === "path");
    var jsonPath = JSON.stringify(path);
    _react.useEffect(function() {
        return navigate(JSON.parse(jsonPath), {
            replace,
            state,
            relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/components/outlet
 */ function Outlet(props) {
    return useOutlet(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/components/route
 */ function Route(_props) {
    (0, _router.UNSAFE_invariant)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a <Router> directly. Instead, you'll render a
 * router that is more specific to your environment such as a <BrowserRouter>
 * in web browsers or a <StaticRouter> for server rendering.
 *
 * @see https://reactrouter.com/router-components/router
 */ function Router(_ref5) {
    var tmp = _ref5.basename, basenameProp = tmp === void 0 ? "/" : tmp, _ref5_children = _ref5.children, children = _ref5_children === void 0 ? null : _ref5_children, locationProp = _ref5.location, _ref5_navigationType = _ref5.navigationType, navigationType = _ref5_navigationType === void 0 ? (0, _router.Action).Pop : _ref5_navigationType, navigator = _ref5.navigator, tmp1 = _ref5.static, staticProp = tmp1 === void 0 ? false : tmp1;
    !!useInRouterContext() && (0, _router.UNSAFE_invariant)(false); // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = _react.useMemo(function() {
        return {
            basename,
            navigator,
            static: staticProp
        };
    }, [
        basename,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, _router.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key;
    var locationContext = _react.useMemo(function() {
        var trailingPathname = (0, _router.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search,
                hash,
                state,
                key
            },
            navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ _react.createElement(NavigationContext.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ _react.createElement(LocationContext.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of <Route> elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/components/routes
 */ function Routes(_ref6) {
    var children = _ref6.children, location = _ref6.location;
    return useRoutes(createRoutesFromChildren(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function Await(_ref7) {
    var children = _ref7.children, errorElement = _ref7.errorElement, resolve = _ref7.resolve;
    return /*#__PURE__*/ _react.createElement(AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ _react.createElement(ResolveAwait, null, children));
}
var AwaitRenderStatus;
(function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
})(AwaitRenderStatus || (AwaitRenderStatus = {}));
var neverSettledPromise = new Promise(function() {});
var AwaitErrorBoundary = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, _inherits._)(AwaitErrorBoundary, _React_Component);
    var _super = (0, _createSuper._)(AwaitErrorBoundary);
    function AwaitErrorBoundary(props) {
        (0, _classCallCheck._)(this, AwaitErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, _createClass._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = AwaitRenderStatus.pending;
                if (!(resolve instanceof Promise)) {
                    // Didn't get a promise - provide as a resolved promise
                    status = AwaitRenderStatus.success;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    // Caught a render error, provide it as a rejected promise
                    status = AwaitRenderStatus.error;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {}); // Avoid unhandled rejection warnings
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    // Already tracked promise - check contents
                    promise = resolve;
                    status = promise._error !== undefined ? AwaitRenderStatus.error : promise._data !== undefined ? AwaitRenderStatus.success : AwaitRenderStatus.pending;
                } else {
                    // Raw (untracked) promise - track it
                    status = AwaitRenderStatus.pending;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        return Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === AwaitRenderStatus.error && promise._error instanceof (0, _router.AbortedDeferredError)) // Freeze the UI by throwing a never resolved promise
                throw neverSettledPromise;
                if (status === AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
                throw promise._error;
                if (status === AwaitRenderStatus.error) // Render via our errorElement
                return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === AwaitRenderStatus.success) // Render children with resolved value
                return /*#__PURE__*/ _react.createElement(AwaitContext.Provider, {
                    value: promise,
                    children: children
                });
                 // Throw to the suspense boundary
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}(_react.Component);
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on <Await>
 */ function ResolveAwait(_ref8) {
    var children = _ref8.children;
    var data = useAsyncValue();
    var toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ _react.createElement(_react.Fragment, null, toRender);
} ///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/utils/create-routes-from-children
 */ function createRoutesFromChildren(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    var routes = [];
    _react.Children.forEach(children, function(element, index) {
        if (!/*#__PURE__*/ _react.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        var treePath = (0, _toConsumableArray._)(parentPath).concat([
            index
        ]);
        if (element.type === _react.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, createRoutesFromChildren(element.props.children, treePath));
            return;
        }
        !(element.type === Route) && (0, _router.UNSAFE_invariant)(false);
        !(!element.props.index || !element.props.children) && (0, _router.UNSAFE_invariant)(false);
        var route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = createRoutesFromChildren(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function renderMatches(matches) {
    return _renderMatches(matches);
}
function mapRouteProperties(route) {
    var updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ _react.createElement(route.Component),
        Component: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ _react.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function createMemoryRouter(routes, opts) {
    return (0, _router.createRouter)({
        basename: opts == null ? void 0 : opts.basename,
        future: _extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, _router.createMemoryHistory)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes,
        mapRouteProperties
    }).initialize();
} ///////////////////////////////////////////////////////////////////////////////

},{"@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_consumable_array":"jg7I9","@swc/helpers/_/_create_super":"bKhhG","react":"9MtAM","@remix-run/router":"2sGdx","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"fLNpH":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _inherits;
});
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, _setPrototypeOfJs._)(subClass, superClass);
}

},{"./_set_prototype_of.js":"lHY0I","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"lHY0I":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _set_prototype_of;
});
function _set_prototype_of(o, p) {
    _set_prototype_of = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return _set_prototype_of(o, p);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"bKhhG":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _create_super;
});
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _possibleConstructorReturnJs = require("./_possible_constructor_return.js");
function _create_super(Derived) {
    var hasNativeReflectConstruct = (0, _isNativeReflectConstructJs._)();
    return function _createSuperInternal() {
        var Super = (0, _getPrototypeOfJs._)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, _getPrototypeOfJs._)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, _possibleConstructorReturnJs._)(this, result);
    };
}

},{"./_get_prototype_of.js":"5LWub","./_is_native_reflect_construct.js":"kOS19","./_possible_constructor_return.js":"9SAAw","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"5LWub":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _get_prototype_of;
});
function _get_prototype_of(o) {
    _get_prototype_of = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return _get_prototype_of(o);
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"kOS19":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_reflect_construct;
});
function _is_native_reflect_construct() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return (_is_native_reflect_construct = function() {
        return !!result;
    })();
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"9SAAw":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _possible_constructor_return;
});
var _assertThisInitializedJs = require("./_assert_this_initialized.js");
var _typeOfJs = require("./_type_of.js");
function _possible_constructor_return(self, call) {
    if (call && ((0, _typeOfJs._)(call) === "object" || typeof call === "function")) return call;
    return (0, _assertThisInitializedJs._)(self);
}

},{"./_assert_this_initialized.js":"8cJza","./_type_of.js":"Pf63v","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"8cJza":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _assert_this_initialized;
});
function _assert_this_initialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"Pf63v":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _type_of;
});
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"2sGdx":[function(require,module,exports) {
/**
 * @remix-run/router v1.6.2
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "AbortedDeferredError", function() {
    return AbortedDeferredError;
});
parcelHelpers.export(exports, "Action", function() {
    return Action;
});
parcelHelpers.export(exports, "ErrorResponse", function() {
    return ErrorResponse;
});
parcelHelpers.export(exports, "IDLE_BLOCKER", function() {
    return IDLE_BLOCKER;
});
parcelHelpers.export(exports, "IDLE_FETCHER", function() {
    return IDLE_FETCHER;
});
parcelHelpers.export(exports, "IDLE_NAVIGATION", function() {
    return IDLE_NAVIGATION;
});
parcelHelpers.export(exports, "UNSAFE_DEFERRED_SYMBOL", function() {
    return UNSAFE_DEFERRED_SYMBOL;
});
parcelHelpers.export(exports, "UNSAFE_DeferredData", function() {
    return DeferredData;
});
parcelHelpers.export(exports, "UNSAFE_convertRoutesToDataRoutes", function() {
    return convertRoutesToDataRoutes;
});
parcelHelpers.export(exports, "UNSAFE_getPathContributingMatches", function() {
    return getPathContributingMatches;
});
parcelHelpers.export(exports, "UNSAFE_invariant", function() {
    return invariant;
});
parcelHelpers.export(exports, "UNSAFE_warning", function() {
    return warning;
});
parcelHelpers.export(exports, "createBrowserHistory", function() {
    return createBrowserHistory;
});
parcelHelpers.export(exports, "createHashHistory", function() {
    return createHashHistory;
});
parcelHelpers.export(exports, "createMemoryHistory", function() {
    return createMemoryHistory;
});
parcelHelpers.export(exports, "createPath", function() {
    return createPath;
});
parcelHelpers.export(exports, "createRouter", function() {
    return createRouter;
});
parcelHelpers.export(exports, "createStaticHandler", function() {
    return createStaticHandler;
});
parcelHelpers.export(exports, "defer", function() {
    return defer;
});
parcelHelpers.export(exports, "generatePath", function() {
    return generatePath;
});
parcelHelpers.export(exports, "getStaticContextFromError", function() {
    return getStaticContextFromError;
});
parcelHelpers.export(exports, "getToPathname", function() {
    return getToPathname;
});
parcelHelpers.export(exports, "isDeferredData", function() {
    return isDeferredData;
});
parcelHelpers.export(exports, "isRouteErrorResponse", function() {
    return isRouteErrorResponse;
});
parcelHelpers.export(exports, "joinPaths", function() {
    return joinPaths;
});
parcelHelpers.export(exports, "json", function() {
    return json;
});
parcelHelpers.export(exports, "matchPath", function() {
    return matchPath;
});
parcelHelpers.export(exports, "matchRoutes", function() {
    return matchRoutes;
});
parcelHelpers.export(exports, "normalizePathname", function() {
    return normalizePathname;
});
parcelHelpers.export(exports, "parsePath", function() {
    return parsePath;
});
parcelHelpers.export(exports, "redirect", function() {
    return redirect;
});
parcelHelpers.export(exports, "resolvePath", function() {
    return resolvePath;
});
parcelHelpers.export(exports, "resolveTo", function() {
    return resolveTo;
});
parcelHelpers.export(exports, "stripBasename", function() {
    return stripBasename;
});
var _asyncToGenerator = require("@swc/helpers/_/_async_to_generator");
var _classCallCheck = require("@swc/helpers/_/_class_call_check");
var _createClass = require("@swc/helpers/_/_create_class");
var _inherits = require("@swc/helpers/_/_inherits");
var _slicedToArray = require("@swc/helpers/_/_sliced_to_array");
var _toArray = require("@swc/helpers/_/_to_array");
var _toConsumableArray = require("@swc/helpers/_/_to_consumable_array");
var _wrapNativeSuper = require("@swc/helpers/_/_wrap_native_super");
var _createSuper = require("@swc/helpers/_/_create_super");
var _tsGenerator = require("@swc/helpers/_/_ts_generator");
var _tsValues = require("@swc/helpers/_/_ts_values");
function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function _extends(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var Action;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})(Action || (Action = {}));
var PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function createMemoryHistory(options) {
    if (options === void 0) options = {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = Action.Pop;
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        var location = createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : createPath(to);
    }
    var history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            var path = typeof to === "string" ? parsePath(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = Action.Push;
            var nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = Action.Replace;
            var nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = Action.Pop;
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action,
                location: nextLocation,
                delta
            });
        },
        listen (fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function createBrowserHistory(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        var _window_location = window1.location, pathname = _window_location.pathname, search = _window_location.search, hash = _window_location.hash;
        return createLocation("", {
            pathname,
            search,
            hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : createPath(to);
    }
    return getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function createHashHistory(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        var _parsePath = parsePath(window1.location.hash.substr(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        return createLocation("", {
            pathname,
            search,
            hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        var base = window1.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window1.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : createPath(to));
    }
    function validateHashLocation(location, to) {
        warning(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function invariant(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function warning(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message); // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    var location = _extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? parsePath(to) : to, {
        state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function createPath(_ref) {
    var _ref_pathname = _ref.pathname, pathname = _ref_pathname === void 0 ? "/" : _ref_pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function parsePath(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    var _options_window = options.window, _$window = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = _$window.history;
    var action = Action.Pop;
    var listener = null;
    var index = getIndex(); // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState(_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        var state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = Action.Pop;
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action,
            location: history.location,
            delta
        });
    }
    function push(to, state) {
        action = Action.Push;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location); // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            _$window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = Action.Replace;
        var location = createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = getHistoryState(location, index);
        var url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        var base = _$window.location.origin !== "null" ? _$window.location.origin : _$window.location.href;
        var href = typeof to === "string" ? to : createPath(to);
        invariant(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(_$window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            _$window.addEventListener(PopStateEventType, handlePop);
            listener = fn;
            return function() {
                _$window.removeEventListener(PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(_$window, to);
        },
        createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push,
        replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
} //#endregion
var ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})(ResultType || (ResultType = {}));
var immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isIndexRoute(route) {
    return route.index === true;
} // Walk the route tree generating unique IDs where necessary so we are working
// solely with AgnosticDataRouteObject's within the Router
function convertRoutesToDataRoutes(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map(function(route, index) {
        var treePath = (0, _toConsumableArray._)(parentPath).concat([
            index
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        invariant(route.index !== true || !route.children, "Cannot specify children on an index route");
        invariant(!manifest[id], 'Found a route id collision on id "' + id + '".  Route ' + "id's must be globally unique within Data Router usages");
        if (isIndexRoute(route)) {
            var indexRoute = _extends({}, route, mapRouteProperties(route), {
                id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            var pathOrLayoutRoute = _extends({}, route, mapRouteProperties(route), {
                id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/utils/match-routes
 */ function matchRoutes(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    var location = typeof locationArg === "string" ? parsePath(locationArg) : locationArg;
    var pathname = stripBasename(location.pathname || "/", basename);
    if (pathname == null) return null;
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    var matches = null;
    for(var i = 0; matches == null && i < branches.length; ++i)matches = matchRouteBranch(branches[i], // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    safelyDecodeURI(pathname));
    return matches;
}
function flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    var flattenRoute = function(route, index, relativePath) {
        var meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route
        };
        if (meta.relativePath.startsWith("/")) {
            invariant(meta.relativePath.startsWith(parentPath), 'Absolute route path "' + meta.relativePath + '" nested under path ' + ('"' + parentPath + '" is not valid. An absolute child route path ') + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta); // Add the children before adding this route to the array so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            invariant(// @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ('all child routes from route path "' + path + '".'));
            flattenRoutes(route.children, branches, routesMeta, path);
        } // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path,
            score: computeScore(path, route.index),
            routesMeta
        });
    };
    routes.forEach(function(route, index) {
        var _route$path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function explodeOptionalSegments(path) {
    var // optional version for all children so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explodes _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, _toArray._)(segments), first = _segments[0], rest = _segments.slice(1); // Optional path segments are denoted by a trailing `?`
    var isOptional = first.endsWith("?"); // Compute the corresponding required segment: `foo?` -> `foo`
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = []; // All child paths with the prefix.  Do this for all children before the
    (_result = result).push.apply(_result, (0, _toConsumableArray._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    }))); // Then if this is an optional value, add all child versions without
    if (isOptional) (_result1 = result).push.apply(_result1, (0, _toConsumableArray._)(restExploded));
     // for absolute paths, ensure `/` instead of empty segment
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score // Higher score first
         : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:\w+$/;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    var siblings = a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    });
    return siblings ? // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // so they sort equally.
    0;
}
function matchRouteBranch(branch, pathname) {
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        var route = meta.route;
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/utils/generate-path
 */ function generatePath(originalPath, params) {
    if (params === void 0) params = {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        warning(false, 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
        path = path.replace(/\*$/, "/*");
    } // ensure `/` is added at the beginning if the path is absolute
    var prefix = path.startsWith("/") ? "/" : "";
    var segments = path.split(/\/+/).map(function(segment, index, array) {
        var isLastSegment = index === array.length - 1; // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            var star = "*";
            var starParam = params[star]; // Apply the splat
            return starParam;
        }
        var keyMatch = segment.match(/^:(\w+)(\??)$/);
        if (keyMatch) {
            var _keyMatch = (0, _slicedToArray._)(keyMatch, 3), key = _keyMatch[1], optional = _keyMatch[2];
            var param = params[key];
            if (optional === "?") return param == null ? "" : param;
            if (param == null) invariant(false, 'Missing ":' + key + '" param');
            return param;
        } // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    }) // Remove empty segments
    .filter(function(segment) {
        return !!segment;
    });
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/utils/match-path
 */ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, _slicedToArray._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], paramNames = _compilePath[1];
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    var captureGroups = match.slice(1);
    var params = paramNames.reduce(function(memo, paramName, index) {
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            var splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        memo[paramName] = safelyDecodeURIComponent(captureGroups[index] || "", paramName);
        return memo;
    }, {});
    return {
        params,
        pathname: matchedPathname,
        pathnameBase,
        pattern
    };
}
function compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    warning(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "' + path + '" will be treated as if it were ' + ('"' + path.replace(/\*$/, "/*") + '" because the `*` character must ') + "always follow a `/` in the pattern. To get rid of this warning, " + ('please change the route path to "' + path.replace(/\*$/, "/*") + '".'));
    var paramNames = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^$?{}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:(\w+)/g, function(_, paramName) {
        paramNames.push(paramName);
        return "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        paramNames.push("*");
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    var matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        paramNames
    ];
}
function safelyDecodeURI(value) {
    try {
        return decodeURI(value);
    } catch (error) {
        warning(false, 'The URL path "' + value + '" could not be decoded because it is is a ' + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
function safelyDecodeURIComponent(value, paramName) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        warning(false, 'The value for the URL param "' + paramName + '" will not be decoded because' + (' the string "' + value + '" is a malformed URL segment. This is probably') + (" due to a bad percent encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
     // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/utils/resolve-path
 */ function resolvePath(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    var _ref = typeof to === "string" ? parsePath(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname = toPathname ? toPathname.startsWith("/") ? toPathname : resolvePathname(toPathname, fromPathname) : fromPathname;
    return {
        pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = fromPathname.replace(/\/+$/, "").split("/");
    var relativeSegments = relativePath.split("/");
    relativeSegments.forEach(function(segment) {
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + 'a string in <Link to="..."> and the router will parse it for you.';
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
/**
 * @private
 */ function resolveTo(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    var to;
    if (typeof toArg === "string") to = parsePath(toArg);
    else {
        to = _extends({}, toArg);
        invariant(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        invariant(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        invariant(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from; // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (isPathRelative || toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/"); // Each leading .. segment means "go up one route" instead of "go up one
            // URL segment".  This is a key difference from how <a href> works and a
            // major reason we call this a "to" value instead of a "href".
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        } // If there are more ".." segments than parent routes, resolve relative to
        // the root / URL.
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from); // Ensure the pathname has a trailing slash if the original "to" had one
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/"); // Or if this was a link to the current path which has a trailing slash
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function getToPathname(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? parsePath(to).pathname : to.pathname;
}
/**
 * @private
 */ var joinPaths = function(paths) {
    return paths.join("/").replace(/\/\/+/g, "/");
};
/**
 * @private
 */ var normalizePathname = function(pathname) {
    return pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
};
/**
 * @private
 */ var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
/**
 * @private
 */ var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 */ var json = function json(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    var headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), _extends({}, responseInit, {
        headers
    }));
};
var AbortedDeferredError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, _inherits._)(AbortedDeferredError, Error1);
    var _super = (0, _createSuper._)(AbortedDeferredError);
    function AbortedDeferredError() {
        (0, _classCallCheck._)(this, AbortedDeferredError);
        return _super.apply(this, arguments);
    }
    return AbortedDeferredError;
}((0, _wrapNativeSuper._)(Error));
var DeferredData = /*#__PURE__*/ function() {
    "use strict";
    function DeferredData(data, responseInit) {
        var _this = this;
        (0, _classCallCheck._)(this, DeferredData);
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        invariant(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects"); // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        var reject;
        this.abortPromise = new Promise(function(_, r) {
            return reject = r;
        });
        this.controller = new AbortController();
        var onAbort = function() {
            return reject(new AbortedDeferredError("Deferred data aborted"));
        };
        this.unlistenAbortSignal = function() {
            return _this.controller.signal.removeEventListener("abort", onAbort);
        };
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce(function(acc, _ref) {
            var _$_ref = (0, _slicedToArray._)(_ref, 2), key = _$_ref[0], value = _$_ref[1];
            return Object.assign(acc, {
                [key]: _this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
    (0, _createClass._)(DeferredData, [
        {
            key: "trackPromise",
            value: function trackPromise(key, value) {
                var _this = this;
                if (!(value instanceof Promise)) return value;
                this.deferredKeys.push(key);
                this.pendingKeysSet.add(key); // We store a little wrapper promise that will be extended with
                // _data/_error props upon resolve/reject
                var promise = Promise.race([
                    value,
                    this.abortPromise
                ]).then(function(data) {
                    return _this.onSettle(promise, key, null, data);
                }, function(error) {
                    return _this.onSettle(promise, key, error);
                }); // Register rejection listeners to avoid uncaught promise rejections on
                // errors or aborted deferred values
                promise.catch(function() {});
                Object.defineProperty(promise, "_tracked", {
                    get: function() {
                        return true;
                    }
                });
                return promise;
            }
        },
        {
            key: "onSettle",
            value: function onSettle(promise, key, error, data) {
                if (this.controller.signal.aborted && error instanceof AbortedDeferredError) {
                    this.unlistenAbortSignal();
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    return Promise.reject(error);
                }
                this.pendingKeysSet.delete(key);
                if (this.done) // Nothing left to abort!
                this.unlistenAbortSignal();
                if (error) {
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return error;
                        }
                    });
                    this.emit(false, key);
                    return Promise.reject(error);
                }
                Object.defineProperty(promise, "_data", {
                    get: function() {
                        return data;
                    }
                });
                this.emit(false, key);
                return data;
            }
        },
        {
            key: "emit",
            value: function emit(aborted, settledKey) {
                this.subscribers.forEach(function(subscriber) {
                    return subscriber(aborted, settledKey);
                });
            }
        },
        {
            key: "subscribe",
            value: function subscribe(fn) {
                var _this = this;
                this.subscribers.add(fn);
                return function() {
                    return _this.subscribers.delete(fn);
                };
            }
        },
        {
            key: "cancel",
            value: function cancel() {
                var _this = this;
                this.controller.abort();
                this.pendingKeysSet.forEach(function(v, k) {
                    return _this.pendingKeysSet.delete(k);
                });
                this.emit(true);
            }
        },
        {
            key: "resolveData",
            value: function resolveData(signal) {
                var _this = this;
                return (0, _asyncToGenerator._)(function() {
                    var aborted, onAbort;
                    return (0, _tsGenerator._)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                aborted = false;
                                if (!!_this.done) return [
                                    3,
                                    2
                                ];
                                onAbort = function() {
                                    return _this.cancel();
                                };
                                signal.addEventListener("abort", onAbort);
                                return [
                                    4,
                                    new Promise(function(resolve) {
                                        _this.subscribe(function(aborted) {
                                            signal.removeEventListener("abort", onAbort);
                                            if (aborted || _this.done) resolve(aborted);
                                        });
                                    })
                                ];
                            case 1:
                                aborted = _state.sent();
                                _state.label = 2;
                            case 2:
                                return [
                                    2,
                                    aborted
                                ];
                        }
                    });
                })();
            }
        },
        {
            key: "done",
            get: function get() {
                return this.pendingKeysSet.size === 0;
            }
        },
        {
            key: "unwrappedData",
            get: function get() {
                invariant(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
                return Object.entries(this.data).reduce(function(acc, _ref2) {
                    var _$_ref2 = (0, _slicedToArray._)(_ref2, 2), key = _$_ref2[0], value = _$_ref2[1];
                    return Object.assign(acc, {
                        [key]: unwrapTrackedPromise(value)
                    });
                }, {});
            }
        },
        {
            key: "pendingKeys",
            get: function get() {
                return Array.from(this.pendingKeysSet);
            }
        }
    ]);
    return DeferredData;
}();
function isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function unwrapTrackedPromise(value) {
    if (!isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
var defer = function defer(data, init) {
    if (init === void 0) init = {};
    var responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new DeferredData(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ var redirect = function redirect(url, init) {
    if (init === void 0) init = 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, _extends({}, responseInit, {
        headers
    }));
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 */ var ErrorResponse = function ErrorResponse(status, statusText, data, internal) {
    "use strict";
    (0, _classCallCheck._)(this, ErrorResponse);
    if (internal === void 0) internal = false;
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
var validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
var validMutationMethods = new Set(validMutationMethodsArr);
var validRequestMethodsArr = [
    "get"
].concat((0, _toConsumableArray._)(validMutationMethodsArr));
var validRequestMethods = new Set(validRequestMethodsArr);
var redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var IDLE_NAVIGATION = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
var IDLE_FETCHER = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined
};
var IDLE_BLOCKER = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
var ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
var isServer = !isBrowser;
var defaultMapRouteProperties = function(route) {
    return {
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    };
}; //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function createRouter(init) {
    invariant(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
     // Routes keyed by ID
    var manifest = {}; // Routes in tree format for matching
    var dataRoutes = convertRoutesToDataRoutes(init.routes, mapRouteProperties, undefined, manifest);
    var inFlightDataRoutes;
    var basename = init.basename || "/"; // Config driven behavior flags
    var future = _extends({
        v7_normalizeFormMethod: false,
        v7_prependBasename: false
    }, init.future); // Cleanup function for history
    var unlistenHistory = null; // Externally-provided functions to call on all state changes
    var subscribers = new Set(); // Externally-provided object to hold scroll restoration locations during routing
    var savedScrollPositions = null; // Externally-provided function to get scroll restoration keys
    var getScrollRestorationKey = null; // Externally-provided function to get current scroll position
    var getScrollPosition = null; // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = matchRoutes(dataRoutes, init.history.location, basename);
    var initialErrors = null;
    if (initialMatches == null) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        var error = getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    var initialized = // functions around still then we'll need to run them in initialize()
    !initialMatches.some(function(m) {
        return m.route.lazy;
    }) && (!initialMatches.some(function(m) {
        return m.route.loader;
    }) || init.hydrationData != null);
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized,
        navigation: IDLE_NAVIGATION,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    }; // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    var pendingAction = Action.Pop; // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    var pendingPreventScrollReset = false; // AbortController for the active navigation
    var pendingNavigationController; // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    var isUninterruptedRevalidation = false; // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    var isRevalidationRequired = false; // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    var cancelledDeferredRoutes = []; // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    var cancelledFetcherLoads = []; // AbortControllers for any in-flight fetchers
    var fetchControllers = new Map(); // Track loads based on the order in which they started
    var incrementingLoadId = 0; // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    var pendingNavigationLoadId = -1; // Fetchers that triggered data reloads as a result of their actions
    var fetchReloadIds = new Map(); // Fetchers that triggered redirect navigations
    var fetchRedirectIds = new Set(); // Most recent href/match for fetcher.load calls for fetchers
    var fetchLoadMatches = new Map(); // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    var activeDeferreds = new Map(); // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    var blockerFunctions = new Map(); // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    var ignoreNextHistoryUpdate = false; // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen(function(_ref) {
            var historyAction = _ref.action, location = _ref.location, delta = _ref.delta;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (ignoreNextHistoryUpdate) {
                ignoreNextHistoryUpdate = false;
                return;
            }
            warning(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                ignoreNextHistoryUpdate = true;
                init.history.go(delta * -1); // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location
                        }); // Re-do the same POP navigation we just blocked
                        init.history.go(delta);
                    },
                    reset () {
                        deleteBlocker(blockerKey);
                        updateState({
                            blockers: new Map(router.state.blockers)
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        }); // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation(Action.Pop, state.location);
        return router;
    } // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    } // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return function() {
            return subscribers.delete(fn);
        };
    } // Update our state and notify the calling context of the change
    function updateState(newState) {
        state = _extends({}, state, newState);
        subscribers.forEach(function(subscriber) {
            return subscriber(state);
        });
    } // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState) {
        var _location$state, _location$state2;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
         // Always preserve any existing loaderData from re-used routes
        var loaderData = newState.loaderData ? mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData; // On a successful navigation we can assume we got through all blockers
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            // so we can start fresh
            for(var _iterator = blockerFunctions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 1), key = _step_value[0];
                deleteBlocker(key);
            } // Always respect the user flag.  Otherwise don't reset on mutation
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        // submission navigations unless they redirect
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        updateState(_extends({}, newState, {
            actionData,
            loaderData,
            historyAction: pendingAction,
            location,
            initialized: true,
            navigation: IDLE_NAVIGATION,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset,
            blockers: new Map(state.blockers)
        }));
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === Action.Pop) ;
        else if (pendingAction === Action.Push) init.history.push(location, location.state);
        else if (pendingAction === Action.Replace) init.history.replace(location, location.state);
         // Reset stateful navigation vars
        pendingAction = Action.Pop;
        pendingPreventScrollReset = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
        cancelledFetcherLoads = [];
    } // Trigger a navigation event, which can either be a numerical POP or a PUSH
    function navigate(to, opts) {
        return _navigate.apply(this, arguments);
    }
    function _navigate() {
        _navigate = // replace with an optional submission
        (0, _asyncToGenerator._)(function(to, opts) {
            var normalizedPath, _normalizeNavigateOptions, path, submission, error, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, blockerKey;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (typeof to === "number") {
                            init.history.go(to);
                            return [
                                2
                            ];
                        }
                        normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
                        _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        currentLocation = state.location;
                        nextLocation = createLocation(state.location, path, opts && opts.state); // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
                        // URL from window.location, so we need to encode it here so the behavior
                        // remains the same as POP and non-data-router usages.  new URL() does all
                        // the same encoding we'd get from a history.pushState/window.location read
                        // without having to touch history
                        nextLocation = _extends({}, nextLocation, init.history.encodeLocation(nextLocation));
                        userReplace = opts && opts.replace != null ? opts.replace : undefined;
                        historyAction = Action.Push;
                        if (userReplace === true) historyAction = Action.Replace;
                        else if (userReplace === false) ;
                        else if (submission != null && isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
                        // users don't have to double-click the back button to get to the prior
                        // location.  If the user redirects to a different location from the
                        // action/loader this will be ignored and the redirect will be a PUSH
                        historyAction = Action.Replace;
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
                        blockerKey = shouldBlockNavigation({
                            currentLocation,
                            nextLocation,
                            historyAction
                        });
                        if (blockerKey) {
                            // Put the blocker into a blocked state
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed () {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: undefined,
                                        reset: undefined,
                                        location: nextLocation
                                    }); // Send the same navigation through
                                    navigate(to, opts);
                                },
                                reset () {
                                    deleteBlocker(blockerKey);
                                    updateState({
                                        blockers: new Map(state.blockers)
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission,
                                // Send through the formData serialization error if we have one so we can
                                // render at the right error boundary after we match routes
                                pendingError: error,
                                preventScrollReset,
                                replace: opts && opts.replace
                            })
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        } // Revalidate all current loaders.  If a navigation is in progress or if this
        );
        return _navigate.apply(this, arguments);
    }
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        }); // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
         // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        } // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation
        });
    } // Start a navigation to the given action/location.  Can optionally provide a
    function startNavigation(historyAction, location, opts) {
        return _startNavigation.apply(this, arguments);
    }
    function _startNavigation() {
        _startNavigation = // overrideNavigation which will override the normalLoad in the case of a redirect
        // navigation
        (0, _asyncToGenerator._)(function(historyAction, location, opts) {
            var routesToUse, loadingNavigation, matches, error, _getShortCircuitMatches, notFoundMatches, route, request, pendingActionData, pendingError, actionOutput, navigation, _ref, shortCircuited, loaderData, errors;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Abort any in-progress navigations and start a new one. Unset any ongoing
                        // uninterrupted revalidations unless told otherwise, since we want this
                        // new navigation to update history normally
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true; // Save the current scroll position every time we start a new navigation,
                        // and track whether we should reset scroll on completion
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        loadingNavigation = opts && opts.overrideNavigation;
                        matches = matchRoutes(routesToUse, location, basename); // Short circuit with a 404 on the root error boundary if we match nothing
                        if (!matches) {
                            error = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(routesToUse), notFoundMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route; // Cancel all pending deferred on 404s since we don't keep any routes
                            cancelActiveDeferreds();
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: {
                                    [route.id]: error
                                }
                            });
                            return [
                                2
                            ];
                        } // Short circuit if it's only a hash change and not a mutation submission.
                        // Ignore on initial page loads because since the initial load will always
                        // be "same hash".
                        // For example, on /page#hash and submit a <Form method="post"> which will
                        // default to a navigation to /page
                        if (state.initialized && isHashChangeOnly(state.location, location) && !(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches
                            });
                            return [
                                2
                            ];
                        } // Create a controller/Request for this navigation
                        pendingNavigationController = new AbortController();
                        request = createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!(opts && opts.pendingError)) return [
                            3,
                            1
                        ];
                        // If we have a pendingError, it means the user attempted a GET submission
                        // with binary FormData so assign here and skip to handleLoaders.  That
                        // way we handle calling loaders above the boundary etc.  It's not really
                        // different from an actionError in that sense.
                        pendingError = {
                            [findNearestBoundary(matches).route.id]: opts.pendingError
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        if (!(opts && opts.submission && isMutationMethod(opts.submission.formMethod))) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, {
                                replace: opts.replace
                            })
                        ];
                    case 2:
                        actionOutput = _state.sent();
                        if (actionOutput.shortCircuited) return [
                            2
                        ];
                        pendingActionData = actionOutput.pendingActionData;
                        pendingError = actionOutput.pendingActionError;
                        navigation = _extends({
                            state: "loading",
                            location
                        }, opts.submission);
                        loadingNavigation = navigation; // Create a GET request for the loaders
                        request = new Request(request.url, {
                            signal: request.signal
                        });
                        _state.label = 3;
                    case 3:
                        return [
                            4,
                            handleLoaders(request, location, matches, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, pendingActionData, pendingError)
                        ];
                    case 4:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, loaderData = _ref.loaderData, errors = _ref.errors;
                        if (shortCircuited) return [
                            2
                        ];
                         // Clean up now that the action/loaders have completed.  Don't clean up if
                        // we short circuited because pendingNavigationController will have already
                        // been assigned to a new controller for the next navigation
                        pendingNavigationController = null;
                        completeNavigation(location, _extends({
                            matches
                        }, pendingActionData ? {
                            actionData: pendingActionData
                        } : {}, {
                            loaderData,
                            errors
                        }));
                        return [
                            2
                        ];
                }
            });
        } // Call the action matched by the leaf route for this navigation and handle
        );
        return _startNavigation.apply(this, arguments);
    }
    function handleAction(request, location, submission, matches, opts) {
        return _handleAction.apply(this, arguments);
    }
    function _handleAction() {
        _handleAction = // redirects/errors
        (0, _asyncToGenerator._)(function(request, location, submission, matches, opts) {
            var navigation, result, actionMatch, replace, boundaryMatch;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads(); // Put us in a submitting state
                        navigation = _extends({
                            state: "submitting",
                            location
                        }, submission);
                        updateState({
                            navigation
                        }); // Call our action and get the result
                        actionMatch = getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        result = {
                            type: ResultType.error,
                            error: getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 3;
                    case 3:
                        if (!isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else // If the user didn't explicity indicate replace behavior, replace if
                        // we redirected to the exact same location we're currently at to avoid
                        // double back-buttons
                        replace = result.location === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(state, result, {
                                submission,
                                replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        if (isErrorResult(result)) {
                            // Store off the pending error - we use it to determine which loaders
                            // to call and will commit it when we complete the navigation
                            boundaryMatch = findNearestBoundary(matches, actionMatch.route.id); // By default, all submissions are REPLACE navigations, but if the
                            // action threw an error that'll be rendered in an errorElement, we fall
                            // back to PUSH so that the user can use the back button to get back to
                            // the pre-submission form location to try again
                            if ((opts && opts.replace) !== true) pendingAction = Action.Push;
                            return [
                                2,
                                {
                                    // Send back an empty object we can use to clear out any prior actionData
                                    pendingActionData: {},
                                    pendingActionError: {
                                        [boundaryMatch.route.id]: result.error
                                    }
                                }
                            ];
                        }
                        if (isDeferredResult(result)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                        return [
                            2,
                            {
                                pendingActionData: {
                                    [actionMatch.route.id]: result.data
                                }
                            }
                        ];
                }
            });
        } // Call all applicable loaders for the given matches, handling redirects,
        );
        return _handleAction.apply(this, arguments);
    }
    function handleLoaders(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
        return _handleLoaders.apply(this, arguments);
    }
    function _handleLoaders() {
        _handleLoaders = // errors, etc.
        (0, _asyncToGenerator._)(function(request, location, matches, overrideNavigation, submission, fetcherSubmission, replace, pendingActionData, pendingError) {
            var loadingNavigation, navigation, activeSubmission, routesToUse, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, updatedFetchers, actionData, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, updatedFetchers1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Figure out the right navigation we want to use for data loading
                        loadingNavigation = overrideNavigation;
                        if (!loadingNavigation) {
                            navigation = _extends({
                                state: "loading",
                                location,
                                formMethod: undefined,
                                formAction: undefined,
                                formEncType: undefined,
                                formData: undefined
                            }, submission);
                            loadingNavigation = navigation;
                        } // If this was a redirect from an action we don't have a "submission" but
                        // we have it on the loading navigation so use that if available
                        activeSubmission = submission || fetcherSubmission ? submission || fetcherSubmission : loadingNavigation.formMethod && loadingNavigation.formAction && loadingNavigation.formData && loadingNavigation.formEncType ? {
                            formMethod: loadingNavigation.formMethod,
                            formAction: loadingNavigation.formAction,
                            formData: loadingNavigation.formData,
                            formEncType: loadingNavigation.formEncType
                        } : undefined;
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        _getMatchesToLoad = (0, _slicedToArray._)(getMatchesToLoad(init.history, state, matches, activeSubmission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1]; // Cancel pending deferreds for no-longer-matched routes or routes we're
                        // about to reload.  Note that if this is an action reload we would have
                        // already cancelled all pending deferreds so this would be a no-op
                        cancelActiveDeferreds(function(routeId) {
                            return !(matches && matches.some(function(m) {
                                return m.route.id === routeId;
                            })) || matchesToLoad && matchesToLoad.some(function(m) {
                                return m.route.id === routeId;
                            });
                        }); // Short circuit if we have no loaders to run
                        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
                            updatedFetchers = markFetchRedirectsDone();
                            completeNavigation(location, _extends({
                                matches,
                                loaderData: {},
                                // Commit pending error if we're short circuiting
                                errors: pendingError || null
                            }, pendingActionData ? {
                                actionData: pendingActionData
                            } : {}, updatedFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        } // If this is an uninterrupted revalidation, we remain in our current idle
                        // state.  If not, we need to switch to our loading state and load data,
                        // preserving any new action data or existing action data (in the case of
                        // a revalidation interrupting an actionReload)
                        if (!isUninterruptedRevalidation) {
                            revalidatingFetchers.forEach(function(rf) {
                                var fetcher = state.fetchers.get(rf.key);
                                var revalidatingFetcher = {
                                    state: "loading",
                                    data: fetcher && fetcher.data,
                                    formMethod: undefined,
                                    formAction: undefined,
                                    formEncType: undefined,
                                    formData: undefined,
                                    " _hasFetcherDoneAnything ": true
                                };
                                state.fetchers.set(rf.key, revalidatingFetcher);
                            });
                            actionData = pendingActionData || state.actionData;
                            updateState(_extends({
                                navigation: loadingNavigation
                            }, actionData ? Object.keys(actionData).length === 0 ? {
                                actionData: null
                            } : {
                                actionData
                            } : {}, revalidatingFetchers.length > 0 ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                        }
                        pendingNavigationLoadId = ++incrementingLoadId;
                        revalidatingFetchers.forEach(function(rf) {
                            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
                            // (via deleteFetcher) does not abort the triggering navigation that
                            // triggered the revalidation
                            fetchControllers.set(rf.key, rf.controller);
                        }); // Proxy navigation abort through to revalidation fetchers
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, request)
                        ];
                    case 1:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                         // Clean up _after_ loaders have completed.  Don't clean up if we short
                        // circuited because fetchControllers would have been aborted and
                        // reassigned to new controllers for the next navigation
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        }); // If any loaders returned a redirect Response, start a new REPLACE navigation
                        redirect = findRedirect(results);
                        if (!redirect) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            startRedirectNavigation(state, redirect, {
                                replace
                            })
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 3:
                        _processLoaderData = processLoaderData(state, matches, matchesToLoad, loaderResults, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors; // Wire up subscribers to update loaderData as promises settle
                        activeDeferreds.forEach(function(deferredData, routeId) {
                            deferredData.subscribe(function(aborted) {
                                // Note: No need to updateState here since the TrackedPromise on
                                // loaderData is stable across resolve/reject
                                // Remove this instance if we were aborted or if promises have settled
                                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
                            });
                        });
                        updatedFetchers1 = markFetchRedirectsDone();
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
                        shouldUpdateFetchers = updatedFetchers1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            _extends({
                                loaderData,
                                errors
                            }, shouldUpdateFetchers ? {
                                fetchers: new Map(state.fetchers)
                            } : {})
                        ];
                }
            });
        });
        return _handleLoaders.apply(this, arguments);
    }
    function getFetcher(key) {
        return state.fetchers.get(key) || IDLE_FETCHER;
    } // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        if (fetchControllers.has(key)) abortFetcher(key);
        var routesToUse = inFlightDataRoutes || dataRoutes;
        var normalizedPath = normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, routeId, opts == null ? void 0 : opts.relative);
        var matches = matchRoutes(routesToUse, normalizedPath, basename);
        if (!matches) {
            setFetcherError(key, routeId, getInternalRouterError(404, {
                pathname: normalizedPath
            }));
            return;
        }
        var _normalizeNavigateOptions = normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission;
        var match = getTargetMatch(matches, path);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, submission);
            return;
        } // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId,
            path
        });
        handleFetcherLoader(key, routeId, path, match, matches, submission);
    } // Call the action for the matched fetcher.submit(), and then handle redirects,
    function handleFetcherAction(key, routeId, path, match, requestMatches, submission) {
        return _handleFetcherAction.apply(this, arguments);
    }
    function _handleFetcherAction() {
        _handleFetcherAction = // errors, and revalidation
        (0, _asyncToGenerator._)(function(key, routeId, path, match, requestMatches, submission) {
            var error, existingFetcher, fetcher, abortController, fetchRequest, actionResult, loadingFetcher, nextLocation, revalidationRequest, routesToUse, matches, loadId, loadFetcher, _getMatchesToLoad, matchesToLoad, revalidatingFetchers, abortPendingFetchRevalidations, _ref, results, loaderResults, fetcherResults, redirect, _processLoaderData, loaderData, errors, doneFetcher, didAbortFetchLoads;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        if (!match.route.action && !match.route.lazy) {
                            error = getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            });
                            setFetcherError(key, routeId, error);
                            return [
                                2
                            ];
                        } // Put this fetcher into it's submitting state
                        existingFetcher = state.fetchers.get(key);
                        fetcher = _extends({
                            state: "submitting"
                        }, submission, {
                            data: existingFetcher && existingFetcher.data,
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, fetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        }); // Call the action for the fetcher
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal, submission);
                        fetchControllers.set(key, abortController);
                        return [
                            4,
                            callLoaderOrAction("action", fetchRequest, match, requestMatches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        actionResult = _state.sent();
                        if (fetchRequest.signal.aborted) {
                            // We can delete this so long as we weren't aborted by ou our own fetcher
                            // re-submit which would have put _new_ controller is in fetchControllers
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if (isRedirectResult(actionResult)) {
                            fetchControllers.delete(key);
                            fetchRedirectIds.add(key);
                            loadingFetcher = _extends({
                                state: "loading"
                            }, submission, {
                                data: undefined,
                                " _hasFetcherDoneAnything ": true
                            });
                            state.fetchers.set(key, loadingFetcher);
                            updateState({
                                fetchers: new Map(state.fetchers)
                            });
                            return [
                                2,
                                startRedirectNavigation(state, actionResult, {
                                    submission,
                                    isFetchActionRedirect: true
                                })
                            ];
                        } // Process any non-redirect errors thrown
                        if (isErrorResult(actionResult)) {
                            setFetcherError(key, routeId, actionResult.error);
                            return [
                                2
                            ];
                        }
                        if (isDeferredResult(actionResult)) throw getInternalRouterError(400, {
                            type: "defer-action"
                        });
                         // Start the data load for current matches, or the next location if we're
                        // in the middle of a navigation
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = inFlightDataRoutes || dataRoutes;
                        matches = state.navigation.state !== "idle" ? matchRoutes(routesToUse, state.navigation.location, basename) : state.matches;
                        invariant(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        loadFetcher = _extends({
                            state: "loading",
                            data: actionResult.data
                        }, submission, {
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, loadFetcher);
                        _getMatchesToLoad = (0, _slicedToArray._)(getMatchesToLoad(init.history, state, matches, submission, nextLocation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, {
                            [match.route.id]: actionResult.data
                        }, undefined // No need to send through errors since we short circuit above
                        ), 2), matchesToLoad = _getMatchesToLoad[0], revalidatingFetchers = _getMatchesToLoad[1]; // Put all revalidating fetchers into the loading state, except for the
                        // current fetcher which we want to keep in it's current loading state which
                        // contains it's action submission info + action data
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = state.fetchers.get(staleKey);
                            var revalidatingFetcher = {
                                state: "loading",
                                data: existingFetcher && existingFetcher.data,
                                formMethod: undefined,
                                formAction: undefined,
                                formEncType: undefined,
                                formData: undefined,
                                " _hasFetcherDoneAnything ": true
                            };
                            state.fetchers.set(staleKey, revalidatingFetcher);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(state.matches, matches, matchesToLoad, revalidatingFetchers, revalidationRequest)
                        ];
                    case 2:
                        _ref = _state.sent(), results = _ref.results, loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) return [
                            2
                        ];
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        redirect = findRedirect(results);
                        if (redirect) return [
                            2,
                            startRedirectNavigation(state, redirect)
                        ];
                         // Process and commit output from loaders
                        _processLoaderData = processLoaderData(state, state.matches, matchesToLoad, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        doneFetcher = {
                            state: "idle",
                            data: actionResult.data,
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined,
                            " _hasFetcherDoneAnything ": true
                        };
                        state.fetchers.set(key, doneFetcher);
                        didAbortFetchLoads = abortStaleFetchLoads(loadId); // If we are currently in a navigation loading state and this fetcher is
                        // more recent than the navigation, we want the newer data so abort the
                        // navigation and complete it with the fetcher data
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            invariant(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches,
                                loaderData,
                                errors,
                                fetchers: new Map(state.fetchers)
                            });
                        } else {
                            // otherwise just update with the fetcher data, preserving any existing
                            // loaderData for loaders that did not need to reload.  We have to
                            // manually merge here since we aren't going through completeNavigation
                            updateState(_extends({
                                errors,
                                loaderData: mergeLoaderData(state.loaderData, loaderData, matches, errors)
                            }, didAbortFetchLoads ? {
                                fetchers: new Map(state.fetchers)
                            } : {}));
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        } // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
        );
        return _handleFetcherAction.apply(this, arguments);
    }
    function handleFetcherLoader(key, routeId, path, match, matches, submission) {
        return _handleFetcherLoader.apply(this, arguments);
    }
    function _handleFetcherLoader() {
        _handleFetcherLoader = (0, _asyncToGenerator._)(function(key, routeId, path, match, matches, submission) {
            var existingFetcher, loadingFetcher, abortController, fetchRequest, result, boundaryMatch, doneFetcher;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key); // Put this fetcher into it's loading state
                        loadingFetcher = _extends({
                            state: "loading",
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined
                        }, submission, {
                            data: existingFetcher && existingFetcher.data,
                            " _hasFetcherDoneAnything ": true
                        });
                        state.fetchers.set(key, loadingFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        }); // Call the loader for this fetcher route match
                        abortController = new AbortController();
                        fetchRequest = createClientSideRequest(init.history, path, abortController.signal);
                        fetchControllers.set(key, abortController);
                        return [
                            4,
                            callLoaderOrAction("loader", fetchRequest, match, matches, manifest, mapRouteProperties, basename)
                        ];
                    case 1:
                        result = _state.sent();
                        if (!isDeferredResult(result)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            resolveDeferredData(result, fetchRequest.signal, true)
                        ];
                    case 2:
                        result = _state.sent() || result;
                        _state.label = 3;
                    case 3:
                        // re-load which would have put _new_ controller is in fetchControllers
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                         // If the loader threw a redirect Response, start a new REPLACE navigation
                        if (!isRedirectResult(result)) return [
                            3,
                            5
                        ];
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(state, result)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        if (isErrorResult(result)) {
                            boundaryMatch = findNearestBoundary(state.matches, routeId);
                            state.fetchers.delete(key); // TODO: In remix, this would reset to IDLE_NAVIGATION if it was a catch -
                            // do we need to behave any differently with our non-redirect errors?
                            // What if it was a non-redirect Response?
                            updateState({
                                fetchers: new Map(state.fetchers),
                                errors: {
                                    [boundaryMatch.route.id]: result.error
                                }
                            });
                            return [
                                2
                            ];
                        }
                        invariant(!isDeferredResult(result), "Unhandled fetcher deferred data"); // Put the fetcher back into an idle state
                        doneFetcher = {
                            state: "idle",
                            data: result.data,
                            formMethod: undefined,
                            formAction: undefined,
                            formEncType: undefined,
                            formData: undefined,
                            " _hasFetcherDoneAnything ": true
                        };
                        state.fetchers.set(key, doneFetcher);
                        updateState({
                            fetchers: new Map(state.fetchers)
                        });
                        return [
                            2
                        ];
                }
            });
        });
        return _handleFetcherLoader.apply(this, arguments);
    }
    function startRedirectNavigation(state, redirect, _temp) {
        return _startRedirectNavigation.apply(this, arguments);
    }
    function _startRedirectNavigation() {
        _startRedirectNavigation = /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ (0, _asyncToGenerator._)(function(state, redirect, _temp) {
            var _window, _ref, submission, replace, isFetchActionRedirect, redirectLocation, url, isDifferentBasename, redirectHistoryAction, _state_navigation, formMethod, formAction, formEncType, formData;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp === void 0 ? {} : _temp, submission = _ref.submission, replace = _ref.replace, isFetchActionRedirect = _ref.isFetchActionRedirect;
                        if (redirect.revalidate) isRevalidationRequired = true;
                        redirectLocation = createLocation(state.location, redirect.location, _extends({
                            _isRedirect: true
                        }, isFetchActionRedirect ? {
                            _isFetchActionRedirect: true
                        } : {}));
                        invariant(redirectLocation, "Expected a location on the redirect navigation"); // Check if this an absolute external redirect that goes to a new origin
                        if (ABSOLUTE_URL_REGEX.test(redirect.location) && isBrowser && typeof ((_window = window) == null ? void 0 : _window.location) !== "undefined") {
                            url = init.history.createURL(redirect.location);
                            isDifferentBasename = stripBasename(url.pathname, basename) == null;
                            if (window.location.origin !== url.origin || isDifferentBasename) {
                                if (replace) window.location.replace(redirect.location);
                                else window.location.assign(redirect.location);
                                return [
                                    2
                                ];
                            }
                        } // There's no need to abort on redirects, since we don't detect the
                        // redirect until the action/loaders have settled
                        pendingNavigationController = null;
                        redirectHistoryAction = replace === true ? Action.Replace : Action.Push; // Use the incoming submission if provided, fallback on the active one in
                        // state.navigation
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType, formData = _state_navigation.formData;
                        if (!submission && formMethod && formAction && formData && formEncType) submission = {
                            formMethod,
                            formAction,
                            formEncType,
                            formData
                        };
                         // If this was a 307/308 submission we want to preserve the HTTP method and
                        if (!(redirectPreserveMethodStatusCodes.has(redirect.status) && submission && isMutationMethod(submission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                submission: _extends({}, submission, {
                                    formAction: redirect.location
                                }),
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 2:
                        if (!isFetchActionRedirect) return [
                            3,
                            4
                        ];
                        // For a fetch action redirect, we kick off a new loading navigation
                        // without the fetcher submission, but we send it along for shouldRevalidate
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: {
                                    state: "loading",
                                    location: redirectLocation,
                                    formMethod: undefined,
                                    formAction: undefined,
                                    formEncType: undefined,
                                    formData: undefined
                                },
                                fetcherSubmission: submission,
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            6
                        ];
                    case 4:
                        // Otherwise, we kick off a new loading navigation, preserving the
                        // submission info for the duration of this navigation
                        return [
                            4,
                            startNavigation(redirectHistoryAction, redirectLocation, {
                                overrideNavigation: {
                                    state: "loading",
                                    location: redirectLocation,
                                    formMethod: submission ? submission.formMethod : undefined,
                                    formAction: submission ? submission.formAction : undefined,
                                    formEncType: submission ? submission.formEncType : undefined,
                                    formData: submission ? submission.formData : undefined
                                },
                                // Preserve this flag across redirects
                                preventScrollReset: pendingPreventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        _state.label = 6;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _startRedirectNavigation.apply(this, arguments);
    }
    function callLoadersAndMaybeResolveData(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function _callLoadersAndMaybeResolveData() {
        _callLoadersAndMaybeResolveData = (0, _asyncToGenerator._)(function(currentMatches, matches, matchesToLoad, fetchersToLoad, request) {
            var results, loaderResults, fetcherResults;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            Promise.all((0, _toConsumableArray._)(matchesToLoad.map(function(match) {
                                return callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename);
                            })).concat((0, _toConsumableArray._)(fetchersToLoad.map(function(f) {
                                if (f.matches && f.match && f.controller) return callLoaderOrAction("loader", createClientSideRequest(init.history, f.path, f.controller.signal), f.match, f.matches, manifest, mapRouteProperties, basename);
                                else {
                                    var error = {
                                        type: ResultType.error,
                                        error: getInternalRouterError(404, {
                                            pathname: f.path
                                        })
                                    };
                                    return error;
                                }
                            }))))
                        ];
                    case 1:
                        results = _state.sent();
                        loaderResults = results.slice(0, matchesToLoad.length);
                        fetcherResults = results.slice(matchesToLoad.length);
                        return [
                            4,
                            Promise.all([
                                resolveDeferredResults(currentMatches, matchesToLoad, loaderResults, loaderResults.map(function() {
                                    return request.signal;
                                }), false, state.loaderData),
                                resolveDeferredResults(currentMatches, fetchersToLoad.map(function(f) {
                                    return f.match;
                                }), fetcherResults, fetchersToLoad.map(function(f) {
                                    return f.controller ? f.controller.signal : null;
                                }), true)
                            ])
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            {
                                results,
                                loaderResults,
                                fetcherResults
                            }
                        ];
                }
            });
        });
        return _callLoadersAndMaybeResolveData.apply(this, arguments);
    }
    function interruptActiveLoads() {
        var // revalidation
        _cancelledDeferredRoutes;
        // Every interruption triggers a revalidation
        isRevalidationRequired = true; // Cancel pending route-level deferreds and mark cancelled routes for
        (_cancelledDeferredRoutes = cancelledDeferredRoutes).push.apply(_cancelledDeferredRoutes, (0, _toConsumableArray._)(cancelActiveDeferreds())); // Abort in-flight fetcher loads
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) {
                cancelledFetcherLoads.push(key);
                abortFetcher(key);
            }
        });
    }
    function setFetcherError(key, routeId, error) {
        var boundaryMatch = findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        });
    }
    function deleteFetcher(key) {
        if (fetchControllers.has(key)) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        state.fetchers.delete(key);
    }
    function abortFetcher(key) {
        var controller = fetchControllers.get(key);
        invariant(controller, "Expected fetch controller: " + key);
        controller.abort();
        fetchControllers.delete(key);
    }
    function markFetchersDone(keys) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = getFetcher(key);
                var doneFetcher = {
                    state: "idle",
                    data: fetcher.data,
                    formMethod: undefined,
                    formAction: undefined,
                    formEncType: undefined,
                    formData: undefined,
                    " _hasFetcherDoneAnything ": true
                };
                state.fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone() {
        var doneKeys = [];
        var updatedFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = state.fetchers.get(key);
                invariant(fetcher, "Expected fetcher: " + key);
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    updatedFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = state.fetchers.get(key);
                    invariant(fetcher, "Expected fetcher: " + key);
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    } // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || IDLE_BLOCKER; // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        invariant(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        state.blockers.set(key, newBlocker);
        updateState({
            blockers: new Map(state.blockers)
        });
    }
    function shouldBlockNavigation(_ref2) {
        var currentLocation = _ref2.currentLocation, nextLocation = _ref2.nextLocation, historyAction = _ref2.historyAction;
        if (blockerFunctions.size === 0) return;
         // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) warning(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, _slicedToArray._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
         // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation,
            nextLocation,
            historyAction
        })) return blockerKey;
    }
    function cancelActiveDeferreds(predicate) {
        var cancelledRouteIds = [];
        activeDeferreds.forEach(function(dfd, routeId) {
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    } // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || function(location) {
            return location.key;
        }; // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === IDLE_NAVIGATION) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            var userMatches = matches.map(function(m) {
                return createUseMatchesMatch(m, state.loaderData);
            });
            var key = getScrollRestorationKey(location, userMatches) || location.key;
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollRestorationKey && getScrollPosition) {
            var userMatches = matches.map(function(m) {
                return createUseMatchesMatch(m, state.loaderData);
            });
            var key = getScrollRestorationKey(location, userMatches) || location.key;
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = convertRoutesToDataRoutes(newRoutes, mapRouteProperties, undefined, manifest);
    }
    router = {
        get basename () {
            return basename;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        initialize,
        subscribe,
        enableScrollRestoration,
        navigate,
        fetch,
        revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: function(to) {
            return init.history.createHref(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher,
        deleteFetcher,
        dispose,
        getBlocker,
        deleteBlocker,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
var UNSAFE_DEFERRED_SYMBOL = Symbol("deferred");
function createStaticHandler(routes, opts) {
    invariant(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        var detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = function(route) {
            return {
                hasErrorBoundary: detectErrorBoundary(route)
            };
        };
    } else mapRouteProperties = defaultMapRouteProperties;
    var dataRoutes = convertRoutesToDataRoutes(routes, mapRouteProperties, undefined, manifest);
    function query(request, _temp2) {
        return _query.apply(this, arguments);
    }
    function _query() {
        _query = /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   */ (0, _asyncToGenerator._)(function(request, _temp2) {
            var requestContext, url, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, error1, _getShortCircuitMatches1, notFoundMatches, route1, result;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        requestContext = (_temp2 === void 0 ? {} : _temp2).requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD") {
                            error = getInternalRouterError(405, {
                                method
                            });
                            _getShortCircuitMatches = getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            return [
                                2,
                                {
                                    basename,
                                    location,
                                    matches: methodNotAllowedMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: {
                                        [route.id]: error
                                    },
                                    statusCode: error.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        } else if (!matches) {
                            error1 = getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            return [
                                2,
                                {
                                    basename,
                                    location,
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    actionData: null,
                                    errors: {
                                        [route1.id]: error1
                                    },
                                    statusCode: error1.status,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                         // When returning StaticHandlerContext, we patch back in the location here
                        // since we need it for React Context.  But this helps keep our submit and
                        // loadRouteData operating on a Request instead of a Location
                        return [
                            2,
                            _extends({
                                location,
                                basename
                            }, result)
                        ];
                }
            });
        });
        return _query.apply(this, arguments);
    }
    function queryRoute(request, _temp3) {
        return _queryRoute.apply(this, arguments);
    }
    function _queryRoute() {
        _queryRoute = /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   */ (0, _asyncToGenerator._)(function(request, _temp3) {
            var _ref, routeId, requestContext, url, method, location, matches, match, result, error, _result$activeDeferre, data;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _temp3 === void 0 ? {} : _temp3, routeId = _ref.routeId, requestContext = _ref.requestContext;
                        url = new URL(request.url);
                        method = request.method;
                        location = createLocation("", createPath(url), null, "default");
                        matches = matchRoutes(dataRoutes, location, basename); // SSR supports HEAD requests while SPA doesn't
                        if (!isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw getInternalRouterError(405, {
                            method
                        });
                        else if (!matches) throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : getTargetMatch(matches, location);
                        if (routeId && !match) throw getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId
                        });
                        else if (!match) // This should never hit I don't think?
                        throw getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, match)
                        ];
                    case 1:
                        result = _state.sent();
                        if (isResponse(result)) return [
                            2,
                            result
                        ];
                        error = result.errors ? Object.values(result.errors)[0] : undefined;
                        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
                        // _something_ that wasn't a Response, but it's not guaranteed/required
                        // to be an `instanceof Error` either, so we have to use throw here to
                        // preserve the "error" state outside of queryImpl.
                        throw error;
                         // Pick off the right state value to return
                        if (result.actionData) return [
                            2,
                            Object.values(result.actionData)[0]
                        ];
                        if (result.loaderData) {
                            ;
                            data = Object.values(result.loaderData)[0];
                            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[UNSAFE_DEFERRED_SYMBOL] = result.activeDeferreds[match.route.id];
                            return [
                                2,
                                data
                            ];
                        }
                        return [
                            2,
                            undefined
                        ];
                }
            });
        });
        return _queryRoute.apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, routeMatch) {
        return _queryImpl.apply(this, arguments);
    }
    function _queryImpl() {
        _queryImpl = (0, _asyncToGenerator._)(function(request, location, matches, requestContext, routeMatch) {
            var result, result1, e;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        invariant(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!isMutationMethod(request.method.toLowerCase())) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, matches, routeMatch || getTargetMatch(matches, location), requestContext, routeMatch != null)
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, routeMatch)
                        ];
                    case 4:
                        result1 = _state.sent();
                        return [
                            2,
                            isResponse(result1) ? result1 : _extends({}, result1, {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        // If the user threw/returned a Response in callLoaderOrAction, we throw
                        // it to bail out and then return or throw here based on whether the user
                        // returned or threw
                        if (isQueryRouteResponse(e)) {
                            if (e.type === ResultType.error && !isRedirectResponse(e.response)) throw e.response;
                            return [
                                2,
                                e.response
                            ];
                        } // Redirects are always returned since they don't propagate to catch
                        // boundaries
                        if (isRedirectResponse(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        });
        return _queryImpl.apply(this, arguments);
    }
    function submit(request, matches, actionMatch, requestContext, isRouteRequest) {
        return _submit.apply(this, arguments);
    }
    function _submit() {
        _submit = (0, _asyncToGenerator._)(function(request, matches, actionMatch, requestContext, isRouteRequest) {
            var result, error, method, error1, boundaryMatch, context, loaderRequest, context1;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: ResultType.error,
                            error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callLoaderOrAction("action", request, actionMatch, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext)
                        ];
                    case 2:
                        result = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        }
                        _state.label = 3;
                    case 3:
                        if (isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
                        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
                        // can get back on the "throw all redirect responses" train here should
                        // this ever happen :/
                        throw new Response(null, {
                            status: result.status,
                            headers: {
                                Location: result.location
                            }
                        });
                        if (isDeferredResult(result)) {
                            error1 = getInternalRouterError(400, {
                                type: "defer-action"
                            });
                            if (isRouteRequest) throw error1;
                            result = {
                                type: ResultType.error,
                                error: error1
                            };
                        }
                        if (isRouteRequest) {
                            // Note: This should only be non-Response values if we get here, since
                            // isRouteRequest should throw any Response received in callLoaderOrAction
                            if (isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: {
                                        [actionMatch.route.id]: result.data
                                    },
                                    errors: null,
                                    // Note: statusCode + headers are unused here since queryRoute will
                                    // return the raw Response or value
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {},
                                    activeDeferreds: null
                                }
                            ];
                        }
                        if (!isErrorResult(result)) return [
                            3,
                            5
                        ];
                        // Store off the pending error - we use it to determine which loaders
                        // to call and will commit it when we complete the navigation
                        boundaryMatch = findNearestBoundary(matches, actionMatch.route.id);
                        return [
                            4,
                            loadRouteData(request, matches, requestContext, undefined, {
                                [boundaryMatch.route.id]: result.error
                            })
                        ];
                    case 4:
                        context = _state.sent();
                        return [
                            2,
                            _extends({}, context, {
                                statusCode: isRouteErrorResponse(result.error) ? result.error.status : 500,
                                actionData: null,
                                actionHeaders: _extends({}, result.headers ? {
                                    [actionMatch.route.id]: result.headers
                                } : {})
                            })
                        ];
                    case 5:
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        return [
                            4,
                            loadRouteData(loaderRequest, matches, requestContext)
                        ];
                    case 6:
                        context1 = _state.sent();
                        return [
                            2,
                            _extends({}, context1, result.statusCode ? {
                                statusCode: result.statusCode
                            } : {}, {
                                actionData: {
                                    [actionMatch.route.id]: result.data
                                },
                                actionHeaders: _extends({}, result.headers ? {
                                    [actionMatch.route.id]: result.headers
                                } : {})
                            })
                        ];
                }
            });
        });
        return _submit.apply(this, arguments);
    }
    function loadRouteData(request, matches, requestContext, routeMatch, pendingActionError) {
        return _loadRouteData.apply(this, arguments);
    }
    function _loadRouteData() {
        _loadRouteData = (0, _asyncToGenerator._)(function(request, matches, requestContext, routeMatch, pendingActionError) {
            var isRouteRequest, requestMatches, matchesToLoad, results, method, activeDeferreds, context, executedLoaders;
            return (0, _tsGenerator._)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null; // Short circuit if we have no loaders to run (queryRoute())
                        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch == null ? void 0 : routeMatch.route.id
                        });
                        requestMatches = routeMatch ? [
                            routeMatch
                        ] : getLoaderMatchesUntilBoundary(matches, Object.keys(pendingActionError || {})[0]);
                        matchesToLoad = requestMatches.filter(function(m) {
                            return m.route.loader || m.route.lazy;
                        }); // Short circuit if we have no loaders to run (query())
                        if (matchesToLoad.length === 0) return [
                            2,
                            {
                                matches,
                                // Add a null for all matched routes for proper revalidation on the client
                                loaderData: matches.reduce(function(acc, m) {
                                    return Object.assign(acc, {
                                        [m.route.id]: null
                                    });
                                }, {}),
                                errors: pendingActionError || null,
                                statusCode: 200,
                                loaderHeaders: {},
                                activeDeferreds: null
                            }
                        ];
                        return [
                            4,
                            Promise.all((0, _toConsumableArray._)(matchesToLoad.map(function(match) {
                                return callLoaderOrAction("loader", request, match, matches, manifest, mapRouteProperties, basename, true, isRouteRequest, requestContext);
                            })))
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) {
                            method = isRouteRequest ? "queryRoute" : "query";
                            throw new Error(method + "() call aborted");
                        } // Process and commit output from loaders
                        activeDeferreds = new Map();
                        context = processRouteLoaderData(matches, matchesToLoad, results, pendingActionError, activeDeferreds); // Add a null for any non-loader matches for proper revalidation on the client
                        executedLoaders = new Set(matchesToLoad.map(function(match) {
                            return match.route.id;
                        }));
                        matches.forEach(function(match) {
                            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
                        });
                        return [
                            2,
                            _extends({}, context, {
                                matches,
                                activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
                            })
                        ];
                }
            });
        });
        return _loadRouteData.apply(this, arguments);
    }
    return {
        dataRoutes,
        query,
        queryRoute
    };
} //#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function getStaticContextFromError(routes, context, error) {
    var newContext = _extends({}, context, {
        statusCode: 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function isSubmissionNavigation(opts) {
    return opts != null && "formData" in opts;
}
function normalizeTo(location, matches, basename, prependBasename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId != null && relative !== "path") {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route.  When using relative:path,
        // fromRouteId is ignored since that is always relative to the current
        // location path
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    } // Resolve the relative path
    var path = resolveTo(to ? to : ".", getPathContributingMatches(contextualMatches).map(function(m) {
        return m.pathnameBase;
    }), stripBasename(location.pathname, basename) || location.pathname, relative === "path"); // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    } // Add an ?index param for matched index routes if we don't already have one
    if ((to == null || to === "" || to === ".") && activeRouteMatch && activeRouteMatch.route.index && !hasNakedIndexQuery(path.search)) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
     // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : joinPaths([
        basename,
        path.pathname
    ]);
    return createPath(path);
} // Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !isSubmissionNavigation(opts)) return {
        path
    };
    if (opts.formMethod && !isValidMethod(opts.formMethod)) return {
        path,
        error: getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
     // Create a Submission on non-GET navigations
    var submission;
    if (opts.formData) {
        var formMethod = opts.formMethod || "get";
        submission = {
            formMethod: normalizeFormMethod ? formMethod.toUpperCase() : formMethod.toLowerCase(),
            formAction: stripHashFromPath(path),
            formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
            formData: opts.formData
        };
        if (isMutationMethod(submission.formMethod)) return {
            path,
            submission
        };
    } // Flatten submission onto URLSearchParams for GET submissions
    var parsedPath = parsePath(path);
    var searchParams = convertFormDataToSearchParams(opts.formData); // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: createPath(parsedPath),
        submission
    };
} // Filter out all routes below any caught error as they aren't going to
// render so we don't need to load them
function getLoaderMatchesUntilBoundary(matches, boundaryId) {
    var boundaryMatches = matches;
    if (boundaryId) {
        var index = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
        if (index >= 0) boundaryMatches = matches.slice(0, index);
    }
    return boundaryMatches;
}
function getMatchesToLoad(history, state, matches, submission, location, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, fetchLoadMatches, routesToUse, basename, pendingActionData, pendingError) {
    var actionResult = pendingError ? Object.values(pendingError)[0] : pendingActionData ? Object.values(pendingActionData)[0] : undefined;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location); // Pick navigation matches that are net-new or qualify for revalidation
    var boundaryId = pendingError ? Object.keys(pendingError)[0] : undefined;
    var boundaryMatches = getLoaderMatchesUntilBoundary(matches, boundaryId);
    var navigationMatches = boundaryMatches.filter(function(match, index) {
        if (match.route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (match.route.loader == null) return false;
         // Always call the loader on new route instances and pending defer cancellations
        if (isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some(function(id) {
            return id === match.route.id;
        })) return true;
         // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        var currentRouteMatch = state.matches[index];
        var nextRouteMatch = match;
        return shouldRevalidateLoader(match, _extends({
            currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult,
            defaultShouldRevalidate: isRevalidationRequired || // Clicked the same link, resubmitted a GET form
            currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    }); // Pick fetcher.loads that need to be revalidated
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        // Don't revalidate if fetcher won't be present in the subsequent render
        if (!matches.some(function(m) {
            return m.route.id === f.routeId;
        })) return;
        var fetcherMatches = matchRoutes(routesToUse, f.path, basename); // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        var fetcherMatch = getTargetMatch(fetcherMatches, f.path);
        if (cancelledFetcherLoads.includes(key)) {
            revalidatingFetchers.push({
                key,
                routeId: f.routeId,
                path: f.path,
                matches: fetcherMatches,
                match: fetcherMatch,
                controller: new AbortController()
            });
            return;
        } // Revalidating fetchers are decoupled from the route matches since they
        // hit a static href, so they _always_ check shouldRevalidate and the
        // default is strictly if a revalidation is explicitly required (action
        // submissions, useRevalidator, X-Remix-Revalidate).
        var shouldRevalidate = shouldRevalidateLoader(fetcherMatch, _extends({
            currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult,
            // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            defaultShouldRevalidate: isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id; // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    var isMissingData = currentLoaderData[match.route.id] === undefined; // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function loadLazyRouteModule(route, mapRouteProperties, manifest) {
    return _loadLazyRouteModule.apply(this, arguments);
}
function _loadLazyRouteModule() {
    _loadLazyRouteModule = /**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ (0, _asyncToGenerator._)(function(route, mapRouteProperties, manifest) {
        var lazyRoute, routeToUpdate, routeUpdates, lazyRouteProperty, staticRouteValue, isPropertyStaticallyDefined;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.lazy) return [
                        2
                    ];
                    return [
                        4,
                        route.lazy()
                    ];
                case 1:
                    lazyRoute = _state.sent();
                    // call then we can return - first lazy() to finish wins because the return
                    // value of lazy is expected to be static
                    if (!route.lazy) return [
                        2
                    ];
                    routeToUpdate = manifest[route.id];
                    invariant(routeToUpdate, "No route found in manifest"); // Update the route in place.  This should be safe because there's no way
                    // we could yet be sitting on this route as we can't get there without
                    // resolving lazy() first.
                    //
                    // This is different than the HMR "update" use-case where we may actively be
                    // on the route being updated.  The main concern boils down to "does this
                    // mutation affect any ongoing navigations or any current state.matches
                    // values?".  If not, it should be safe to update in place.
                    routeUpdates = {};
                    for(var lazyRouteProperty in lazyRoute){
                        staticRouteValue = routeToUpdate[lazyRouteProperty];
                        isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
                        // on the route updates
                        lazyRouteProperty !== "hasErrorBoundary";
                        warning(!isPropertyStaticallyDefined, 'Route "' + routeToUpdate.id + '" has a static property "' + lazyRouteProperty + '" ' + "defined but its lazy function is also returning a value for this property. " + ('The lazy route property "' + lazyRouteProperty + '" will be ignored.'));
                        if (!isPropertyStaticallyDefined && !immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
                    } // Mutate the route with the provided updates.  Do this first so we pass
                    // the updated version to mapRouteProperties
                    Object.assign(routeToUpdate, routeUpdates); // Mutate the `hasErrorBoundary` property on the route based on the route
                    // updates and remove the `lazy` function so we don't resolve the lazy
                    // route again.
                    Object.assign(routeToUpdate, _extends({}, mapRouteProperties(routeToUpdate), {
                        lazy: undefined
                    }));
                    return [
                        2
                    ];
            }
        });
    });
    return _loadLazyRouteModule.apply(this, arguments);
}
function callLoaderOrAction(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
    return _callLoaderOrAction.apply(this, arguments);
}
function _callLoaderOrAction() {
    _callLoaderOrAction = (0, _asyncToGenerator._)(function(type, request, match, matches, manifest, mapRouteProperties, basename, isStaticRequest, isRouteRequest, requestContext) {
        var resultType, result, onReject, runHandler, handler, values, url, pathname, url1, pathname1, e, status, location, currentUrl, url2, isSameBasename, data, contentType, _result$init, _result$init2;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (isStaticRequest === void 0) isStaticRequest = false;
                    if (isRouteRequest === void 0) isRouteRequest = false;
                    runHandler = function(handler) {
                        // Setup a promise we can race against so that abort signals short circuit
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        return Promise.race([
                            handler({
                                request,
                                params: match.params,
                                context: requestContext
                            }),
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = match.route[type];
                    if (!match.route.lazy) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler),
                            loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                        ])
                    ];
                case 2:
                    values = _state.sent();
                    result = values[0];
                    return [
                        3,
                        7
                    ];
                case 3:
                    // Load lazy route module, then run any returned handler
                    return [
                        4,
                        loadLazyRouteModule(match.route, mapRouteProperties, manifest)
                    ];
                case 4:
                    _state.sent();
                    handler = match.route[type];
                    if (!handler) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 5:
                    // Handler still run even if we got interrupted to maintain consistency
                    // with un-abortable behavior of handler execution on non-lazy or
                    // previously-lazy-loaded routes
                    result = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw getInternalRouterError(405, {
                            method: request.method,
                            pathname,
                            routeId: match.route.id
                        });
                    } else // lazy() route has no loader to run.  Short circuit here so we don't
                    // hit the invariant below that errors on returning undefined.
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: undefined
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    pathname1 = url1.pathname + url1.search;
                    throw getInternalRouterError(404, {
                        pathname: pathname1
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    invariant(result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ('"' + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    resultType = ResultType.error;
                    result = e;
                    return [
                        3,
                        14
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    if (!isResponse(result)) return [
                        3,
                        19
                    ];
                    status = result.status; // Process redirects
                    if (redirectStatusCodes.has(status)) {
                        location = result.headers.get("Location");
                        invariant(location, "Redirects returned/thrown from loaders/actions must have a Location header"); // Support relative routing in internal redirects
                        if (!ABSOLUTE_URL_REGEX.test(location)) location = normalizeTo(new URL(request.url), matches.slice(0, matches.indexOf(match) + 1), basename, true, location);
                        else if (!isStaticRequest) {
                            // Strip off the protocol+origin for same-origin + same-basename absolute
                            // redirects. If this is a static request, we can let it go back to the
                            // browser as-is
                            currentUrl = new URL(request.url);
                            url2 = location.startsWith("//") ? new URL(currentUrl.protocol + location) : new URL(location);
                            isSameBasename = stripBasename(url2.pathname, basename) != null;
                            if (url2.origin === currentUrl.origin && isSameBasename) location = url2.pathname + url2.search + url2.hash;
                        } // Don't process redirects in the router during static requests requests.
                        // Instead, throw the Response and let the server handle it with an HTTP
                        // redirect.  We also update the Location header in place in this flow so
                        // basename and relative routing is taken into account
                        if (isStaticRequest) {
                            result.headers.set("Location", location);
                            throw result;
                        }
                        return [
                            2,
                            {
                                type: ResultType.redirect,
                                status,
                                location,
                                revalidate: result.headers.get("X-Remix-Revalidate") !== null
                            }
                        ];
                    } // For SSR single-route requests, we want to hand Responses back directly
                    // without unwrapping.  We do this with the QueryRouteResponse wrapper
                    // interface so we can know whether it was returned or thrown
                    if (isRouteRequest) // eslint-disable-next-line no-throw-literal
                    throw {
                        type: resultType || ResultType.data,
                        response: result
                    };
                    contentType = result.headers.get("Content-Type"); // Check between word boundaries instead of startsWith() due to the last
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        16
                    ];
                    return [
                        4,
                        result.json()
                    ];
                case 15:
                    data = _state.sent();
                    return [
                        3,
                        18
                    ];
                case 16:
                    return [
                        4,
                        result.text()
                    ];
                case 17:
                    data = _state.sent();
                    _state.label = 18;
                case 18:
                    if (resultType === ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: new ErrorResponse(status, result.statusText, data),
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 19:
                    if (resultType === ResultType.error) return [
                        2,
                        {
                            type: resultType,
                            error: result
                        }
                    ];
                    if (isDeferredData(result)) {
                        ;
                        return [
                            2,
                            {
                                type: ResultType.deferred,
                                deferredData: result,
                                statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                                headers: ((_result$init2 = result.init) == null ? void 0 : _result$init2.headers) && new Headers(result.init.headers)
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result
                        }
                    ];
            }
        });
    } // Utility method for creating the Request instances for loaders/actions during
    );
    return _callLoaderOrAction.apply(this, arguments);
}
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL(stripHashFromPath(location)).toString();
    var init = {
        signal
    };
    if (submission && isMutationMethod(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType, formData = submission.formData; // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        init.body = formEncType === "application/x-www-form-urlencoded" ? convertFormDataToSearchParams(formData) : formData;
    } // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
    return new Request(url, init);
}
function convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, _slicedToArray._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
            searchParams.append(key, value instanceof File ? value.name : value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds) {
    // Fill in loaderData/errors from our loaders
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {}; // Process loader results into state.loaderData/state.errors
    results.forEach(function(result, index) {
        var id = matchesToLoad[index].route.id;
        invariant(!isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if (isErrorResult(result)) {
            // Look upwards from the matched route for the closest ancestor
            // error boundary, defaulting to the root match
            var boundaryMatch = findNearestBoundary(matches, id);
            var error = result.error; // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError) {
                error = Object.values(pendingError)[0];
                pendingError = undefined;
            }
            errors = errors || {}; // Prefer higher error values if lower errors bubble to the same boundary
            if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
             // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined; // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = isRouteErrorResponse(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            if (isDeferredResult(result)) {
                activeDeferreds.set(id, result.deferredData);
                loaderData[id] = result.deferredData.data;
            } else loaderData[id] = result.data;
             // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    }); // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError) {
        errors = pendingError;
        loaderData[Object.keys(pendingError)[0]] = undefined;
    }
    return {
        loaderData,
        errors,
        statusCode: statusCode || 200,
        loaderHeaders
    };
}
function processLoaderData(state, matches, matchesToLoad, results, pendingError, revalidatingFetchers, fetcherResults, activeDeferreds) {
    var _processRouteLoaderData = processRouteLoaderData(matches, matchesToLoad, results, pendingError, activeDeferreds), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors; // Process results from our revalidating fetchers
    for(var index = 0; index < revalidatingFetchers.length; index++){
        var _revalidatingFetchers_index = revalidatingFetchers[index], key = _revalidatingFetchers_index.key, match = _revalidatingFetchers_index.match, controller = _revalidatingFetchers_index.controller;
        invariant(fetcherResults !== undefined && fetcherResults[index] !== undefined, "Did not find corresponding fetcher result");
        var result = fetcherResults[index]; // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) continue;
        else if (isErrorResult(result)) {
            var boundaryMatch = findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = _extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if (isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        invariant(false, "Unhandled fetcher revalidation redirect");
        else if (isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        invariant(false, "Unhandled fetcher deferred data");
        else {
            var doneFetcher = {
                state: "idle",
                data: result.data,
                formMethod: undefined,
                formAction: undefined,
                formEncType: undefined,
                formData: undefined,
                " _hasFetcherDoneAnything ": true
            };
            state.fetchers.set(key, doneFetcher);
        }
    }
    return {
        loaderData,
        errors
    };
}
function mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = _extends({}, newLoaderData);
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (newLoaderData.hasOwnProperty(id)) {
                if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
            } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
            // wasn't removed by HMR
            mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
} // Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function findNearestBoundary(matches, routeId) {
    var eligibleMatches = routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, _toConsumableArray._)(matches);
    return eligibleMatches.reverse().find(function(m) {
        return m.route.hasErrorBoundary === true;
    }) || matches[0];
}
function getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    var route = routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route
            }
        ],
        route
    };
}
function getInternalRouterError(status, _temp4) {
    var _ref = _temp4 === void 0 ? {} : _temp4, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + ' request to "' + pathname + '" but ' + ('did not provide a `loader` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "' + routeId + '" does not match URL "' + pathname + '"';
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "' + pathname + '"';
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + ' request to "' + pathname + '" but ' + ('did not provide an `action` for route "' + routeId + '", ') + "so there is no way to handle the request.";
        else if (method) errorMessage = 'Invalid request method "' + method.toUpperCase() + '"';
    }
    return new ErrorResponse(status || 500, statusText, new Error(errorMessage), true);
} // Find any returned redirect errors, starting from the lowest match
function findRedirect(results) {
    for(var i = results.length - 1; i >= 0; i--){
        var result = results[i];
        if (isRedirectResult(result)) return result;
    }
}
function stripHashFromPath(path) {
    var parsedPath = typeof path === "string" ? parsePath(path) : path;
    return createPath(_extends({}, parsedPath, {
        hash: ""
    }));
}
function isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
     // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function isDeferredResult(result) {
    return result.type === ResultType.deferred;
}
function isErrorResult(result) {
    return result.type === ResultType.error;
}
function isRedirectResult(result) {
    return (result && result.type) === ResultType.redirect;
}
function isDeferredData(value) {
    var deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function isRedirectResponse(result) {
    if (!isResponse(result)) return false;
    var status = result.status;
    var location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function isQueryRouteResponse(obj) {
    return obj && isResponse(obj.response) && (obj.type === ResultType.data || ResultType.error);
}
function isValidMethod(method) {
    return validRequestMethods.has(method.toLowerCase());
}
function isMutationMethod(method) {
    return validMutationMethods.has(method.toLowerCase());
}
function resolveDeferredResults(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
    return _resolveDeferredResults.apply(this, arguments);
}
function _resolveDeferredResults() {
    _resolveDeferredResults = (0, _asyncToGenerator._)(function(currentMatches, matchesToLoad, results, signals, isFetcher, currentLoaderData) {
        var _loop, index;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _loop = function(index) {
                        var result, match, currentMatch, isRevalidatingLoader, signal;
                        return (0, _tsGenerator._)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    result = results[index];
                                    match = matchesToLoad[index]; // If we don't have a match, then we can have a deferred result to do
                                    // anything with.  This is for revalidating fetchers where the route was
                                    // removed during HMR
                                    if (!match) return [
                                        2,
                                        "continue"
                                    ];
                                    currentMatch = currentMatches.find(function(m) {
                                        return m.route.id === match.route.id;
                                    });
                                    isRevalidatingLoader = currentMatch != null && !isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
                                    if (!(isDeferredResult(result) && (isFetcher || isRevalidatingLoader))) return [
                                        3,
                                        2
                                    ];
                                    // Note: we do not have to touch activeDeferreds here since we race them
                                    // against the signal in resolveDeferredData and they'll get aborted
                                    // there if needed
                                    signal = signals[index];
                                    invariant(signal, "Expected an AbortSignal for revalidating fetcher deferred result");
                                    return [
                                        4,
                                        resolveDeferredData(result, signal, isFetcher).then(function(result) {
                                            if (result) results[index] = result || results[index];
                                        })
                                    ];
                                case 1:
                                    _state.sent();
                                    _state.label = 2;
                                case 2:
                                    return [
                                        2
                                    ];
                            }
                        });
                    };
                    index = 0;
                    _state.label = 1;
                case 1:
                    if (!(index < results.length)) return [
                        3,
                        4
                    ];
                    return [
                        5,
                        (0, _tsValues._)(_loop(index))
                    ];
                case 2:
                    _state.sent();
                    _state.label = 3;
                case 3:
                    index++;
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
    return _resolveDeferredResults.apply(this, arguments);
}
function resolveDeferredData(result, signal, unwrap) {
    return _resolveDeferredData.apply(this, arguments);
}
function _resolveDeferredData() {
    _resolveDeferredData = (0, _asyncToGenerator._)(function(result, signal, unwrap) {
        var aborted;
        return (0, _tsGenerator._)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (unwrap === void 0) unwrap = false;
                    return [
                        4,
                        result.deferredData.resolveData(signal)
                    ];
                case 1:
                    aborted = _state.sent();
                    if (aborted) return [
                        2
                    ];
                    if (unwrap) try {
                        return [
                            2,
                            {
                                type: ResultType.data,
                                data: result.deferredData.unwrappedData
                            }
                        ];
                    } catch (e) {
                        // Handle any TrackedPromise._error values encountered while unwrapping
                        return [
                            2,
                            {
                                type: ResultType.error,
                                error: e
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            type: ResultType.data,
                            data: result.deferredData.data
                        }
                    ];
            }
        });
    });
    return _resolveDeferredData.apply(this, arguments);
}
function hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
} // Note: This should match the format exported by useMatches, so if you change
// this please also change that :)  Eventually we'll DRY this up
function createUseMatchesMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname,
        params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function getTargetMatch(matches, location) {
    var search = typeof location === "string" ? parsePath(location).search : location.search;
    if (matches[matches.length - 1].route.index && hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
     // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
} //#endregion

},{"@swc/helpers/_/_async_to_generator":"h4e2J","@swc/helpers/_/_class_call_check":"93i5p","@swc/helpers/_/_create_class":"9mBzM","@swc/helpers/_/_inherits":"fLNpH","@swc/helpers/_/_sliced_to_array":"lAYt5","@swc/helpers/_/_to_array":"cdUIS","@swc/helpers/_/_to_consumable_array":"jg7I9","@swc/helpers/_/_wrap_native_super":"iejbF","@swc/helpers/_/_create_super":"bKhhG","@swc/helpers/_/_ts_generator":"dn4mF","@swc/helpers/_/_ts_values":"jPClC","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"h4e2J":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _async_to_generator;
});
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"cdUIS":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _to_array;
});
var _arrayWithHolesJs = require("./_array_with_holes.js");
var _iterableToArrayJs = require("./_iterable_to_array.js");
var _nonIterableRestJs = require("./_non_iterable_rest.js");
var _unsupportedIterableToArrayJs = require("./_unsupported_iterable_to_array.js");
function _to_array(arr) {
    return (0, _arrayWithHolesJs._)(arr) || (0, _iterableToArrayJs._)(arr) || (0, _unsupportedIterableToArrayJs._)(arr) || (0, _nonIterableRestJs._)();
}

},{"./_array_with_holes.js":"bmtDq","./_iterable_to_array.js":"2gg5C","./_non_iterable_rest.js":"6iEkD","./_unsupported_iterable_to_array.js":"5obbp","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"iejbF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _wrap_native_super;
});
var _constructJs = require("./_construct.js");
var _getPrototypeOfJs = require("./_get_prototype_of.js");
var _isNativeFunctionJs = require("./_is_native_function.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _wrap_native_super(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    _wrap_native_super = function(Class) {
        if (Class === null || !(0, _isNativeFunctionJs._)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, _constructJs._)(Class, arguments, (0, _getPrototypeOfJs._)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, _setPrototypeOfJs._)(Wrapper, Class);
    };
    return _wrap_native_super(Class);
}

},{"./_construct.js":"H8Kwc","./_get_prototype_of.js":"5LWub","./_is_native_function.js":"cUvsY","./_set_prototype_of.js":"lHY0I","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"H8Kwc":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _construct;
});
var _isNativeReflectConstructJs = require("./_is_native_reflect_construct.js");
var _setPrototypeOfJs = require("./_set_prototype_of.js");
function _construct(Parent, args, Class) {
    if ((0, _isNativeReflectConstructJs._)()) _construct = Reflect.construct;
    else _construct = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, _setPrototypeOfJs._)(instance, Class.prototype);
        return instance;
    };
    return _construct.apply(null, arguments);
}

},{"./_is_native_reflect_construct.js":"kOS19","./_set_prototype_of.js":"lHY0I","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"cUvsY":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return _is_native_function;
});
function _is_native_function(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"dn4mF":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__generator;
});
var _tslib = require("tslib");

},{"tslib":"fPQ7a","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"fPQ7a":[function(require,module,exports) {
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "__extends", function() {
    return __extends;
});
parcelHelpers.export(exports, "__assign", function() {
    return __assign;
});
parcelHelpers.export(exports, "__rest", function() {
    return __rest;
});
parcelHelpers.export(exports, "__decorate", function() {
    return __decorate;
});
parcelHelpers.export(exports, "__param", function() {
    return __param;
});
parcelHelpers.export(exports, "__esDecorate", function() {
    return __esDecorate;
});
parcelHelpers.export(exports, "__runInitializers", function() {
    return __runInitializers;
});
parcelHelpers.export(exports, "__propKey", function() {
    return __propKey;
});
parcelHelpers.export(exports, "__setFunctionName", function() {
    return __setFunctionName;
});
parcelHelpers.export(exports, "__metadata", function() {
    return __metadata;
});
parcelHelpers.export(exports, "__awaiter", function() {
    return __awaiter;
});
parcelHelpers.export(exports, "__generator", function() {
    return __generator;
});
parcelHelpers.export(exports, "__createBinding", function() {
    return __createBinding;
});
parcelHelpers.export(exports, "__exportStar", function() {
    return __exportStar;
});
parcelHelpers.export(exports, "__values", function() {
    return __values;
});
parcelHelpers.export(exports, "__read", function() {
    return __read;
});
/** @deprecated */ parcelHelpers.export(exports, "__spread", function() {
    return __spread;
});
/** @deprecated */ parcelHelpers.export(exports, "__spreadArrays", function() {
    return __spreadArrays;
});
parcelHelpers.export(exports, "__spreadArray", function() {
    return __spreadArray;
});
parcelHelpers.export(exports, "__await", function() {
    return __await;
});
parcelHelpers.export(exports, "__asyncGenerator", function() {
    return __asyncGenerator;
});
parcelHelpers.export(exports, "__asyncDelegator", function() {
    return __asyncDelegator;
});
parcelHelpers.export(exports, "__asyncValues", function() {
    return __asyncValues;
});
parcelHelpers.export(exports, "__makeTemplateObject", function() {
    return __makeTemplateObject;
});
parcelHelpers.export(exports, "__importStar", function() {
    return __importStar;
});
parcelHelpers.export(exports, "__importDefault", function() {
    return __importDefault;
});
parcelHelpers.export(exports, "__classPrivateFieldGet", function() {
    return __classPrivateFieldGet;
});
parcelHelpers.export(exports, "__classPrivateFieldSet", function() {
    return __classPrivateFieldSet;
});
parcelHelpers.export(exports, "__classPrivateFieldIn", function() {
    return __classPrivateFieldIn;
});
parcelHelpers.export(exports, "__addDisposableResource", function() {
    return __addDisposableResource;
});
parcelHelpers.export(exports, "__disposeResources", function() {
    return __disposeResources;
});
parcelHelpers.export(exports, "__rewriteRelativeImportExtension", function() {
    return __rewriteRelativeImportExtension;
});
var extendStatics = function extendStatics1(d, b) {
    extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return extendStatics(d, b);
};
function __extends(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var __assign = function __assign1() {
    __assign = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function __decorate(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function __param(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function __propKey(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function __setFunctionName(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function __metadata(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var __createBinding = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function __exportStar(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function __spread() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat(__read(arguments[i]));
    return ar;
}
function __spreadArrays() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function __await(v) {
    return this instanceof __await ? (this.v = v, this) : new __await(v);
}
function __asyncGenerator(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function __asyncDelegator(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: __await(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function __asyncValues(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var __setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var ownKeys = function ownKeys1(o) {
    ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return ownKeys(o);
};
function __importStar(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") __createBinding(result, mod, k[i]);
    }
    __setModuleDefault(result, mod);
    return result;
}
function __importDefault(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function __classPrivateFieldGet(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function __classPrivateFieldSet(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function __classPrivateFieldIn(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function __addDisposableResource(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function __disposeResources(env) {
    function fail(e) {
        env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function __rewriteRelativeImportExtension(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
exports.default = {
    __extends,
    __assign,
    __rest,
    __decorate,
    __param,
    __esDecorate,
    __runInitializers,
    __propKey,
    __setFunctionName,
    __metadata,
    __awaiter,
    __generator,
    __createBinding,
    __exportStar,
    __values,
    __read,
    __spread,
    __spreadArrays,
    __spreadArray,
    __await,
    __asyncGenerator,
    __asyncDelegator,
    __asyncValues,
    __makeTemplateObject,
    __importStar,
    __importDefault,
    __classPrivateFieldGet,
    __classPrivateFieldSet,
    __classPrivateFieldIn,
    __addDisposableResource,
    __disposeResources,
    __rewriteRelativeImportExtension
};

},{"@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}],"jPClC":[function(require,module,exports) {
var parcelHelpers = require("@parcel/transformer-js/src/esmodule-helpers.js");
parcelHelpers.defineInteropFlag(exports);
parcelHelpers.export(exports, "_", function() {
    return 0, _tslib.__values;
});
var _tslib = require("tslib");

},{"tslib":"fPQ7a","@parcel/transformer-js/src/esmodule-helpers.js":"3ZRi9"}]},[], null, "parcelRequiree0b7")

//# sourceMappingURL=index.f5cc3b37.js.map
